import React, {useState, useEffect, useRef, createContext, useContext, forwardRef, useCallback, useMemo} from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import {dynamicForm} from '../configuration/fieldSetting';
import { createState } from 'state-pool';
// import { last } from './state';
import ModalComponent from './ModalComponent';
// import { data } from '../configuration/fieldSetting';
import { FormControl, InputLabel, Box, Typography, Grid, InputAdornment, Autocomplete  } from '@mui/material';
import { TextField, Checkbox, FormControlLabel, Select, MenuItem, Button, Paper, Radio, RadioGroup, FormGroup, Snackbar, SnackbarContent, Alert, Stack, CircularProgress } from '@mui/material'; 
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';

import Textarea from '@mui/joy/Textarea';
import OtpInput from 'react-otp-input';
// date imports
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import dayjs from "dayjs";

// Icons
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import ErrorIcon from '@mui/icons-material/Error';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import FilePresentIcon from '@mui/icons-material/FilePresent';
import UploadOutlinedIcon from '@mui/icons-material/UploadOutlined';
import BorderColorOutlinedIcon from '@mui/icons-material/BorderColorOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';

// import { TableVirtuoso } from 'react-virtuoso';

// Internal imports
import {getAccessToken, fetchAccessToken } from '../component/getToken';
import { FormDetail } from "../util/apiUrl";
import {Form, saveField, CountryList, StateList, CityList, DocumentSave, annexture, formPreview, enterAadhaar, enterOtp, debGenerateToken, debIdDetails, ValidateDebId, ValidateDebIdDetails, subjectList as subjectListUrl,getMultiSequenceData} from "../util/apiUrl";
import CallAPI from '../util/apiAction';
import attachment from '../assets/images/attachment.png';
import Preview from "./preview";
import ScreenView from "../util/screenView";
// import '../assets/styles/global.css';
import '../assets/styles/form.css';
import pdfIcon from "../assets/images/pdfIcon.png"
import docIcon from "../assets/images/docIcon.png"
import errorIcon from "../assets/images/error.png"
import RefreshIcon from '@mui/icons-material/Refresh';
import JobSection from "./jobSelection";
import Loader from "./linearProgress";
import { renderToFile } from "@react-pdf/renderer";
import appSetting from "../configuration/appsettings";


const errors = []; // Define or receive errors object
export const newActiveState = createState("");
export const last = createState('');
export const globalInstersted = createState('');
export const globalCurrentSection = createState('');

export default function FormSection(props){
    let apiRootUrl = `${appSetting.ApiServerURL[appSetting.environment]}`;

    // const id = props.sectionId
    const location = useLocation();
    const Navigate = useNavigate();
    
    // const { CourseId, CategoryId, lastActiveSection, enquiryId, name } = location.state;

    const univId = sessionStorage.getItem('univID')
    const dateOfBirth = sessionStorage.getItem('dateOfBirth')
    const mobileNo = sessionStorage.getItem('mobileNo')

    // useState
    const [data, setData] = useState(null);
    const [admissionFormId, setAdmissionFormId] = useState(null);
    const [showPreview, setShowPreview] = useState(props.showPreview);
    // const [preview, setPreview] = useState(newContext)
    const [id, setId] = useState(props.activeSection);
    const [previewToken, setPreviewToken] = useState(props.previewToken);
    const [selectedDate, setSelectedDate] = useState(null);
    // const {activeId, setActiveId} = useContext(newContext);
    const [activeId, setActiveId] = newActiveState.useState();
    // const { setCurrentSection } = useContext(newContext);
    const [lastSaveSection, setLastSaveSection] = last.useState();
    const [currentSection, setCurrentSection] = globalCurrentSection.useState();
    const year = dayjs().subtract(15, 'year');
    // const [inputValue, setInputValue] = useState({});
    const inputValue = useRef({});
    const [dependencyTick, setDependencyTick] = useState(0)
    const lastChangedFieldRef = useRef(null)
    const [subjectValue, setSubjectValue] = useState([]);
    // const [checkedItems, setCheckedItems] = useState({});
    const checkedItems = useRef({});
    const [latestField, setLatestField] = useState({});
    const [checked, setChecked] = useState(false);
    const [textInputValue, setTextInputValue] = useState('');
    const [inputTrigger, setInputTrigger] = useState(0);
    const [textError, setTextError] = useState({})

    const [listOfFieldsArray, setListOfFieldsArray] = useState([]);
    const [listOfFields, setListOfFields] = useState({})
    const [saveApiResponse, setSaveApiResponse] = useState(null);
    const [loading, setLoading] = useState(false);
    const [buttonLoading, setButtonLoading] = useState({});
    const [successMessage, setSuccessMessage] = useState(null);
    const [debToken, setDebToken] = useState(null)
    const [isDebVerified, setIsDebVerified] = useState(false)
    const [debData, setDebData] = useState({});
    // const [debId, setDebId] = useState(null)
    const [isRequired, setIsRequired] = useState({});
    const [externallyRequiredFields, setExternallyRequiredFields] = useState({});

    // DEB ID verification only applies while the field is actually mandatory.
    // A dependancyType '4' rule can turn a mandatory DEB ID optional at runtime — when that
    // happens the Verify button is withdrawn and the verification gate on Next is skipped.
    const isDebOptionalByDependency = (field) =>
        field?.dbColumnName?.toLowerCase() === 'debid' &&
        field?.isRequired === 1 &&
        isRequired[field?.fieldName] === false;

    const findDebIdField = () => {
        if(data === null || data === undefined){
            return undefined;
        }

        for(const section of data.sections){
            const found = section.fieldsList?.find(f => f.dbColumnName?.toLowerCase() === 'debid');

            if(found !== undefined){
                return found;
            }
        }

        return undefined;
    };

    // DEB ID and ABC ID are only enterable while a Verify button exists to validate
    // them. Both ways the button can be withdrawn lock the fields:
    //   debEnable === 0        -> the university does not use DEB at all
    //   optional by dependency -> verification no longer applies
    // ABC ID has no button of its own - it is populated by the DEB verification - so it
    // follows the DEB field's state. An explicit dependancyType 5/6 rule outranks both,
    // so a dependency that enables the field is honoured rather than overridden.
    const isDebFieldLocked = (field) => {
        const column = field?.dbColumnName?.toLowerCase();

        if(column !== 'debid' && column !== 'abc_id'){
            return false;
        }

        if(disabledFields[field?.fieldName] === false){
            return false;
        }

        if(debEnable === null || debEnable === 0){
            return debEnable === 0;
        }

        return isDebOptionalByDependency(findDebIdField());
    };

    const [maxSubjectSequence, setMaxSubjectSequence] = useState(null)
    const [editSection, setEditSection] = useState(null)
    // const [jobDataLength, setJobDataLength] = useState(null)
    const [alignFieldList, setAlignFieldList] = useState([])
    const inputOnChange = useRef([])
    const pickedData = useRef({})
    const [disabledFields, setDisabledFields] = useState({})
    const [fieldVisibility, setFieldVisibility] = useState({})
    const [subjectList, setOptionalSubjectList] = useState([])

    // Table usestate
    const [tableInputValue, setTableInputValue] = useState([]);
    const [tableRowSequence, setTableRowSequence] = useState(null);
    // const [tableValue, setTableValue] = useState({});
    const tableValue = useRef({});
    const [row, setRow] = useState(0)
    const [deleteFlag, setDeleteFlag] = useState(0);
    const [workMandatoryFlag, setWorkMandatoryFlag] = useState(0);
    const [tableRow, setTableRow] = useState(1);
    const [editFlag, setEditFlag] = useState(0);
    const [deleteSequenceFlag, setDeleteSequenceFlag] = useState(0);
    const requiredKeys = useRef({})
    const [mandatoryMsg, setMandatoryMsg] = useState(null);

    // University Flag usestate
    const [kycFlag, setKycFlag] = useState(0);
    const [fullNameFlag, setFullNameFlag] = useState(null);
    const [examMandatoryFlag, setExamMandatory] = useState(0);
    const [debEnable, setDebEnable] = useState(null);

    // Annexture usestate
    const [annextureFlag, setAnnextureFlag] = useState(false)       // set annexture view flag to false
    const [annextureData, setAnnextureData] = useState(null); 
    const [annextureType, setAnnextureType] = useState(null);
    const [Insterested, setInterested] = globalInstersted.useState();
    const [link, setLink] = useState(null);

    // Modal usestate
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [titleMsg, setTitleMsg] = useState(null);
    const [content, setContent] = useState(null);
    const [modalResponse, setModalResponse] = useState(false);
    const [modalContentIdentity, setModalContentIdentity] = useState(null)
    const [modalResponseCallback, setModalResponseCallback] = useState(null);

    // document usestate
    const [file, setFile] = useState({});
    const [fileDataURL, setFileDataURL] = useState({});
    const [fileName, setFileName] = useState(null);
    const [extension, setExtension] = useState(null);
    const [validationError, setValidationError] = useState(null);
    const [blob, setblob] = useState(null);
    const [base64String, setBase64String] = useState(null);

    // dropdown usestate
    const [apiDropdownData, setApiDropdownData] = useState({});
    const [modifiedApiDropdownData, setModifiedApiDropdownData] = useState({});
    const [countryList, setCountryList] = useState(null);
    const [stateList, setStateList] = useState(null);
    const [cityList, setCityList] = useState(null);
    const [permanentCountryList, setPermanentCountryList] = useState(null);
    const [permanentStateList, setPermanentStateList] = useState(null);
    const [permanentCityList, setPermanentCityList] = useState(null);
    const [selStateList, setSelStateList] = useState(null)
    const [selPermanentStateList, setSelPermanentStateList] = useState(null)
    const [selCityList, setSelCityList] = useState(null)
    const [selPermanentCityList, setSelPermanentCityList] = useState(null)

    // Aadhaar usestate
    const [otp, setOtp] = useState('')
    const [isAadhaarVerified, setIsAadhaarVerified] = useState(false)
    const [aadhaarData, setAadhaarData] = useState(null)

    const [listOfSections, setListOfSections] = useState({})
    const inputRef = useRef(null);

    const Registerdob = sessionStorage.getItem("dateOfBirth");
    var RegisterMobile = sessionStorage.getItem("mobileNo");
    var RegisterName = sessionStorage.getItem("name");
    var RegisterEmail = sessionStorage.getItem("email");
    var course = sessionStorage.getItem('CourseId')
    var category = sessionStorage.getItem('CategoryId')
    var lastActive = sessionStorage.getItem('lastActiveSection')
    var enquiry = sessionStorage.getItem('enquiryId')
    const loggedInUser = sessionStorage.getItem("loggedInUser");
    var adminUserId = sessionStorage.getItem('userId') ? sessionStorage.getItem('userId') : 0;
    var action = sessionStorage.getItem('Action') ? sessionStorage.getItem('Action') : '';

    const [lastActiveSection, setLastActiveSec] = useState(null)
    const [CourseId, setCourseId] = useState(null)
    const [CategoryId, setCategoryId] = useState(null)
    // const [userName, setUserName] = useState(null)
    const [name, setName] = useState(null)
    const [enquiryLocation, setEnquiryLocation] = useState(null)
    const [enquiryId, setEnquiryId] = useState(0)

    let setDebId = 0
    let jobDataLength = 0

    // Set Intrested in and working flag
    useEffect(() => {
        if(data !== null && (loggedInUser !== 'admin' || (loggedInUser === 'admin' && sessionStorage.getItem('actionType') === 'Edit'))){
            // Set Interested in flag
            let sec = data.sections.find(section => section.sectionId === 7 && section.isActive === 1)
        
            if(sec){
                let fields = sec.fieldsList
                if(fields?.length !== 0){
                    let intField = fields.find(f => f.fieldId === 52)
                    if(intField){
                        setInterested(intField.value)
                    }
                }
            }
            
            // commented because it should be managed through workMandatoryFlag
            // set workMandatory Flag
            // let personalSec = data.sections.find(section => section.sectionId === 2)
            // let personalField = personalSec.fieldsList
            // let workingStatus = personalField.find(field=> field.dbColumnName === 'WorkingStatus')
            // if(workingStatus !== undefined){
            //     if(workingStatus.value === 'Employed'){
            //         setWorkMandatoryFlag(1)
            //     }
            // }
        }
    }, [data])

    useEffect(() => {
        setLastActiveSec(parseInt(lastActive))
        setCourseId(parseInt(course))
        if(enquiry !== null){
            setEnquiryId(parseInt(enquiry))
        }else{
            setEnquiryId(0)
        }
        
        if(category !== null){
            setCategoryId(parseInt(category))
        }
        setName(RegisterName)
    },[sessionStorage?.length > 0]) 

    useEffect(() => {
        if(location.state !== null){
            const { lastActiveSection, CategoryId, CourseId, enquiryId, name } = location.state;
            setLastActiveSec(lastActiveSection)
            setCourseId(CourseId)
            setEnquiryId(enquiryId)
            // setEnquiryLocation(enquiryId)
            setCategoryId(CategoryId)
            // setUserName(userName)
            setName(name)
        }else{
            let CatId = sessionStorage.getItem("CategoryId");
            setCategoryId(parseInt(CatId))
        }
    },[location.state])

    const fetchFormData = async (isMultipleFields, sectionId) => {
        try {
            const { data,loading,error } = await CallAPI(Form, 'POST', { 
                 "unvId": univId,
                 "categoryId": CategoryId,
                 "courseId": CourseId,
                 "isMultiFieldSection": isMultipleFields,
                 "sectionId": sectionId,
                 "isPreview": 0,
                 "enquiryId": enquiryId,
                 "mobileNo": mobileNo,
                 "dob": dateOfBirth,
                 "name": name,
                 "AdminUserId": adminUserId,
                 "Action": action
             }
           ); 
             setData(data);
           } catch (error) {
             console.error('Error fetching data:', error);
           }
    }

    useEffect(() => {
        if(props.activeSection !== null && !isNaN(props.activeSection) && props.activeSection !== 0){
            if(data && id && props.activeSection){
                let sec1 = data.sections.find(section => section.sectionId === id)
                let sec2 = data.sections.find(section => section.sectionId === props.activeSection)

                // Refetch when landing on a multi-field section (either coming from a
                // non-multi section, or switching between multi sections — since the Form
                // API is section-scoped and current `data` holds only the previous section's
                // fieldsList).
                if(sec1 && sec2){
                    if(sec2.isMultipleFields === 1 && sec1.sectionId !== sec2.sectionId){
                        fetchFormData(sec2.isMultipleFields, sec2.sectionId)
                    }
                }else if(sec1){
                    sessionStorage.setItem('isMultiFieldSection', sec1.isMultipleFields)
                }
            }
            setId(parseInt(props.activeSection))
        }
    }, [props.activeSection]);
    

    // API to fetch formData
    useEffect(() => {
        // re-check
        const fetchData = async () => {
            let isMultiFieldSection = 0
            if(props.activeSection && data){
                let sec = data.sections.find(section => section.sectionId === props.activeSection)
                isMultiFieldSection = sec.isMultipleFields
            }else if(props.activeSection === 5 || props.activeSection === 6){
                isMultiFieldSection = 1
                sessionStorage.setItem('isMultiFieldSection', isMultiFieldSection)
            }else{
                isMultiFieldSection = sessionStorage.getItem('isMultiFieldSection')
            }
            // let isMultiFieldSection = sessionStorage.getItem('isMultiFieldSection')

          try {
           const { data,loading,error } = await CallAPI(Form, 'POST', { 
                "unvId": univId,
                "categoryId": CategoryId,
                "courseId": CourseId,
                // "isMultiFieldSection": ((id !== null && id === 5) || (id !== null && id === 6)) ? 1 : 0,
                "isMultiFieldSection": isMultiFieldSection ? parseInt(isMultiFieldSection) : 0,
                "sectionId": props.activeSection ? props.activeSection : (id == null || Number.isNaN(id)) ? 0 : id,
                // "sectionId": (id == null || Number.isNaN(id)) ? 0 : id,
                "isPreview": 0,
                "enquiryId": enquiryId,
                "mobileNo": mobileNo,
                "dob": dateOfBirth,
                "name": name,
                "AdminUserId": adminUserId,
                "Action": action
            }
          ); 
            setData(data);
            setAdmissionFormId(data.admissionFormId)
            if(data.lastActiveSection === 0){
                let first = data.sections.find(section => section.sequence === 1 && section.parentSectionId === 0  && section.isActive === 1)
                setLastSaveSection(first.sectionId)
            }else{
                setLastSaveSection(data.lastActiveSection)
            }
            setTimeout(() => {
                setLoading(false); // Set loading state to false after a short delay
              }, 1000);
          } catch (error) {
            console.error('Error fetching data:', error);
            setTimeout(() => {
                setLoading(false); // Set loading state to false after a short delay
              }, 500);
          }
        };
        if(loggedInUser === 'student' || (loggedInUser === 'admin' && sessionStorage.getItem('actionType') === 'Edit')){
            setLoading(true);

            if(CategoryId !== null && CourseId !== null && name !== null){
                fetchData();
            }
        }
        
    }, [lastActiveSection, CourseId, CategoryId, enquiryId, name, loggedInUser]);

    useEffect(() => {
        const fetchOptionalSubjects = async () => {
            try {
                const { data,loading,error } = await CallAPI(subjectListUrl, 'GET', {
                    "unvId": univId,
                });
                setOptionalSubjectList(data);
            } catch (error) {
                console.error('Error fetching optional subjects:', error);
            }
        }

        fetchOptionalSubjects();
    },[])

    // API for preview
    useEffect(() => {
        const fetchPreviewData = async () => {
            try {
             const { data,loading,error } = await CallAPI(formPreview, 'POST', { 
                    "unvId": univId,
                    "categoryId": String(CategoryId),
                    "previewToken": props.previewToken   
                }
            );
            if(data?.length !== 0){ 
              setData(data);
              let firstSection = data?.sections.find(section => section.sequence === 1 && section.parentSectionId === 0 && section.isActive === 1)
              setId(firstSection?.sectionId)
            }
            } catch (error) {
              console.error('Error fetching data:', error);
            }
        };

        if((loggedInUser === 'admin' && sessionStorage.getItem('actionType') !== 'Edit') && CategoryId !== null && CategoryId !== NaN && props.previewToken !== ''){
            fetchPreviewData();
        }
    }, [CategoryId, loggedInUser, props.previewToken])

    const annextureDataRef = useRef(false);
    // API for get Annexture
    useEffect(() => {
        const fetchData = async () => {
          try {
           const { data, annexureType, loading, error } = await CallAPI(annexture, 'POST', { 
                "enquiryId": enquiry,
            }
          ); 
            setAnnextureData(data);
            setAnnextureType(annexureType)
            annextureDataRef.current = true;
          } catch (error) {
            console.error('Error fetching data:', error);
          }
        };
    
        if((loggedInUser !== 'admin' || (loggedInUser === 'admin' && sessionStorage.getItem('actionType') === 'Edit'))){
            if(data){
                let sec = data.sections.find(section => section.sectionId === 7)
                // if((sec && sec.isActive === 1 && !annextureDataRef.current) || id === 7){
                if((sec && sec.isActive === 1 ) && (id && id === 7)){
                    fetchData();
                }
            }
        }
        
    }, [data]);

    // API for debId token
    useEffect(() => {
        const fetchData = async () => {
            try {
                const { data,loading,error } = await CallAPI(debGenerateToken, 'POST', { 
                      "username" : "DigivUnv", 
                      "password" : "63a326d8-3943-4f27-b2f1-83770255282c"
                 }
               ); 
               setDebToken(data.token)
                 
               } catch (error) {
                 console.error('Error fetching data:', error);
                 
            }
        };

        if(loggedInUser === 'student' || (loggedInUser === 'admin' && sessionStorage.getItem('actionType') === 'Edit')){
            fetchData();
        }
    }, [])

    // on change of date
    const handleDateChange = (date, name) => {
        // pickedData.current[name] = date;
        pickedData.current = {
            ...pickedData.current,
            [name]: date
        }
    };

    const handleDateClose = async (name, target, isMultipleFields) => {
        var t = new Date(pickedData?.current?.[name] !== undefined && pickedData?.current?.[name] !== null ? pickedData?.current?.[name] : '');
        var formattedDate = dayjs(t).format("YYYY-MM-DD");
        let isError = false;
        let errorMessage = '';

         // Add date comparison validation for DOJ and DOL fields
        if (formattedDate && (target?.dbColumnName === 'DOJ' || target?.dbColumnName === 'DOL')) {
            const currentDate = new Date(formattedDate);
            
            if (target?.dbColumnName === 'DOL') {
                // When DOL is being entered, check against DOJ
                const dojFieldName = Object.keys(inputValue.current).find(key => {
                    // Find the DOJ field in the same section
                    const section = data?.sections?.find(sec => sec.sectionId === target.sectionId);
                    const dojField = section?.fieldsList?.find(field => field.dbColumnName === 'DOJ');
                    // console.log('dojField', dojField)
                    return dojField?.fieldName === key;
                });
                
                if (dojFieldName && inputValue.current[dojFieldName]) {
                    const dojDate = new Date(inputValue.current[dojFieldName]);
                    
                    if (currentDate <= dojDate) {
                        isError = true;
                        errorMessage = 'Date of leaving cannot be before date of joining';
                    }
                }
            } else if (target?.dbColumnName === 'DOJ') {
                // When DOJ is being entered, check against existing DOL
                const dolFieldName = Object.keys(inputValue.current).find(key => {
                    // Find the DOL field in the same section
                    const section = data?.sections?.find(sec => sec.sectionId === target.sectionId);
                    const dolField = section?.fieldsList?.find(field => field.dbColumnName === 'DOL');
                    return dolField?.fieldName === key;
                });
                
                if (dolFieldName && inputValue.current[dolFieldName]) {
                    const dolDate = new Date(inputValue.current[dolFieldName]);
                    if (dolDate <= currentDate) {
                        // Update the DOL field error
                        await updateTextError(dolFieldName, { 
                            isError: true, 
                            errorMessage: 'Date of leaving cannot be before date of joining' 
                        });
                        // Clear the DOL value
                        inputValue.current = {
                            ...inputValue.current,
                            [dolFieldName]: ''
                        };
                    }
                }
            }
        }
            
        setTextError((prevTextError) => ({
            ...prevTextError,
            [name]: { isError, errorMessage },
        }));

        if (!isError && formattedDate !== 'Invalid Date') {
            inputValue.current = {
                ...inputValue.current,
                [name]: formattedDate
            };

            tableValue.current = {
                ...tableValue.current,
                [name]: formattedDate
            }

            const isCreated = createObject(target, formattedDate)
        } else {
            // Clear the invalid date
            pickedData.current = {
                ...pickedData.current,
                [name]: null
            };

        }

    }

    const [imageUrl, setImage] = useState("");

    // to set image
    const handleImageChange = (name, sectionId, fieldId, rest, event) => {
        // if(isAadhaarVerified === false){
        const selectedFile = event.target.files[0];
        let fileName = selectedFile.name
        let fileExtension = fileName.split('.').pop().toLowerCase()
        let type = selectedFile.type;
        let size = selectedFile.size;
        let validate = rest?.fieldValidations
        let validTypes = '';
        let validMaxSize = 0;
        let validMinSize = 0;
        let validMaxSizeUnit = '';
        let validMinSizeUnit = '';

        let isError = false;
        let errorMessage = '';

        if(selectedFile.type === 'image/png'){
            type = '.png'
        }else if(selectedFile.type === 'image/jpg'){
            type = '.jpg'
        }else if(selectedFile.type === 'image/jpeg'){
            type = '.jpeg'
        }

        validate.forEach(element => {
            switch (element.property) {
                case 'FileType':
                    validTypes = element.value.split(/,\s*|\./).filter(Boolean);
                    break;
                case 'MaxSize':
                    validMaxSize = parseFloat(element.value);
                    break;
                case 'MinSize':
                    validMinSize = parseFloat(element.value-1);
                    break;
                case 'MaxSizeUnit':
                    validMaxSizeUnit = element.value;
                    break;
                case 'MinSizeUnit':
                    validMinSizeUnit = element.value;
                    break;
                default:
                    break;
            }
        });

        const sizeUnits = {
            KB: 1024,
            MB: 1024 * 1024,
            GB: 1024*1024*1024
        };

        const minSize = validMinSize * (sizeUnits[validMinSizeUnit] || 1);      // Minimun Valid size 
        const maxSize = validMaxSize * (sizeUnits[validMaxSizeUnit] || 1);      // Maximum Valid size 



        // if(rest?.validationType === 'Image'){
            if((validTypes.includes(fileExtension)) && size >= minSize && size <= maxSize){
                setValidationError((prevState) => ({
                    ...prevState,
                    [rest?.fieldName] : 'Valid'
                }))

                // setFile(URL.createObjectURL(event.target.files[0]));
                setFile((prevState) => ({
                    ...prevState,
                    [rest?.fieldName]: URL.createObjectURL(event.target.files[0])
                }))
                const reader = new FileReader();
                    reader.onloadend = () => {
                    var baseString = reader.result.replace("data:", "").replace(/^.+,/, "");
                    setBase64String(baseString)

                    // setInputValue((prevInputValue) => ({
                    //     ...prevInputValue,
                    //     [name]: baseString
                    // }));

                    inputValue.current = {
                        ...inputValue.current,
                        [name]: baseString
                    };

                    const isCreated = createObject(rest, baseString)
            
                };
                reader.readAsDataURL(selectedFile);
                isError = false;
                errorMessage = '';
            }else{
                setValidationError((prevState) => ({
                    ...prevState,
                    [rest?.fieldName] : 'Invalid'
                }))

                if(!validTypes.includes(fileExtension)){
                    isError = true;
                    errorMessage = `Invalid filetype: ${fileExtension}`;
                }else if(size > maxSize){
                    isError = true;
                    errorMessage = `Maximum size is ${validMaxSize} ${validMaxSizeUnit}`;
                }else if(size < minSize){
                    isError = true;
                    errorMessage = `Minimum size is ${validMinSize+1} ${validMinSizeUnit}`;
                }else{
                    isError = true;
                    errorMessage = `Format: ${validTypes} (min size: ${validMinSize+1} ${validMinSizeUnit}, max size: ${validMaxSize} ${validMaxSizeUnit})`;
                }

                
            }

        setTextError((prevTextError) => ({
            ...prevTextError,
            [name]: { isError, errorMessage },
        }));
 
    };
    
    const handleFile = (fieldName, sectionId, fieldId, validationType, sequenceId, rest, event) => {
        const selectedFile = event.target.files[0];
        let fileName = selectedFile.name
        let fileExtension = fileName.split('.').pop()
        let fileSize = selectedFile.size
        let validate = rest?.fieldValidations
        let validTypes = '';
        let validMaxSize = 0;
        let validMinSize = 0;
        let validMaxSizeUnit = '';
        let validMinSizeUnit = '';

        let isError = false;
        let errorMessage = '';

        // Validation properties
        validate.forEach(element => {
            switch (element.property) {
                case 'FileType':
                    validTypes = element.value.split(/,\s*|\./).filter(Boolean);
                    break;
                case 'MaxSize':
                    validMaxSize = parseFloat(element.value);
                    break;
                case 'MinSize':
                    validMinSize = parseFloat(element.value-1);
                    break;
                case 'MaxSizeUnit':
                    validMaxSizeUnit = element.value;
                    break;
                case 'MinSizeUnit':
                    validMinSizeUnit = element.value;
                    break;
                default:
                    break;
            }
        });

        const sizeUnits = {
            KB: 1000,
            MB: 1000000,
            GB: 1000000000
        };

        const minSize = validMinSize * (sizeUnits[validMinSizeUnit] || 1);      // Minimun Valid size 
        const maxSize = validMaxSize * (sizeUnits[validMaxSizeUnit] || 1);      // Maximum Valid size 

        let blobUrl = URL.createObjectURL(selectedFile)
        if((validTypes.includes(fileExtension)) && fileSize >= minSize && fileSize <= maxSize){

            setValidationError((prevState) => ({
                ...prevState,
                [fieldName] : 'Valid'
            }))

            inputValue.current = {
                ...inputValue.current,
                [fieldName]: selectedFile
            };
            // Clear error for this field after successful upload
            setTextError(prevTextError => ({
                ...prevTextError,
                [fieldName]: { isError: false, errorMessage: "" }
            }));

            const reader = new FileReader();
            reader.onload = async(e) => {
                setFile((prevState) => ({
                    ...prevState,
                    [fieldName]: selectedFile
                }))
                setblob((prevState) => ({
                    ...prevState,
                    [fieldName]: blobUrl
                }))
                setFileDataURL((prevState) => ({
                    ...prevState,
                    [fieldName]: e.target.result
                }));
                setFileName((prevState) => ({
                    ...prevState,
                    [fieldName]: selectedFile.name
                }))
                setExtension((prevState) => ({
                    ...prevState,
                    [fieldName]: selectedFile.type
                }))

                
            }
            reader.readAsDataURL(selectedFile);

            // setInputValue((prevInputValue) => ({
            //     ...prevInputValue,
            //     [fieldName]: selectedFile
            // }));
            inputValue.current = {
                ...inputValue.current,
                [fieldName]: selectedFile
            };
            
            if(inputValue.current[fieldName] !== null){
                const formData = new FormData();
                formData.append("formFile", selectedFile);

                // API to save document
                const fetchData = async() => {
                    const accessToken = await getAccessToken();
                    setButtonLoading((prevButton) => ({
                        [fieldName] : true,
                        'isDelete': false
                    }))
                    try {
                        const formData = new FormData();
                        formData.append("UnvId", parseInt(univId));
                        formData.append("EnquiryId", enquiryId);
                        formData.append("AdmissionFormId", admissionFormId);
                        formData.append("SectionId", sectionId);
                        formData.append("FieldId", fieldId);
                        formData.append("SequenceId", rest?.sequence);
                        formData.append("DocumentId", rest?.fieldDataSource);
                        formData.append("DocumentformFile", selectedFile);
                        formData.append("IsDelete", false);

                        const response = await fetch(DocumentSave, {
                            method: 'POST',
                            body: formData,
                            headers : {
                                'Authorization': `Bearer ${accessToken}`,
                            }
                        });
                        const data = await response.json();

                        // API of Enquiry
                        // If response ok API call to fetch latest data 
                        if (response.ok) {
                            try {
                                const { data,loading,error } = await CallAPI(Form, 'POST', { 
                                    "unvId": univId,
                                    "categoryId": CategoryId,
                                    "courseId": CourseId,
                                    "isMultiFieldSection": 0,
                                    "sectionId": sectionId,
                                    "isPreview": 0,
                                    "enquiryId": enquiryId,
                                    "mobileNo": mobileNo,
                                    "dob": dateOfBirth,
                                    "name": name,
                                    "AdminUserId": adminUserId,
                                    "Action": action
                                }); 
                                setData(data);
                                setLastSaveSection(data.lastActiveSection)
                            } catch (error) {
                                console.error('Error fetching data:', error);
                            }
                        }else{
                            throw new Error(data.message || 'Error fetching data');
                        }
                        setButtonLoading((prevButton) => ({
                            [fieldName] : false,
                            'isDelete': false
                        }))
                    }catch (error) {
                        console.error('Error fetching data:', error);
                    }
                }

                if(loggedInUser !== 'admin' || (loggedInUser === 'admin' && sessionStorage.getItem('actionType') === 'Edit')){
                    fetchData()
                }
                
            }

        }else{
            setValidationError((prevState) => ({
                ...prevState,
                [fieldName] : 'Invalid'
            }))

            if(!validTypes.includes(fileExtension)){
                isError = true;
                errorMessage = `Invalid filetype: ${fileExtension}`;
            }else if(fileSize > maxSize){
                isError = true;
                errorMessage = `Maximum size is ${validMaxSize} ${validMaxSizeUnit}`;
            }else if(fileSize < minSize){
                isError = true;
                errorMessage = `Minimum size is ${validMinSize+1} ${validMinSizeUnit}`;
            }else{
                isError = true;
                errorMessage = `Format: ${validTypes} (min size: ${validMinSize+1} ${validMinSizeUnit}, max size: ${validMaxSize} ${validMaxSizeUnit})`;
            }

            setTextError(prevTextError => ({
                ...prevTextError,
                [fieldName]: { isError: isError, errorMessage: errorMessage }
            }));
        }

    };

    // To Preview Document
    const documentPreview = (fieldName, value) => {
        if(value !== null || value !== ""){
        let extension = value.split('.').pop()      // Fetch the extension from url
        setIsModalOpen(true);
        setTitleMsg("");
        if(extension === 'pdf'){
            setContent(<iframe src={value} width={1200} height={800} frameBorder="0"></iframe>)
        }else if(extension === 'doc' || extension === 'docx'){
            const encodedUrl = encodeURIComponent(value);
            const googleDocsViewerUrl = `https://docs.google.com/gview?url=${encodedUrl}&embedded=true`;
            setContent(<iframe src={googleDocsViewerUrl} width={1200} height={800} frameBorder="0"></iframe>)
        }else if(extension === 'png' || extension === 'jpg' || extension === 'jpeg'){
            setContent(<iframe src={value} width={1200} height={800} frameBorder="0"></iframe>)
        }
        setModalContentIdentity('documentPreview')
        }
    };

    // To remove uploaded document
    const removeUploadedFile = (fieldName, rest, value) => {

        let extension = value.split('.').pop() 
        let parts = value.split('.')
        let dummyFile = new File([extension], extension, { type: 'text/plain' });

        const fetchData = async() => {
            setButtonLoading((prevButton) =>({
                [fieldName]: true,
                'isDelete' : true
            }))
            const accessToken = await getAccessToken();

            try {
                const formData = new FormData();
                formData.append("UnvId", parseInt(univId));
                formData.append("EnquiryId", enquiryId);
                formData.append("SectionId", rest?.sectionId);
                formData.append("FieldId", rest?.fieldId);
                formData.append("AdmissionFormId", admissionFormId);
                formData.append("SequenceId", rest?.sequence);
                formData.append("DocumentId", rest?.fieldDataSource);
                formData.append("DocumentformFile", dummyFile);
                formData.append("IsDelete", true);

                const response = await fetch(DocumentSave, {
                    method: 'POST',
                    body: formData,
                    headers : {
                        'Authorization': `Bearer ${accessToken}`,
                    }
                });

                if (response.ok) {
                    try {
                        const { data,loading,error } = await CallAPI(Form, 'POST', { 
                            "unvId": univId,
                            "categoryId": CategoryId,
                            "courseId": CourseId,
                            "isMultiFieldSection": 0,
                            "sectionId": rest?.sectionId,
                            "isPreview": 0,
                            "enquiryId": enquiryId,
                            "mobileNo": mobileNo,
                            "dob": dateOfBirth,
                            "name": name,
                            "AdminUserId": adminUserId,
                            "Action": action
                        }); 
                        setData(data);
                        setLastSaveSection(data.lastActiveSection)
                    } catch (error) {
                        console.error('Error fetching data:', error);
                    }
                }else{
                    throw new Error(data.message || 'Error fetching data');
                }

            }catch(error){
                console.log(error)
            }
            setButtonLoading((prevButton) =>({
                [fieldName]: false,
                'isDelete': false
            }))
            
        }
        if((loggedInUser !== 'admin' || (loggedInUser === 'admin' && sessionStorage.getItem('actionType') === 'Edit'))){
            fetchData();
        }
        
        setFile((prevState) => ({
            ...prevState,
            [fieldName]: null
        }))
        setFileName((prevState) => ({
            ...prevState,
            [fieldName]: null
        }))
        setExtension((prevState) => ({
            ...prevState,
            [fieldName]: null
        }))
        setValidationError((prevState) => ({
            ...prevState,
            [fieldName] : null
        }))
    }


    const handleDropdownChange = (name, value, target) => {
        let sec = data.sections.find(section => section?.sectionId === target?.sectionId);
        inputValue.current = {
            ...inputValue.current,
            [name]: value.toString()
        };

        if(modifiedApiDropdownData[name] !== undefined && sec?.isMultipleFields === 1){
            const selectedData = modifiedApiDropdownData[name].find((item) => item.key === value.toString())
 
            if(selectedData){
                tableValue.current = {
                    ...tableValue.current,
                    [name]: selectedData.value.toString()
                }
            }
        }  

        const handleFilter = (dbColumnName, fieldName, dependentFieldName) => {
            let sec = data.sections.find(section => section?.sectionId === target?.sectionId)
            let field = sec?.fieldsList.find(field => field?.dbColumnName.toLowerCase() === fieldName)
            
            if(field){
                const filteredStates = apiDropdownData[field.fieldName].filter(state => state.valueId === value.toString());
                setModifiedApiDropdownData((prevModifiedApiData) => ({
                ...prevModifiedApiData,
                [field.fieldName]: filteredStates
                }));
                
                // If the filtered states array is empty, reset the dependent field to an empty array
                if (filteredStates?.length === 0 && dependentFieldName) {
                    let dependentField = sec?.fieldsList.find(field => field?.dbColumnName.toLowerCase() === dependentFieldName)
                    setModifiedApiDropdownData((prevModifiedApiData) => ({
                        ...prevModifiedApiData,
                        [dependentField?.fieldName]: []
                    }));

                    inputOnChange.current = ([
                        ...inputOnChange.current,
                        {
                            'sectionId': dependentField?.sectionId,
                            'fieldId': dependentField?.fieldId,
                            'sequenceId': 0,
                            'value': '0',
                            "imageExtension": "",
                            "imageSize": "",
                            "fieldRefType": "",
                            "fieldRefTypeId": 0,
                            "fieldTypeId": dependentField?.fieldTypeId,
                            "isDelete": false,
                        },
                        {
                            'sectionId': field?.sectionId,
                            'fieldId': field?.fieldId,
                            'sequenceId': 0,
                            'value': '0',
                            "imageExtension": "",
                            "imageSize": "",
                            "fieldRefType": "",
                            "fieldRefTypeId": 0,
                            "fieldTypeId": field.fieldTypeId,
                            "isDelete": false,
                        }
                    ])
                }
            }
        }

        const isCreated = createObject(target, value.toString())
        
        let isError = false
        let errorMessage = ''

        setTextError((prevTextError) => ({
            ...prevTextError,
            [name]: { isError, errorMessage },
        }));

        switch (target?.dbColumnName.toLowerCase()) {
            case 'countryid':
              handleFilter('countryid', 'stateid', 'cityid');
              break;
            case 'pcountryid':
              handleFilter('pcountryid', 'pstateid', 'pcityid');
              break;
            case 'stateid':
              handleFilter('stateid', 'districtid');
              handleFilter('stateid', 'cityid');
              break;
            case 'pstateid':
                handleFilter('stateid', 'pdistrictid');
                handleFilter('pstateid', 'pcityid');
                break;
            case 'centredistrictid':
                handleFilter('centredistrictid', 'centreid')
            default:
              // handle other cases or do nothing
        }

    }

    const createObject = (target, value) => {
        let sec = data?.sections.find(section => section?.sectionId === target?.sectionId)
        let newObject = {}
        let formattedDate = ''

        if(target?.fieldType === 'Date'){
            const [day, month, year] = target?.valueLabel.split("-");
            formattedDate = `${year}-${month}-${day}`;
        }
        

        if(sec?.isMultipleFields === 1){
            newObject = {
                sectionId: target?.sectionId,
                fieldId: target?.fieldId,
                sequenceId: deleteSequenceFlag === 1 && tableInputValue[id] && editFlag === 0 ? tableInputValue[id].length + 1 : tableRowSequence[target.sectionId],
                value: value,
                imageExtension: "",
                imageSize: "",
                fieldRefType: target?.fieldRefType,
                fieldRefTypeId: target?.fieldRefTypeId,
                fieldTypeId: target?.fieldTypeId,
                isDelete: false,
            };
        }else{
            newObject = {
                sectionId: target?.sectionId,
                fieldId: target?.fieldId,
                sequenceId: 0,
                value: target?.fieldType === 'RadioButton' ?
                        (value !== undefined && value !== '' ? value
                            : (radioButtonValue[target?.fieldName] !== undefined && radioButtonValue[target?.fieldName] !== '' ? radioButtonValue[target?.fieldName] : target?.value))
                        : (target?.fieldType === 'Date' && (value === 'Invalid Date' || value === undefined)) ? formattedDate : value,
                imageExtension: "",
                imageSize: "",
                fieldRefType: target?.fieldRefType,
                fieldRefTypeId: target?.fieldRefTypeId,
                fieldTypeId: target?.fieldTypeId,
                isDelete: false,
            };
        }
        

        if (newObject) {
            // Subjects share the same fieldId across rows (differentiated by fieldRefTypeId),
            // so match SubjectId entries on fieldRefTypeId too — otherwise selecting a new
            // subject would overwrite another subject's entry at the same fieldId slot.
            const existingIndex = inputOnChange.current.findIndex(
                (item) => item.sectionId === newObject.sectionId
                    && item.fieldId === newObject.fieldId
                    && (newObject.fieldRefType === 'SubjectId'
                        ? item.fieldRefTypeId === newObject.fieldRefTypeId
                        : true)
            );

            if (existingIndex !== -1) {
                // Update the existing object
                inputOnChange.current[existingIndex] = newObject;
            } else {
                // Add new entry
                inputOnChange.current.push(newObject);
            }
            lastChangedFieldRef.current = newObject;
            if (target?.fieldType === 'RadioButton' || target?.fieldType === 'DropDown' || target?.fieldType === 'CheckList' || target?.fieldType === 'CheckBox') {
                setDependencyTick(t => t + 1);
            }
        } else {
            console.error('newObject is undefined or invalid:', newObject);
        }

        return true;
    }

    // Set university flags
    useEffect(() => {
        if(data !== null && (loggedInUser !== 'admin' || (loggedInUser === 'admin' && sessionStorage.getItem('actionType') === 'Edit'))){
            let univ = data.universityFlags.find(univFlag => univFlag.Key === 'AadhaarKYCEnabled')
            let fullname = data.universityFlags.find(univFlag => univFlag.Key === 'FullNameApplicable')
            let exam = data.universityFlags.find(examFlag => examFlag.Key === 'ExamDetailMandatory')
            let debEnable = data.universityFlags.find(debFlag => debFlag.Key === 'DEBEnabled')
            setKycFlag(univ.Value)
            setFullNameFlag(fullname.Value)
            setExamMandatory(exam.Value)
            setDebEnable(debEnable.Value)
        }

    }, [data])

    
    let uuId = ''
    let aadhaarOtp = ''
    let aadhaarMessage = ''
    const verifyAadhaar = async () => {
        if(isAadhaarVerified === false){
            // setLoading(true)
            // setButtonLoading(true)
            let sec = data.sections.find(section => section.sectionId === 2)
            let field = sec.fieldsList.find(f => f.dbColumnName === 'AadharNo')

            setButtonLoading((prevButton) => ({
                [field.fieldName] : true,
                'isDelete': false
            }))
            let addhar = inputValue.current[field.fieldName]
            if(aadhaarData !== undefined || aadhaarData !== null || aadhaarData !== ''){
                aadhaarNumber = aadhaarData
            } else if(addhar !== undefined || addhar !== ''){
                aadhaarNumber = addhar
            } 
        
            try{
                const response = await fetch(enterAadhaar, {
                    method: 'POST',
                    headers: {
                    'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({ "aadhaar": aadhaarNumber}),
                });
                if(response.ok){
                    const kycResponse = await response.json();
                    // setLoading(false)
                    setButtonLoading((prevButton) => ({
                        [field.fieldName] : true,
                        'isDelete': false
                    }))
                    if(kycResponse.response_status.code === 0 && kycResponse.response_status.status === 'SUCCESS'){
                        uuId = kycResponse.response_data.uuId

                        aadhaarModel(false)
                    }else if(kycResponse.response_status.status === 'FAIL'){
                        let isError = true
                        let errorMessage = kycResponse.response_status.message
                        await updateTextError(field.fieldName, { isError, errorMessage });
                    }
                }
            }catch(error){
                console.log(error)
            }
        }
    }

    const aadhaarModel = (buttonDisabled) =>{
        setIsModalOpen(true)
        setTitleMsg('Aadhaar Verification')
        setContent(
            <Box sx={{mt:1}}>
                {/* <hr/> */}
                <Typography
                    sx={{
                        color: '#5aa729',
                        // fontFamily: 'Open Sauce Sans',
                        fontSize: '16px'
                    }}
                >
                    A One-Time password has been sent to your registered mobile number
                </Typography>
                <Box sx={{mb:5}}>
                    <Box sx={{mt:5}}></Box>
                    <InputLabel sx={{mt: 3}}>Enter OTP</InputLabel>
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', textAlign: 'center' }}>
                        <TextField
                            className="formInputField"
                            sx={{width: '80%'}}
                            onChange={(e) => handleOtp(e.target.value)}
                            InputProps={{
                                sx: {
                                '& input': {
                                    textAlign: 'center',
                                    // Add other custom styles here
                                },
                                },
                            }}
                        />
                        <RefreshIcon 
                            sx={{ color: '#185ABD', mt: 1, ml: 1, mr: 1 }} 
                            onClick={resendOtp}
                        />
                    </Box>
                    <Typography
                        sx={{
                            color: 'red',
                            // fontFamily: 'Open Sauce Sans',
                            fontSize: '16px'
                        }}
                    >{aadhaarMessage}</Typography>
                </Box>
                <Button sx={{
                    textAlign: 'center', 
                    // background: '#5aa729',
                    color: '#fff',
                    marginTop:  '3%',
                    marginBottom: '2%',
                    '&:hover': {
                        background: '#538a30',
                    },
                    textTransform: 'none',
                    mt:5,
                    // fontFamily: 'Open Sauce Sans',
                    background: 'linear-gradient(119.54deg, #000046 0, #1cb5e0 100%)',
                    '&:hover': {
                        background: 'linear-gradient(119.54deg, #000046 0, #1cb5e0 100%)', 
                    }
                }}
                onClick={() => {
                    varifyOtp();
                    aadhaarModel(true);
                }}
                disabled={buttonDisabled}
                >
                    {loading ? 
                    <CircularProgress
                        size={24}
                        sx={{
                        color: '#fff',
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        marginTop: '-12px',
                        marginLeft: '-12px',
                        }}
                    /> : 'Verify'}
                </Button>
            </Box> 
        )
        setModalContentIdentity('Verification')
    }

    // Set aadhaar verification otp
    const handleOtp = (otpVal) => {
        setOtp(parseInt(otpVal));
        aadhaarOtp = otpVal
    }

    // Resend otp for aadhaar verification
    const resendOtp = async() => {
        setOtp('')
        try{
            const response = await fetch('https://uatapi.teamleaseedtech.com/api/kyc/v2/enteraadhaar', {
                method: 'POST',
                headers: {
                'Content-Type': 'application/json',
                },
                body: JSON.stringify({ "aadhaar": aadhaarNumber}),
            });
            if(response.ok){
                const refreshResponse = await response.json();
                if(refreshResponse.response_status.status === 'SUCCESS'){
                    console.log('otp resend')
                }else if(refreshResponse.response_status.status === 'FAIL'){
                    aadhaarMessage = refreshResponse.response_status.message
                    return aadhaarMessage;
                }
            }
        }catch(error){
            console.log(error)
        }
    }

    const varifyOtp = async () => {
        // setLoading(true)
        setButtonLoading(true)
        try{
            const response = await fetch(enterOtp, {
                method: 'POST',
                headers: {
                'Content-Type': 'application/json',
                },
                body: JSON.stringify({ "uuid": uuId, "otp": aadhaarOtp}),
            });
            if(response.ok){
                const verifyResponse = await response.json();
                setLoading(false);
                setButtonLoading(false)
                if(verifyResponse.response_status.status === 'SUCCESS'){
                    let sec = data.sections.find(section => section.sectionId === 2)
                    let field = sec.fieldsList.find(f => f.dbColumnName === 'AadharNo')

                    setIsModalOpen(false)
                    setIsAadhaarVerified(true)
                    prefillAadhaarData(verifyResponse.response_data)

                    let isError = false
                    let errorMessage = ''

                    await updateTextError(field.fieldName, { isError, errorMessage });

                }else if(verifyResponse.response_status.status === 'FAIL'){
                    setIsAadhaarVerified(false)
                    aadhaarMessage = verifyResponse.response_status.message

                    setIsModalOpen(true)
                    setTitleMsg('Aadhaar Verification')
                    setContent(
                        <Box sx={{mt:1}}>
                            {/* <hr/> */}
                            <Typography
                                sx={{
                                    color: '#5aa729',
                                    // fontFamily: 'Open Sauce Sans',
                                    fontSize: '16px'
                                }}
                            >
                                A One-Time password has been sent to your registered mobile number
                            </Typography>
                            <Box sx={{mb:5}}>
                                <Box sx={{mt:5}}></Box>
                                <InputLabel sx={{mt: 3}}>Enter OTP</InputLabel>
                                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', textAlign: 'center' }}>
                                    <TextField
                                        className="formInputField"
                                        sx={{width: '80%'}}
                                        onChange={(e) => handleOtp(e.target.value)}
                                        InputProps={{
                                            sx: {
                                            '& input': {
                                                textAlign: 'center',
                                                // Add other custom styles here
                                            },
                                            },
                                        }}
                                    />
                                    <RefreshIcon 
                                        sx={{ color: '#185ABD', mt: 1, ml: 1, mr: 1 }} 
                                        onClick={resendOtp}
                                    />
                                </Box>
                                <Typography
                                    sx={{
                                        color: 'red',
                                        // fontFamily: 'Open Sauce Sans',
                                        fontSize: '16px'
                                    }}
                                >{aadhaarMessage}</Typography>
                            </Box>
                            <Button sx={{
                                textAlign: 'center', 
                                // background: '#5aa729',
                                color: '#fff',
                                marginTop:  '3%',
                                marginBottom: '2%',
                                '&:hover': {
                                    background: '#538a30',
                                },
                                textTransform: 'none',
                                mt:5,
                                // fontFamily: 'Open Sauce Sans',
                                background: 'linear-gradient(119.54deg, #000046 0, #1cb5e0 100%)',
                            }}
                            onClick={varifyOtp}
                            >Verify</Button>
                        </Box> 
                    )
                    setModalContentIdentity('Verification')
                }
                
            }
        }catch(error){
            console.log(error)
        }
    }

    useEffect(() =>{
        if(data !== null && (loggedInUser !== 'admin' || (loggedInUser === 'admin' && sessionStorage.getItem('actionType') === 'Edit'))){
            let sec = data.sections.find(section => section.sectionId === 2)
            let sec1 = data.sections.find(section => section.sectionId === 1)
            let aadhaarField = sec.fieldsList.find(f => f.dbColumnName.toLowerCase() === 'aadharno')
            // let debField = sec.fieldsList.find(f => f.dbColumnName.toLowerCase() === 'debid')

            let debField = sec1?.fieldsList.find(field => field.dbColumnName.toLowerCase() === 'debid');

            // If not found in Section 1, search in Section 2
            if (!debField) {
                debField = sec1?.fieldsList.find(field => field.dbColumnName.toLowerCase() === 'debid');
            }

            if(aadhaarField !== undefined && aadhaarField.value !== ''){
                setIsAadhaarVerified(true)
            } if(debField !== undefined && debField.value !== ''){
                // set deb verified
                setIsDebVerified(true)
            }
        }
    },[data])

    const prefillAadhaarData = (aadhaarData1) => {
        // fetch feilds of personal detail section
        let section = data.sections.find(section => section.sectionId === 2);
        
        var dobField = section.fieldsList.find(field => field.dbColumnName === 'DOB')
        var genderField = section.fieldsList.find(field => field.dbColumnName === 'Gender')
        var photoField = section.fieldsList.find(field => field.dbColumnName === 'Photo')

        //  fetch fields of corresponding detail section
        let sec = data.sections.find(s=>s.sectionId === 9)
        let cityField = sec.fieldsList.find(f=>f.dbColumnName === 'CityId')
        let stateField = sec.fieldsList.find(f=>f.dbColumnName === 'StateId')
        let countryField = sec.fieldsList.find(f=>f.dbColumnName === 'CountryId')
        let pincodeField = sec.fieldsList.find(f=>f.dbColumnName === 'Pincode')
        let address1Field = sec.fieldsList.find(f=>f.dbColumnName === 'AddressLine1')
        let address2Field = sec.fieldsList.find(f=>f.dbColumnName === 'AddressLine2')

        

        // Convert base64 to file
        let base64String = aadhaarData1.doc_face;
        const mimeType = 'image/jpeg'; // adjust the mime type according to your image type
        const byteCharacters = atob(base64String);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const file = new Blob([byteArray], { type: mimeType });
        setFile(URL.createObjectURL(file));
        let imageFileType = file.type; 
        let imageFileSize = file.size;


        let address = aadhaarData1.address.split(",").splice(-4)        // fetch city, state, country and pincode
        let addressLine = aadhaarData1.address.split(",").splice(0,2)   // fetch adress line1 and address line2

        const countryKey = countryList.find(country => country.value.toLowerCase() === address[2].toLowerCase()).key;
        const statek = stateList.find(state => state.value.toLowerCase() === address[1].toLowerCase()).key;
        const cityk = cityList.find(city => city.value.toLowerCase() === address[0].toLowerCase()).key;

        // Set state list
        const states = stateList.filter(state => state.countryId === (countryKey ? countryKey.key : null));
        setSelStateList(states)

        // Set city list
        const city = cityList.filter(city => city.stateId === (statek ? statek.key : null));
        setSelCityList(city)

        // Format dob
        let [day, month, year] = aadhaarData1.dob.split("/");
        let formattedDob = `${year}-${month}-${day}`;

        // set input values
        inputValue.current = {
            ...inputValue.current,
            [dobField?.fieldName]: formattedDob,
            [genderField?.fieldName]: aadhaarData1.gender,
            [photoField?.fieldName]: aadhaarData1.doc_face,
            [cityField?.fieldName]: cityk.toString(),
            [stateField?.fieldName]: statek.toString(),
            [countryField?.fieldName]: countryKey.toString(),
            [pincodeField?.fieldName]: address[3],
            [address1Field?.fieldName]: addressLine[0],
            [address2Field?.fieldName]: addressLine[1]
        };

        // set into list to save
        let fieldsToSave = [
            { 'sectionId': 2, fieldId: dobField?.fieldId, 'sequenceId': 0, value: formattedDob !== null && formattedDob !==undefined ? formattedDob : "", "imageExtension": "", "imageSize": "", "fieldRefType": "", "fieldRefTypeId": 0, "fieldTypeId": dobField?.fieldTypeId, "isDelete" : false,},
            { 'sectionId': 2, fieldId: genderField?.fieldId, 'sequenceId': 0, value: aadhaarData1.gender !== null && aadhaarData1.gender !== undefined ? aadhaarData1.gender : "", "imageExtension": "", "imageSize": "", "fieldRefType": "", "fieldRefTypeId": 0, "fieldTypeId": genderField?.fieldTypeId, "isDelete" : false,},
            { 'sectionId': 2, fieldId: photoField?.fieldId, 'sequenceId': 0, value: aadhaarData1.doc_face !== null && aadhaarData1.doc_face !== undefined ? aadhaarData1.doc_face : "", "imageExtension": imageFileType, "imageSize": imageFileSize.toString(), "fieldRefType": "", "fieldRefTypeId": 0, "fieldTypeId": photoField?.fieldTypeId, "isDelete" : false,},
            
            { 'sectionId': 9, fieldId: cityField?.fieldId, 'sequenceId': 0, value: cityk !== null && cityk !== undefined ? cityk.toString() : "", "imageExtension": "", "imageSize": "", "fieldRefType": "", "fieldRefTypeId": 0, "fieldTypeId": cityField?.fieldTypeId, "isDelete" : false,},
            { 'sectionId': 9, fieldId: stateField?.fieldId, 'sequenceId': 0, value: statek !== null && statek !== undefined ? statek.toString() : "", "imageExtension": "", "imageSize": "", "fieldRefType": "", "fieldRefTypeId": 0, "fieldTypeId":stateField?.fieldTypeId, "isDelete" : false,},
            { 'sectionId': 9, fieldId: countryField?.fieldId, 'sequenceId': 0, value: countryKey !== null && countryKey !== undefined ? countryKey.toString() : "", "imageExtension": "", "imageSize": "", "fieldRefType": "", "fieldRefTypeId": 0, "fieldTypeId": countryField?.fieldTypeId, "isDelete" : false,},
            { 'sectionId': 9, fieldId: pincodeField?.fieldId, 'sequenceId': 0, value: address[3] !== null && address[3] !== undefined ? address[3] : "", "imageExtension": "", "imageSize": "", "fieldRefType": "", "fieldRefTypeId": 0, "fieldTypeId": pincodeField?.fieldTypeId, "isDelete" : false,},
            { 'sectionId': 9, fieldId: address1Field?.fieldId, 'sequenceId': 0, value: addressLine[0] !== null && addressLine[0] !== undefined ? addressLine[0] : "", "imageExtension": "", "imageSize": "", "fieldRefType": "", "fieldRefTypeId": 0, "fieldTypeId": address1Field?.fieldTypeId, "isDelete" : false,},
            { 'sectionId': 9, fieldId: address2Field?.fieldId, 'sequenceId': 0, value: addressLine[1] !== null && addressLine[1] !== undefined ? addressLine[1] : "", "imageExtension": "", "imageSize": "", "fieldRefType": "", "fieldRefTypeId": 0, "fieldTypeId": address2Field?.fieldTypeId, "isDelete" : false,},
        ]
        
        // setListOfFieldsArray(fieldsToSave);
        inputOnChange.current = fieldsToSave

        if(fullNameFlag !== null && fullNameFlag === 0){
            var firstField = section.fieldsList.find(field => field.dbColumnName === 'Firstname')
            var middleField = section.fieldsList.find(field => field.dbColumnName === 'Middlename')
            var lastField = section.fieldsList.find(field => field.dbColumnName === 'Lastname')

            var nameParts = aadhaarData1.name.split(" ");
        
            // Access the parts of the name
            if(nameParts?.length === 3){
                var firstName = nameParts[0];
                var middleName = nameParts[1];
                var lastName = nameParts[2];
            }

            // set input values
            inputValue.current = {
                ...inputValue.current,
                [firstField?.fieldName]: firstName !== null && firstName !== undefined ? firstName : "",
                [middleField?.fieldName]: middleName !== null && middleName !== undefined ? middleName : "",
                [lastField?.fieldName]: lastName !== null && lastName !== undefined ? lastName : "",
            };

            let fieldsToSave = [
                { 'sectionId': 2, fieldId: firstField?.fieldId, 'sequenceId': 0, value: firstName !== null && firstName !== undefined ? firstName : "", "imageExtension": "", "imageSize": "", "fieldRefType": "", "fieldRefTypeId": 0, "fieldTypeId": firstField?.fieldTypeId, "isDelete" : false,},
                { 'sectionId': 2, fieldId: middleField?.fieldId, 'sequenceId': 0, value: middleName !== null && middleName !== undefined ? middleName : "", "imageExtension": "", "imageSize": "", "fieldRefType": "", "fieldRefTypeId": 0, "fieldTypeId": middleField?.fieldTypeId, "isDelete" : false,},
                { 'sectionId': 2, fieldId: lastField?.fieldId, 'sequenceId': 0, value: lastName !== null && lastName !== undefined ? lastName : "", "imageExtension": "", "imageSize": "", "fieldRefType": "", "fieldRefTypeId": 0, "fieldTypeId": lastField?.fieldTypeId, "isDelete" : false,},
            ]   

            // setListOfFieldsArray((prevList) => [...prevList, ...fieldsToSave]);
            inputOnChange.current = ([
                ...inputOnChange.current,
                ...fieldsToSave
            ])
        } else if(fullNameFlag !== null && fullNameFlag === 1){
            var firstField = section.fieldsList.find(field => field.dbColumnName === 'Firstname')

            inputValue.current = {
                ...inputValue.current,
                [firstField?.fieldName]: aadhaarData1.name !== null && aadhaarData1.name !== undefined ? aadhaarData1.name : "",
            };

            let fieldsToSave = [
                { 'sectionId': 2, fieldId: firstField?.fieldId, 'sequenceId': 0, value: aadhaarData1.name !== null && aadhaarData1.name !== undefined ? aadhaarData1.name : "", "imageExtension": "", "imageSize": "", "fieldRefType": "", "fieldRefTypeId": 0, "fieldTypeId": firstField?.fieldTypeId, "isDelete" : false,},
            ]   
            
            inputOnChange.current = ([
                ...inputOnChange.current,
                ...fieldsToSave
            ])
        }

    }

    // UMS1-1186: asks the API whether this DEB ID may be used for the current enquiry.
    // Returns the reason when restricted, null when allowed. Fails open - a network
    // problem must not block a legitimate applicant.
    const checkDebIdRestriction = async (debIdValue) => {
        if(debIdValue === null || debIdValue === undefined || debIdValue === ''){
            return null;
        }

        try {
            const debRestriction = await CallAPI(ValidateDebId, 'POST', {
                "enquiryId": enquiryId,
                "debId": debIdValue
            })

            if(debRestriction && debRestriction.isSuccess === false){
                return debRestriction.message
            }
        } catch(restrictionError) {
            console.log(restrictionError)
        }

        return null;
    }

    const verifyDebId = async (sectionId) => {
        let sec = data.sections.find(section => section.sectionId === sectionId)
        let field = sec.fieldsList.find(f => f.dbColumnName.toLowerCase() === 'debid')

        let deb = inputValue.current[field.fieldName]
        let debNumber = 0
        let isError = false;
        let errorMessage = '';

        if(setDebId !== undefined || setDebId !== null || setDebId !== ''){
            debNumber = setDebId
        } else if(deb !== undefined || deb !== ''){
            debNumber = setDebId
        }

        const enteredDebId = debNumber ? debNumber : deb
        const enteredRestrictionMessage = await checkDebIdRestriction(enteredDebId)

        if(enteredRestrictionMessage !== null){
            isError = true
            errorMessage = enteredRestrictionMessage

            await updateTextError(field.fieldName, { isError, errorMessage });

            return;
        }

        try{
            const response = await fetch(debIdDetails, {
                method: 'POST',
                headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${debToken}`,
                },
                body: JSON.stringify({ "DEBId": debNumber ? debNumber : deb , "UnvId": parseInt(univId)}),
            });
            setButtonLoading((prevButton) => ({
                [field?.fieldName] : true,
            }))
            if(response.ok){
                const debResponse = await response.json();
                if(debResponse.isSuccess === true){
                    let details = debResponse.resource[0]

                    // UMS1-1186: the value saved below is the one returned by the DEB service,
                    // not what was typed, so re-check it here before any auto-fill happens.
                    const debIdToValidate = details.debUniqueID !== null && details.debUniqueID !== undefined ? details.debUniqueID : deb !== null && deb !== undefined ? deb : debNumber
                    const debRestrictionMessage = await checkDebIdRestriction(debIdToValidate)

                    if(debRestrictionMessage !== null){
                        isError = true
                        errorMessage = debRestrictionMessage

                        setButtonLoading((prevButton) => ({
                            [field?.fieldName] : false,
                        }))

                        await updateTextError(field.fieldName, { isError, errorMessage });

                        return;
                    }

                    let section = data.sections.find(sec => sec.sectionId === 2)
                    let section1 = data.sections.find(sec => sec.sectionId === 1);

                    var abcField = section1?.fieldsList.find(field => field.dbColumnName.toLowerCase() === 'abc_id');
                    // If not found in Section 1, search in Section 2
                    if (!abcField) {
                        abcField = section?.fieldList.find(field => field.dbColumnName.toLowerCase() === 'abc_id');
                    }

                    var debField = section1?.fieldsList.find(field => field.dbColumnName.toLowerCase() === 'debid');
                    if(!debField){
                        debField = section?.fieldList.find(field => field.dbColumnName.toLowerCase() === 'debid');
                    }

                    var dobField = section.fieldsList.find(field => field.dbColumnName.toLowerCase() === 'dob')
                    var genderField = section.fieldsList.find(field => field.dbColumnName.toLowerCase() === 'gender')
                    var mobileField = section.fieldsList.find(field => field.dbColumnName.toLowerCase() === 'mobileno')
                    var emailFeild = section.fieldsList.find(field => field.dbColumnName.toLowerCase() === 'emailid' )
                    // var abcField = section.fieldList.find(field => field.dbColumnName.toLowerCase() === 'abc_id')

                    // let [day, month, year] = details.dob !== "" && details.dob.split("/");
                    // let formattedDob = `${year}-${month}-${day}`;
                    // console.log('formattedDob', formattedDob)
                    let formattedDob = ""; // Initialize formattedDob as an empty string

                    if (details.dob) { // Ensure dob is not undefined or empty
                        if (details.dob.startsWith("undefined")) {
                            formattedDob = "";
                        } else {
                            let [day, month, year] = details.dob.split("/");
                            
                            if (day && month && year) {
                                formattedDob = `${year}-${month}-${day}`;
                            }
                        }
                    }

                    let gender = ''

                    if(details.gender === 'Male'){
                        gender = 'M'
                    }else if(details.gender === 'Female'){
                        gender = 'F'
                    }else if(details.gender === 'Transgender'){
                        gender = 'T'
                    }else if(details.gender === 'Others'){
                        gender = 'O'
                    }

                    inputValue.current = {
                        ...inputValue.current,
                        [dobField?.fieldName]: formattedDob,
                        [genderField?.fieldName]: gender,
                        [mobileField?.fieldName] : details.mobile,
                        [emailFeild?.fieldName]: details.email,
                        [abcField?.fieldName]: details.abcid,
                        [debField?.fieldName]: debNumber ? debNumber : deb,
                    };

                    setDebData((prevDebData) => ({
                        ...prevDebData,
                        [dobField?.fieldName]: formattedDob,
                        [genderField?.fieldName]: gender,
                        [mobileField?.fieldName] : details.mobile,
                        [emailFeild?.fieldName]: details.email,
                        [abcField?.fieldName]: details.abcid,
                        [debField?.fieldName]: debNumber ? debNumber : deb,
                    }))
                    
                    let fieldsToSave = [
                        { 'sectionId': debField.sectionId, fieldId: debField?.fieldId, 'sequenceId': 0, value: details.debUniqueID !== null && details.debUniqueID !== undefined ? details.debUniqueID : deb !== null && deb !== undefined ? deb : debNumber, "imageExtension": "", "imageSize": "", "fieldRefType": "", "fieldRefTypeId": 0, "fieldTypeId": debField?.fieldTypeId, "isDelete" : false,},
                        { 'sectionId': 2, fieldId: dobField?.fieldId, 'sequenceId': 0, value: formattedDob !== null && formattedDob !==undefined ? formattedDob : "", "imageExtension": "", "imageSize": "", "fieldRefType": "", "fieldRefTypeId": 0, "fieldTypeId": dobField?.fieldTypeId, "isDelete" : false,},
                        { 'sectionId': 2, fieldId: genderField?.fieldId, 'sequenceId': 0, value: gender !== null && gender !== undefined ? gender : "", "imageExtension": "", "imageSize": "", "fieldRefType": "", "fieldRefTypeId": 0, "fieldTypeId": genderField?.fieldTypeId, "isDelete" : false,},
                        { 'sectionId': 2, fieldId: mobileField?.fieldId, 'sequenceId': 0, value: details.mobile !== null && details.mobile !== undefined ? details.mobile : "", "imageExtension": "", "imageSize": "", "fieldRefType": "", "fieldRefTypeId": 0, "fieldTypeId": mobileField?.fieldTypeId, "isDelete" : false,},
                        { 'sectionId': 2, fieldId: emailFeild?.fieldId, 'sequenceId': 0, value: details.email !== null && details.email !== undefined ? details.email : "", "imageExtension": "", "imageSize": "", "fieldRefType": "", "fieldRefTypeId": 0, "fieldTypeId": emailFeild?.fieldTypeId, "isDelete" : false,},
                        { 'sectionId': abcField.sectionId, 'fieldId': abcField.fieldId, 'sequenceId': 0, 'value': details.abcid !== null && details.abcid !== undefined ? details.abcid : "", "imageExtension": "", "imageSize": "", "fieldRefType": "", "fieldRefTypeId": 0, "fieldTypeId": abcField?.fieldTypeId, "isDelete" : false,}
                    ]

                    fieldsToSave.forEach((newObject) => {
                        const existingIndex = inputOnChange.current.findIndex(
                            (item) => item.sectionId === newObject.sectionId && item.fieldId === newObject.fieldId
                        );
                    
                        if (existingIndex !== -1) {
                            // Update the existing object
                            inputOnChange.current[existingIndex] = newObject;
                        } else {
                            // Add new entry
                            inputOnChange.current.push(newObject);
                        }
                    });
                    
                    inputOnChange.current = ([
                        ...inputOnChange.current,
                        ...fieldsToSave
                    ])

                    if(fullNameFlag !== null && fullNameFlag === 0){
                        var firstField = section.fieldsList.find(field => field.dbColumnName.toLowerCase() === 'firstname')
                        var middleField = section.fieldsList.find(field => field.dbColumnName.toLowerCase() === 'middlename')
                        var lastField = section.fieldsList.find(field => field.dbColumnName.toLowerCase() === 'lastname')
                        
                        var nameParts = details.stdname.split(" ");
        
                        // Access the parts of the name
                        if(nameParts?.length === 3){
                            var firstName = nameParts[0];
                            var middleName = nameParts[1];
                            var lastName = nameParts[2];
                        }

                        inputValue.current = {
                            ...inputValue.current,
                            [firstField?.fieldName]: firstName !== null && firstName !== undefined ? firstName : "",
                            [middleField?.fieldName]: middleName !== null && middleName !== undefined ? middleName : "",
                            [lastField?.fieldName]: lastName !== null && lastName !== undefined ? lastName : "",
                        };

                        let fieldsToSave = [
                            { 'sectionId': 2, fieldId: firstField?.fieldId, 'sequenceId': 0, value: firstName !== null && firstName !== undefined ? firstName : "", "imageExtension": "", "imageSize": "", "fieldRefType": "", "fieldRefTypeId": 0, "fieldTypeId": firstField?.fieldTypeId, "isDelete" : false,},
                            { 'sectionId': 2, fieldId: middleField?.fieldId, 'sequenceId': 0, value: middleName !== null && middleName !== undefined ? middleName : "", "imageExtension": "", "imageSize": "", "fieldRefType": "", "fieldRefTypeId": 0, "fieldTypeId": middleField?.fieldTypeId, "isDelete" : false,},
                            { 'sectionId': 2, fieldId: lastField?.fieldId, 'sequenceId': 0, value: lastName !== null && lastName !== undefined ? lastName : "", "imageExtension": "", "imageSize": "", "fieldRefType": "", "fieldRefTypeId": 0, "fieldTypeId": lastField?.fieldTypeId, "isDelete" : false,},
                        ]   

                        // setListOfFieldsArray((prevList) => [...prevList, ...fieldsToSave]);
                        inputOnChange.current = ([
                            ...inputOnChange.current,
                            ...fieldsToSave
                        ])

                        setDebData((prevDebData) => ({
                            ...prevDebData,
                            [firstField?.fieldName]: firstName !== null && firstName !== undefined ? firstName : "",
                            [middleField?.fieldName]: middleName !== null && middleName !== undefined ? middleName : "",
                            [lastField?.fieldName]: lastName !== null && lastName !== undefined ? lastName : "",
                        }))
                    } else if(fullNameFlag !== null && fullNameFlag === 1){
                        var firstField = section.fieldsList.find(field => field.dbColumnName.toLowerCase() === 'firstname')

                        inputValue.current = {
                            ...inputValue.current,
                            [firstField?.fieldName]: details.stdname,
                        };

                        let fieldsToSave = [
                            { 'sectionId': 2, fieldId: firstField?.fieldId, 'sequenceId': 0, value: details.stdname, "imageExtension": "", "imageSize": "", "fieldRefType": "", "fieldRefTypeId": 0, "fieldTypeId": firstField?.fieldTypeId, "isDelete" : false,},
                        ]   

                        inputOnChange.current = ([
                            ...inputOnChange.current,
                            ...fieldsToSave
                        ])

                        setDebData((prevDebData) => ({
                            ...prevDebData,
                            [firstField?.fieldName]: details.stdname !== null && details.stdname !== undefined ? details.stdname : "",
                        }))

                        setListOfFieldsArray((prevList) => [...prevList, ...fieldsToSave]);
                    }

                    setIsDebVerified(true)
                    setButtonLoading((prevButton) => ({
                        [field?.fieldName] : false,
                    }))
                        
                }else if(debResponse.isSuccess === false){
                    isError = true
                    errorMessage = debResponse.message

                    setButtonLoading((prevButton) => ({
                        [field?.fieldName] : false,
                    }))

                    await updateTextError(field.fieldName, { isError, errorMessage });
                }
            }else{
                console.log(response)
            }
        }  catch(error){
            console.log(error)
        }  
    }

    const handleCheckboxChange = (fieldName, target, event) => {
        setChecked((prevChecked) => ({
            ...prevChecked,
            [fieldName]: event.target.checked
        }));

        if(target.fieldRefType === 'SubjectId'){
            if(event.target.checked){
                // Add to list
                const isCreated = createObject(target, target.fieldRefTypeId.toString())
            } else {
                // Uncheck: drop only the matching subject entry (match by fieldRefTypeId
                // since multiple subjects share the same fieldId). Backend does
                // delete+insert from the payload, so omitting a subject deselects it.
                inputOnChange.current = inputOnChange.current.filter(
                    field => !(field.sectionId === target.sectionId
                        && field.fieldId === target.fieldId
                        && field.fieldRefTypeId === target.fieldRefTypeId)
                );
            }
        }else {
            if(event.target.checked){
                const isCreated = createObject(target, 'true')
            }else if(event.target.checked === false && target.value !== '' ){
                const isCreated = createObject(target, 'false')
            }
        }

    }

    const handleCheckListChange = (field, key, value, event) => {
        const { checked } = event.target;
      
        if (!checkedItems.current[field.fieldName]) {
            checkedItems.current[field.fieldName] = {};
        }

        checkedItems.current[field.fieldName][key] = checked;
        // setCheckedItems((prevCheckedItems) => ({
        //   ...prevCheckedItems,
        //   [field.fieldName]: {
        //     ...prevCheckedItems[field.fieldName],
        //     [key]: checked,
        //   },
        // }));

        setLatestField({ field, key });
      
    };

    useEffect(() => {
    const { field, key } = latestField;
    if (!field || !key) return;

    const checklist = checkedItems.current[field.fieldName];
    if (checklist && key in checklist) {
        const isChecked = checklist[key];

        const existingFieldIndex = inputOnChange.current.findIndex(
            (item) =>
                item.sectionId === field.sectionId &&
                item.fieldId === field.fieldId &&
                item.sequenceId === 0
        );

        if (isChecked) {
            // Checkbox is checked - add if not present
            if (existingFieldIndex !== -1) {
                const existingField = inputOnChange.current[existingFieldIndex];
                const values = existingField.value ? existingField.value.split(",") : [];
                if (!values.includes(key)) {
                    existingField.value = [...values, key].join(",");
                }
            } else {
                // If field entry doesn't exist yet, create it
                createObject(field, key);
            }
        } else {
            // Checkbox is unchecked - remove the key
            if (existingFieldIndex !== -1) {
                const existingField = inputOnChange.current[existingFieldIndex];
                const values = existingField.value ? existingField.value.split(",") : [];
                const filteredValues = values.filter((item) => item !== key);
                existingField.value = filteredValues.join(",");

                // Optionally, clean up the checklist state (if needed)
                // delete checklist[key]; // Only do this if you're managing checkedItems manually
            }
        }
    }
}, [checkedItems.current, latestField]);

    const inputRefs = useRef({});
    const textareaRef = useRef(null);

    const dataLoadedRef = useRef(false);
    const [isDataLoaded, setIsDataLoaded] = useState(false);

    
    // set dropdown list
    useEffect(() => {
        // if (dataLoadedRef.current) return;
        // if (data === null) return;
        if (dataLoadedRef.current || data === null) return; // Prevent multiple executions
        dataLoadedRef.current = true; 

        if(data !== null ){
            data.sections.forEach(section => {
                section.fieldsList.forEach(field => {
                    if(field.fieldDataSourceType === 'API'){
                        if(field.fieldDataSource !== ''){
                        CallAPI(`${apiRootUrl}${field.fieldDataSource}`, 'GET', {
                            'ChildDataId' : field.dbColumnName.toLowerCase() !== 'centredistrictid' && field.dbColumnName.toLowerCase() !== 'centreid' && field.dbColumnName.toLowerCase() !== 'mediumid' ? 0 : sessionStorage.getItem('CourseId'),
                            'ChildDataId2' : 0
                        }).then(({ data, loading, error }) => {
                            setApiDropdownData(prevApiData => ({
                                ...prevApiData,
                                [field.fieldName]: data ? data : []
                            }))

                            setModifiedApiDropdownData(prevApiData => ({
                                ...prevApiData,
                                [field.fieldName]: data ? data : []
                            }))

                            const fieldsdbNames = ['stateid', 'pstateid', 'districtid', 'pdistrictid', 'cityid', 'pcityid', 'CentreDistrictId', 'CentreId', 'mediumid', 'BoardId', 'SchoolId'];
                            let allFieldsHaveValue = true;

                            fieldsdbNames.forEach((fieldName) => {
                            if (field.dbColumnName.toLowerCase() === fieldName && field.value === '') {
                                    allFieldsHaveValue = false;
                                }
                            });

                            if(!allFieldsHaveValue){
                                setModifiedApiDropdownData(prevApiData => ({
                                    ...prevApiData,
                                    [field.fieldName]: data
                                }))
                            }
                           
                        }).catch(error => {
                            console.error('Error fetching data:', error);
                        });
                    }
                }})
            });
        }
    },[data])

    useEffect(() => {
        if(apiDropdownData){
            if(data !== null ){
                data.sections.forEach(section => {
                    section.fieldsList.forEach(field => {
                        if(field.dbColumnName.toLowerCase() === 'stateid'){
                            let dependencyField = section.fieldsList.find(field => field.dbColumnName.toLowerCase() === 'countryid')
                            
                            if(apiDropdownData[field.fieldName] && apiDropdownData[field.fieldName]?.length === 1){
                                setModifiedApiDropdownData(prevApiData => ({
                                    ...prevApiData,
                                    [field.fieldName]: apiDropdownData[field.fieldName]
                                }))
                            }else{
                                if(dependencyField !== undefined && dependencyField.value !== '' ){
                                    if(apiDropdownData[field.fieldName]){
                                        let filteredlist = apiDropdownData[field.fieldName].filter(state => state.valueId === dependencyField.value)
                                        
                                        setModifiedApiDropdownData(prevApiData => ({
                                            ...prevApiData,
                                            [field.fieldName]: filteredlist
                                        }))
                                    }
                                }else if(dependencyField !== undefined){
                                    setModifiedApiDropdownData(prevApiData => ({
                                        ...prevApiData,
                                        [field.fieldName]: []
                                    }))
                                }
                            }
                        }
                        if(field.dbColumnName.toLowerCase() === 'pstateid'){
                            let dependencyField = section.fieldsList.find(field => field.dbColumnName.toLowerCase() === 'pcountryid')

                            if(apiDropdownData[field.fieldName] && apiDropdownData[field.fieldName]?.length === 1){
                                setModifiedApiDropdownData(prevApiData => ({
                                    ...prevApiData,
                                    [field.fieldName]: apiDropdownData[field.fieldName]
                                }))
                            }else{
                                if(dependencyField !== undefined && dependencyField.value !== ''){
                                    if(apiDropdownData[field.fieldName]){
                                        let filteredlist = apiDropdownData[field.fieldName].filter(state => state.valueId === dependencyField.value)

                                        setModifiedApiDropdownData(prevApiData => ({
                                            ...prevApiData,
                                            [field.fieldName]: filteredlist
                                        }))
                                    }
                                }else if(dependencyField !== undefined){
                                    setModifiedApiDropdownData(prevApiData => ({
                                        ...prevApiData,
                                        [field.fieldName]: []
                                    }))
                                }
                            }
                        }
                        if(field.dbColumnName.toLowerCase() === 'districtid'){
                            let dependencyField = section.fieldsList.find(field => field.dbColumnName.toLowerCase() === 'stateid')

                            if(apiDropdownData[field.fieldName] && apiDropdownData[field.fieldName]?.length === 1){
                                setModifiedApiDropdownData(prevApiData => ({
                                    ...prevApiData,
                                    [field.fieldName]: apiDropdownData[field.fieldName]
                                }))
                            }else{
                                if(dependencyField !== undefined && dependencyField.value !== ''){
                                    if(apiDropdownData[field.fieldName]){
                                        let filteredlist = apiDropdownData[field.fieldName].filter(state => state.valueId === dependencyField.value)
                                        
                                        setModifiedApiDropdownData(prevApiData => ({
                                            ...prevApiData,
                                            [field.fieldName]: filteredlist
                                        }))
                                    }
                                }else{
                                    setModifiedApiDropdownData(prevApiData => ({
                                        ...prevApiData,
                                        [field.fieldName]: []
                                    }))
                                }
                            }
                        }
                        if(field.dbColumnName.toLowerCase() === 'pdistrictid'){
                            let dependencyField = section.fieldsList.find(field => field.dbColumnName.toLowerCase() === 'pstateid')

                            if(apiDropdownData[field.fieldName] && apiDropdownData[field.fieldName]?.length === 1){
                                setModifiedApiDropdownData(prevApiData => ({
                                    ...prevApiData,
                                    [field.fieldName]: apiDropdownData[field.fieldName]
                                }))
                            }else{
                                if(dependencyField !== undefined && dependencyField.value !== ''){
                                    if(apiDropdownData[field.fieldName]){
                                        let filteredlist = apiDropdownData[field.fieldName].filter(state => state.valueId === dependencyField.value)

                                        setModifiedApiDropdownData(prevApiData => ({
                                            ...prevApiData,
                                            [field.fieldName]: filteredlist
                                        }))
                                    }
                                }else{
                                    setModifiedApiDropdownData(prevApiData => ({
                                        ...prevApiData,
                                        [field.fieldName]: []
                                    }))
                                }
                            }
                        }
                        if(field.dbColumnName.toLowerCase() === 'cityid'){
                            let dependencyField = section.fieldsList.find(field => field.dbColumnName.toLowerCase() === 'stateid')

                            if(apiDropdownData[field.fieldName] && apiDropdownData[field.fieldName]?.length === 1){
                                setModifiedApiDropdownData(prevApiData => ({
                                    ...prevApiData,
                                    [field.fieldName]: apiDropdownData[field.fieldName]
                                }))
                            }else{
                                if(dependencyField !== undefined && dependencyField.value !== ''){
                                    if(apiDropdownData[field.fieldName]){
                                        let filteredlist = apiDropdownData[field.fieldName].filter(state => state.valueId === dependencyField.value)
    
                                        setModifiedApiDropdownData(prevApiData => ({
                                            ...prevApiData,
                                            [field.fieldName]: filteredlist
                                        }))
                                    }
                                }else{
                                    setModifiedApiDropdownData(prevApiData => ({
                                        ...prevApiData,
                                        [field.fieldName]: []
                                    }))
                                }
                            }
                            
                        }
                        if(field.dbColumnName.toLowerCase() === 'pcityid'){
                            let dependencyField = section.fieldsList.find(field => field.dbColumnName.toLowerCase() === 'pstateid')

                            if(apiDropdownData[field.fieldName] && apiDropdownData[field.fieldName]?.length === 1){
                                setModifiedApiDropdownData(prevApiData => ({
                                    ...prevApiData,
                                    [field.fieldName]: apiDropdownData[field.fieldName]
                                }))
                            }else{
                                if(dependencyField !== undefined && dependencyField.value !== ''){
                                    if(apiDropdownData[field.fieldName]){
                                        let filteredlist = apiDropdownData[field.fieldName].filter(state => state.valueId === dependencyField.value)

                                        setModifiedApiDropdownData(prevApiData => ({
                                            ...prevApiData,
                                            [field.fieldName]: filteredlist
                                        }))
                                    }
                                }else{
                                    setModifiedApiDropdownData(prevApiData => ({
                                        ...prevApiData,
                                        [field.fieldName]: []
                                    }))
                                }
                            }
                        }
                        if(field.dbColumnName.toLowerCase() === 'centreid'){
                            let dependencyField = section.fieldsList.find(field => field.dbColumnName.toLowerCase() === 'centredistrictid')
                            if(apiDropdownData[field.fieldName] && apiDropdownData[field.fieldName]?.length === 1){
                                setModifiedApiDropdownData(prevApiData => ({
                                    ...prevApiData,
                                    [field.fieldName]: apiDropdownData[field.fieldName]
                                }))
                                // let dropdownArray = apiDropdownData[field.fieldName]
                                // setInputValue((prevInputValue) => ({
                                //     ...prevInputValue,
                                //     [field.fieldName]: dropdownArray[0].key.toString()
                                // }))
                            }else{
                                if(dependencyField !== undefined && dependencyField.value !== ''){
                                    if(apiDropdownData[field.fieldName]){
                                        let filteredlist = apiDropdownData[field.fieldName].filter(centre => centre.valueId === dependencyField.value)
                                        setModifiedApiDropdownData(prevApiData => ({
                                            ...prevApiData,
                                            [field.fieldName]: filteredlist
                                        }))
                                    } 
                                }else{
                                    setModifiedApiDropdownData(prevApiData => ({
                                        ...prevApiData,
                                        [field.fieldName]: []
                                    }))
                                }
                            }
                            
                        }
                    })
                })
            }
        }
    }, [apiDropdownData])

    // auto-select dropdown value if only one option is available
    useEffect(() => {
        if(data){
            let section = data.sections.find(section => section.sectionId === id)
            if(section && section.isMultipleFields !== 1){
                if(modifiedApiDropdownData){
                    Object.keys(modifiedApiDropdownData).forEach((key) => {
                        if (modifiedApiDropdownData[key]?.length === 1) {
                            // If the array length is 1, set its value in inputValue
                            data.sections.forEach((section) => {
                                // Iterate through fieldsList in each section
                                if(section.isMultipleFields !== 1){
                                    section.fieldsList.forEach((field) => {
                                        if (field.fieldName === key) {
                                            const dropdownArray = modifiedApiDropdownData[key];

                                            inputValue.current = {
                                                ...inputValue.current,
                                                [field.fieldName]: dropdownArray[0].key.toString()
                                            };

                                            if(section.isMultipleFields !== 1){
                                                const isCreated = createObject(field, dropdownArray[0].key.toString())
                                               
                                            }
                                        }
                                    });
                                }
                            });
                        }
                    });
                    
                }
            }
        }

    },[modifiedApiDropdownData])

    const focusedFieldRef = useRef(null);
    const backButtonRef = useRef(null);
    const saveButtonRef = useRef(null);

    const handleKeyDown = (event, currentFieldName, fields, options = null) => {
        if (event.key === 'Tab') {
            event.preventDefault(); // Prevent default tab behavior
    
             // Sort fields by sequence
            const sortedFields = fields.sort((a, b) => a.sequence - b.sequence);

            // Find the current field's index based on sequence
            const currentIndex = sortedFields.findIndex(field => field.fieldName === currentFieldName);
    
            if (event.shiftKey) {
                // Handle Shift+Tab to move to the previous field or radio button options
                if (options && options.length > 0) {
                    // Handle navigation within the radio button options
                    const currentOptionIndex = options.findIndex((option, index) =>
                        inputRefs.current[`${currentFieldName}-${index}`] === document.activeElement
                    );
    
                    if (currentOptionIndex > 0) {
                        // Focus on the previous radio button option
                        const prevOptionRef = inputRefs.current[`${currentFieldName}-${currentOptionIndex - 1}`];
                        if (prevOptionRef) {
                            prevOptionRef.focus();
                            return;
                        }
                    } else if (currentOptionIndex === 0) {
                        // Move to the previous field before the first radio button option
                        let prevIndex = currentIndex - 1;
                        while (prevIndex >= 0) {
                            const prevField = sortedFields[prevIndex];
                            if (prevField.isActive === 1) {
                                const prevFieldName = prevField.fieldName;
    
                                if (prevField.fieldType === 'RadioButton' && prevField.fieldDataSource) {
                                    // Parse options for the previous radio button field
                                    const radioOptions = prevField.fieldDataSource
                                        .split("+")
                                        .filter(item => item)
                                        .map((item, index) => {
                                            const [key, value] = item.split("=");
                                            return { key, value, index };
                                        });
    
                                    if (radioOptions.length > 0) {
                                        const lastOptionRef = inputRefs.current[`${prevFieldName}-${radioOptions.length - 1}`];
                                        if (lastOptionRef) {
                                            lastOptionRef.focus(); // Focus on the last radio button option
                                            return;
                                        }
                                    }
                                } else if (inputRefs.current[prevFieldName]) {
                                    inputRefs.current[prevFieldName].focus(); // Focus on the previous active field
                                    return;
                                }
                            }
                            prevIndex--;
                        }
                    }
                } else {
                    // Move to the previous field
                    let prevIndex = currentIndex - 1;
                    while (prevIndex >= 0) {
                        const prevField = sortedFields[prevIndex];
                        if (prevField.isActive === 1) {
                            const prevFieldName = prevField.fieldName;
                            if (inputRefs.current[prevFieldName]) {
                                inputRefs.current[prevFieldName].focus();
                                return;
                            }
                        }
                        prevIndex--;
                    }
                }
            } 
            else {
                // Handle Tab to move to the next field or radio button options
                let nextIndex = currentIndex + 1;
                const nextField = sortedFields[nextIndex];

                // If next field is a radio button, focus its first option and prevent tabbing out
                if (nextField && (nextField.fieldType === 'RadioButton' || nextField.fieldType === 'CheckList') && nextField.fieldDataSource) {
                    const radioOptions = nextField.fieldDataSource
                        .split("+")
                        .filter(item => item)
                        .map((item, index) => {
                            const [key, value] = item.split("=");
                            return { key, value, index };
                        });

                    if (radioOptions.length > 0) {
                        const firstOptionRef = inputRefs.current[`${nextField.fieldName}-0`];
                        if (firstOptionRef) {
                            firstOptionRef.focus();
                            // Prevent default tabbing out of the radio group
                            return;
                        }
                    }
                }

                // If currently on a radio option, move to next option
                if (options && options.length > 0) {
                    const currentOptionIndex = options.findIndex((option, index) =>
                        inputRefs.current[`${currentFieldName}-${index}`] === document.activeElement
                    );

                    if (currentOptionIndex !== -1 && currentOptionIndex < options.length - 1) {
                        // Focus on the next radio button option
                        const nextOptionRef = inputRefs.current[`${currentFieldName}-${currentOptionIndex + 1}`];
                        if (nextOptionRef) {
                            nextOptionRef.focus();
                            return;
                        }
                    } else if (currentOptionIndex === options.length - 1) {
                        // Move to the next field after the last radio button option
                        nextIndex = currentIndex + 1;
                    }
                }
                let foundNext = false;
                // Now, move to the next active field as usual
                while (nextIndex < fields.length) {
                    const nextField = sortedFields[nextIndex];
                    if (nextField.isActive === 1 && nextField.fieldType !== 'Image') {
                        const nextFieldName = nextField.fieldName;
                        if ((nextField.fieldType === 'RadioButton' || nextField.fieldType === 'CheckList') && nextField.fieldDataSource) {
                            // Already handled above
                        } else if (inputRefs.current[nextFieldName]) {
                            inputRefs.current[nextFieldName].focus();
                            focusedFieldRef.current = inputRefs.current[nextFieldName];
                            foundNext = true;
                            break;
                        }
                    }
                    nextIndex++;
                }

                if (!foundNext && backButtonRef.current) {
                    backButtonRef.current.focus();
                }
            }
           
        }
    };

    // Customized fields
    const Input = 
    forwardRef(({ value, sx, onBlur, onChange, type, name, isMultipleFields, ...rest }, ref) => {
        let inputDate = null
        let sec = data?.sections.find(section=>section.sectionId === rest?.sectionId)
        let fields = sec?.fieldsList
        const imageInputRef = useRef(null);
        const inputValueRef = useRef("");

        switch (type) {
            case "Text":                
                return (
                    <ScreenView>
                        {mobileView => (
                        <TextField
                            className={
                                isRequired[rest?.fieldName] === true ? "formInputRequired" 
                                : isRequired[rest?.fieldName] === false? 'formInputField'
                                : rest?.isRequired === 1 ? "formInputRequired" : 'formInputField'
                            }
                            id={rest?.dbColumnName}
                            autoComplete="off"
                            sx={sx ? sx : { width: '100%', mt: mobileView ? 2 : 3, textAlign: 'left', 
                            // ...(rest?.visibleToStudent === '2' && { display: 'none' })
                            }}
                            name={rest?.fieldName}
                            maxLength={rest?.maxLength}
                            inputRef={(ref) => {
                                inputRefs.current[rest?.fieldName] = ref; // store the ref in the inputRefs object
                            }}
                            // onClick={() => {
                            //     inputRefs[rest?.fieldName].focus(); // focus on the current input field when clicked
                            // }}
                            onClick={() => {
                                if (inputRefs.current[rest?.fieldName]) {
                                  inputRefs.current[rest?.fieldName].focus(); // Set focus on the clicked field
                                  focusedFieldRef.current = inputRefs.current[rest?.fieldName]; // Update the focusedFieldRef
                                }
                            }}
                            defaultValue={(inputValue.current?.[rest?.fieldName] ? inputValue.current?.[rest?.fieldName]  : 
                                debData?.[rest?.fieldName] !== undefined ? debData?.[rest?.fieldName] :
                                inputValue.current?.[rest?.fieldName] ?? (isMultipleFields === 1 ? "" : value))
                            }
                            // defaultValue={initialValue.current}
                            onBlur={(e) => {onBlur(e.target.value, e.target.value, e.target)}}
                            disabled={!!disabledFields[rest?.fieldName] || isDebFieldLocked(rest)}
                            // rest?.sectionId === 5 || rest?.sectionId === 6 ? "":
                            
                            onKeyDown={(event) => handleKeyDown(event, rest?.fieldName, fields)} 
                            inputProps={{ style: { 
                                ...(rest?.inputCase === 'U' && {textTransform: "uppercase"}), 
                                ...(rest?.inputCase === 'C' && {textTransform: "capitalize"}),
                                ...(rest?.inputCase === 'L' && {textTransform: "lowercase"})  
                            } }}
                            onChange={(e) => onChange(e.target.value, e.target)}
                            required={isRequired[rest?.fieldName]} 

                            InputProps={{
                                autoComplete: "new-password",
                                readOnly: (
                                    (loggedInUser === 'admin' && sessionStorage.getItem('actionType') !== 'Edit') || 
                                    (
                                        rest?.dbColumnName.toLowerCase() === 'emailid' &&
                                        debData?.[rest?.fieldName] !== undefined &&
                                        debData?.[rest?.fieldName] !== ''
                                    ) ||
                                    (
                                        (rest?.dbColumnName.toLowerCase() === 'firstname' || 
                                         rest?.dbColumnName.toLowerCase() === 'lastname' ||
                                        //  rest?.dbColumnName.toLowerCase() === 'emailid' ||
                                         rest?.dbColumnName.toLowerCase() === 'abc_id'
                                        ) && 
                                        (
                                        (inputValue.current?.[rest?.fieldName]?.trim() || debData?.[rest?.fieldName]?.trim()) !== undefined &&
                                        (inputValue.current?.[rest?.fieldName]?.trim() || debData?.[rest?.fieldName]?.trim() || value?.trim()) !== ''
                                        )
                                        // ((inputValue?.[rest?.fieldName]?.trim() !== '' || inputValue?.[rest?.fieldName] !== undefined)|| 
                                        //  (debData?.[rest?.fieldName]?.trim() !== '' || debData?.[rest?.fieldName] !== undefined) || 
                                        //  value?.trim() !== ''
                                        // )
                                    ) ||
                                    (
                                        rest?.dbColumnName.toLowerCase() === 'mobileno' &&
                                        (
                                          (inputValue.current?.[rest?.fieldName] && /^\d{10}$/.test(inputValue.current?.[rest?.fieldName]?.trim())) ||
                                          (debData?.[rest?.fieldName] && /^\d{10}$/.test(debData?.[rest?.fieldName]?.trim())) ||
                                          (value && /^\d{10}$/.test(value?.trim()))
                                        )
                                    ) ||
                                    (debEnable !== null && debEnable === 1 && rest?.dbColumnName.toLowerCase() === 'abc_id' && 
                                        (inputValue.current?.[rest?.fieldName]?.trim() !== '' || 
                                         debData?.[rest?.fieldName]?.trim() !== '' || 
                                         value?.trim() !== ''
                                        )
                                    )
                                ),
                                endAdornment: (
                                <>
                                {/* && rest?.isRequired === 1 */}
                                    {Object.entries(textError).length > 0 &&
                                        Object.entries(textError).map(([name, { isError, errorMessage }]) =>
                                            isError === true && rest?.fieldName === name && (
                                                <InputAdornment key={name} position="end">
                                                    <Popup trigger={<ErrorIcon sx={{ color: 'red' }} />} on='hover' position="top center">
                                                        <Box sx={{ width: '100%' }}>{errorMessage}</Box>
                                                    </Popup>
                                                </InputAdornment>
                                            ) 
                                        )
                                    }

                                    {rest?.dbColumnName === 'AadharNo' && kycFlag === 1 &&
                                        <InputAdornment position="end">
                                            <Button 
                                                className="additional-button"
                                                disabled= {isAadhaarVerified}
                                                onMouseDown={(event) => {
                                                    event.preventDefault(); // prevent button from capturing focus
                                                    onBlur(inputRefs[rest?.fieldName].value, inputRefs[rest?.fieldName])
                                                    verifyAadhaar()
                                                }}
                                                sx={{
                                                    width:mobileView ? '108px' : '156px',
                                                    color: isAadhaarVerified ? '#fff' : '#484848',
                                                    border: isAadhaarVerified ? '0.5px solid #29BF12' : '0.5px solid #FEBF00',
                                                    background: isAadhaarVerified ? '#29BF12' : '#FEBF00',
                                                    '&:disabled': { // add a separate rule for the disabled state
                                                        color: '#fff', // set the color to #fff when the button is disabled
                                                    },
                                                    disabled: {buttonLoading}
                                                }}  
                                                // onClick={verifyAadhaar}
                                            >{isAadhaarVerified ? 'Verified' : buttonLoading[rest?.fieldName] && buttonLoading['isDelete'] === false ? 
                                                <CircularProgress
                                                    size={24}
                                                    sx={{
                                                    color: 'green[500]',
                                                    position: 'absolute',
                                                    top: '50%',
                                                    left: '50%',
                                                    marginTop: '-12px',
                                                    marginLeft: '-12px',
                                                    }}
                                                /> : 'Verify'}
                                            </Button>
                                        </InputAdornment>
                                    }

                                    {rest?.dbColumnName === 'DebId' && debEnable !== null && debEnable === 1 && !isDebOptionalByDependency(rest) &&
                                        <InputAdornment position="end">
                                            <Button 
                                                className="additional-button"
                                                disabled= {isDebVerified}
                                                onMouseDown={(event) => {
                                                    event.preventDefault(); // prevent button from capturing focus
                                                    // handleInputChange(inputRefs[rest?.fieldName].value, inputRefs[rest?.fieldName].fieldType, inputRefs[rest?.fieldName].fieldName, inputRefs[rest?.fieldName], 0, inputRefs[rest?.fieldName].value)
                                                    onBlur(inputRefs[rest?.fieldName]?.value, inputRefs[rest?.fieldName])
                                                    verifyDebId(rest?.sectionId)
                                                }}
                                                sx={{
                                                    width:mobileView ? '108px' : '156px',
                                                    color: isDebVerified ? '#fff' : '#484848',
                                                    border: isDebVerified ? '0.5px solid #29BF12' : '0.5px solid #FEBF00',
                                                    background: isDebVerified ? '#29BF12' : '#FEBF00',
                                                    '&:disabled': { // add a separate rule for the disabled state
                                                        color: '#fff', // set the color to #fff when the button is disabled
                                                    },
                                                    disabled: {loading}
                                                }}  
                                                // onClick={verifyAadhaar}
                                            >{isDebVerified ? 'Verified' : buttonLoading[rest?.fieldName] ? 
                                                <CircularProgress
                                                    size={24}
                                                    sx={{
                                                    color: 'green[500]',
                                                    position: 'absolute',
                                                    top: '50%',
                                                    left: '50%',
                                                    marginTop: '-12px',
                                                    marginLeft: '-12px',
                                                    }}
                                                /> : 'Verify'}
                                            </Button>
                                        </InputAdornment>
                                    }
                                </>
                                )
                            }}
                            
                        />  
                        )}
                    </ScreenView>
                );
                break;
            case "TextArea":
                return (
                    <>
                    <Textarea minRows={2} 
                        className={
                            isRequired[rest?.fieldName] === true ? "formTextareaRequired" 
                            : isRequired[rest?.fieldName] === false? 'formTextarea'
                            : rest?.isRequired === 1 ? "formTextareaRequired" : 'formTextarea'
                        }
                        id={rest?.dbColumnName}
                        autoComplete="off"
                        sx={sx ? sx :{ width: '100%', mt:3, textAlign: 'left' }}
                        maxLength={rest?.maxLength}
                        onBlur={(e) => onBlur(e.target.value, e.target.value)}
                        // ref={textareaRef}
                        // onClick={() => {
                        //     textareaRef.current.focus(); // focus on the current input field when clicked
                        // }}
                        inputRef={(ref) => {
                            inputRefs.current[rest?.fieldName] = ref; // store the ref in the inputRefs object
                        }}
                        onClick={() => {
                            if (inputRefs.current[rest?.fieldName]) {
                              inputRefs.current[rest?.fieldName].focus(); // Set focus on the clicked field
                              focusedFieldRef.current = inputRefs.current[rest?.fieldName]; // Update the focusedFieldRef
                            }
                        }}
                        onKeyDown={(event) => handleKeyDown(event, rest?.fieldName, fields)} 
                        tabIndex={rest?.sequence}
                        // rest?.sectionId === 5 || rest?.sectionId === 6 ? "": 
                        defaultValue={inputValue.current[rest?.fieldName] || '' || (isMultipleFields === 1 ? "" : value)}
                        readOnly={loggedInUser === 'admin' && sessionStorage.getItem('actionType') !== 'Edit' }
                        // readOnly={(loggedInUser === 'student' || (loggedInUser === 'admin' && sessionStorage.getItem('actionType') !== 'Edit')) ? false : true}
                        required={isRequired[rest?.fieldName]}
                    />
                    {Object.entries(textError).length > 0 &&
                        Object.entries(textError).map(([name, { isError, errorMessage }]) => (
                            isError === true &&
                            rest?.fieldName === name && (
                            <Typography className="error-message" key={name}>
                                {errorMessage}
                            </Typography>
                        )
                    ))}
                    </>
                    
                );
                break;
            case "RadioButton":
                const radio = rest.fieldDataSource
                const option = radio
                    .split("+")
                    .filter(item => item) // Remove empty items
                    .map(item => {
                        const [key, value] = item.split("=");
                        return {key, value} ;
                    });
                return(
                    <ScreenView>{mobileView => (
                    <>
                    <Typography sx={{fontSize: '16px', mt:2}}>{rest?.fieldName}</Typography>
                    <RadioGroup row
                        defaultValue={radioButtonValue[rest?.fieldName] || inputValue.current[rest?.fieldName] || '' || (isMultipleFields === 1 ? "":value)}
                        sx={{ 
                            mt:0.5,
                            height: 'auto' , 
                            flexFlow: 'wrap',
                            border: '0.5px solid rgba(0, 0, 0, 0.26)',
                            borderRadius: '4px',
                            borderLeft: isRequired[rest?.fieldName] === true ? '2px solid red' : isRequired[rest?.fieldName] === false? '' : rest?.isRequired === 1 ? "2px solid red" : '',
                        }}
                        id={rest?.dbColumnName}
                    >
                        {option
                            .filter((selectOption, index) => {
                                // If annextureType is "Annexure II" and fieldId is 52, exclude the first option
                                if (annextureType && annextureType === "Annexure II" && rest?.fieldId === 52 && index === 0) {
                                    return false;
                                }
                                return true;
                            })
                            .map((selectOption, index) => (
                                <FormControlLabel
                                    key={index}
                                    value={selectOption.key}
                                    control={ <Radio name={rest?.fieldName} 
                                        inputRef={(ref) => {
                                            inputRefs.current[`${rest?.fieldName}-${index}`] = ref; // Store ref for each option
                                        }}
                                    />}
                                    label={selectOption.value}
                                    InputLabelProps={{ shrink: false }}
                                    sx={{ml: 1, mr:0, ml:0}}
                                    disabled={(loggedInUser === 'admin' && sessionStorage.getItem('actionType') !== 'Edit') || rest?.visibleToStudent === '0'}
                                    onChange={(e) => onChange(selectOption.key, e.target)}
                                    onBlur={(e) => onBlur(selectOption.key, selectOption.value, e.target)}
                                    tabIndex={rest?.sequence}
                                    inputRef={(ref) => {
                                        inputRefs.current[`${rest?.fieldName}-${index}`]  = ref; // store the ref in the inputRefs object
                                    }}
                                    onClick={() => {
                                        if (inputRefs.current[`${rest?.fieldName}-${index}`] ) {
                                          inputRefs.current[`${rest?.fieldName}-${index}`] .focus(); // Set focus on the clicked field
                                          focusedFieldRef.current = inputRefs.current[`${rest?.fieldName}-${index}`] ; // Update the focusedFieldRef
                                        }
                                    }}
                                    onKeyDown={(event) => handleKeyDown(event, rest?.fieldName, fields, option)}
                                    required={isRequired[rest?.fieldName]}
                                    
                                />
                            ))}
                        
                    </RadioGroup> 
                    {Object.entries(textError).length > 0 &&
                        Object.entries(textError).map(([name, { isError, errorMessage }]) => (
                            isError === true &&
                            rest?.fieldName === name && (
                                <Typography className="error-message" key={name}>
                                    {errorMessage}
                                </Typography>
                            )
                        ))
                    }
                    </>
                    )}</ScreenView>
                );
                break;
            case "DropDown":
                if(rest?.fieldDataSourceType === 'API') {
                    return (
                        <>
                        <Autocomplete
                            className={
                                isRequired[rest?.fieldName] === true
                                    ? "form-dropdown-require"
                                    : isRequired[rest?.fieldName] === false
                                    ? "form-dropdown"
                                    : rest?.isRequired === 1
                                    ? "form-dropdown-require"
                                    : "form-dropdown"
                            }
                            id={rest?.dbColumnName}
                            options={(() => {
                                const baseOptions = modifiedApiDropdownData?.[rest?.fieldName] || [];
                                // If annextureType is "Annexure II" and fieldId is 52, exclude the first option
                                if (annextureType && annextureType === "Annexure II" && rest?.fieldId === 52 && baseOptions.length > 0) {
                                    return baseOptions.slice(1); // Remove first option
                                }
                                return baseOptions;
                            })()}
                            filterOptions={(options, state) => {
                                const input = state.inputValue.trim().toLowerCase();
                                inputValueRef.current = input;
                        
                                if (input.length >= 3) {
                                    return options.filter((option) =>
                                        option.value.toLowerCase().includes(input)
                                    );
                                } else {
                                    return options.slice(0, 100); // default short list
                                }
                            }}
                            getOptionLabel={(option) => option.value || ""}
                            isOptionEqualToValue={(option, value) => option.key === value.key}
                            value={
                                modifiedApiDropdownData?.[rest?.fieldName]?.find(
                                    (opt) =>
                                    opt.key === (
                                        inputValue.current[rest?.fieldName] ||
                                        (isMultipleFields === 1 ? '' : value)
                                    )
                                ) || null
                            }
                            onChange={(event, newValue) => {
                                handleDropdownChange(rest?.fieldName, newValue?.key || "", rest);
                            }}
                            tabIndex={rest?.sequence}
                            onKeyDown={(event) => handleKeyDown(event, rest?.fieldName, fields)} 
                            onClick={() => {
                                if (inputRefs.current[rest?.fieldName]) {
                                  inputRefs.current[rest?.fieldName].focus(); // Set focus on the clicked field
                                  focusedFieldRef.current = inputRefs.current[rest?.fieldName]; // Update the focusedFieldRef
                                }
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    autoComplete="off"
                                    variant="outlined"
                                    required={isRequired[rest?.fieldName]}
                                    inputRef={(ref) => {
                                        inputRefs.current[rest?.fieldName] = ref; // store the ref in the inputRefs object
                                    }}
                                    InputProps={{
                                        ...params.InputProps,
                                        autoComplete: "new-password", // disable autocomplete and autofill
                                        readOnly:
                                            loggedInUser === "admin" &&
                                            sessionStorage.getItem("actionType") !== "Edit",
                                        sx: {
                                                padding: '3px 9px !important' , // sets padding inside the actual input box
                                            },
                                    }}
                                    inputProps={{
                                        ...params.inputProps,
                                        autoComplete: "off",
                                        name: `no-autofill-${Math.random().toString(36).substr(2, 9)}`,
                                        id: `no-autofill-${Math.random().toString(36).substr(2, 9)}`,
                                    }}
                                />
                            )}
                            disabled={
                                (loggedInUser === "admin" &&
                                sessionStorage.getItem("actionType") !== "Edit") || rest?.visibleToStudent === '0'
                            }
                            sx={{ mt: 3, width: "100%" }}
                        />
                        {Object.entries(textError).length > 0 &&
                            Object.entries(textError).map(([name, { isError, errorMessage }]) => (
                                isError === true &&
                                rest?.fieldName === name && (
                                <Typography className="error-message" key={name}>
                                    {errorMessage}
                                </Typography>
                            )
                        ))}
                        </>
                    )
                }
                if (rest?.fieldDataSourceType === 'TXT') {
                    const options = rest.fieldDataSource
                    const keyValuePairs = options
                        .split("+")
                        .filter(item => item) // Remove empty items
                        .map(item => {
                            // const [key, value] = item.split("=");
                            // return {key, value} ;
                            const parts = item.split("=");
                            const key = parts[0];
                            const value = parts[1] || "";

                            if (parts[2] !== undefined && parts[2] === '1') {
                            const sectionId = rest.sectionId || "defaultSection"; // Use actual section identifier

                            // Initialize section if it doesn't exist
                            if (!requiredKeys.current[sectionId]) {
                                requiredKeys.current[sectionId] = {};
                            }

                            // Initialize the fieldName array if it doesn't exist within the section
                            if (!requiredKeys.current[sectionId][rest.fieldName]) {
                                requiredKeys.current[sectionId][rest.fieldName] = [];
                            }

                            // Add value to the section->field array if not already present
                            if (!requiredKeys.current[sectionId][rest.fieldName].includes(value)) {
                                requiredKeys.current[sectionId][rest.fieldName].push(value);
                            }
                            }

                            return { key, value };
                            
                            
                            // if (parts[2] !== undefined && parts[2] === '1') {
                            //     // Initialize the field array if it doesn't exist
                            //     if (!requiredKeys.current[rest.fieldName]) {
                            //         requiredKeys.current[rest.fieldName] = [];
                            //     }
                                
                            //     // Add value to the field's array if not already present
                            //     if (!requiredKeys.current[rest.fieldName].includes(value)) {
                            //         requiredKeys.current[rest.fieldName].push(value);
                            //     }
                            // }

                            // return { key, value };
                        });
                    return (
                        <ScreenView>{mobileView => (
                        <>
                        <Select
                            className={
                                isRequired[rest?.fieldName] === true ? "form-dropdown-require" 
                                : isRequired[rest?.fieldName] === false? 'form-dropdown'
                                : rest?.isRequired === 1 ? "form-dropdown-require" : 'form-dropdown'
                            }
                            id={rest?.dbColumnName}
                            defaultValue={inputValue.current[rest?.fieldName] || '' || (isMultipleFields === 1 ? "" : value)}
                            sx={{mt: mobileView ? 3 : 3, width: '100%'}}
                            displayEmpty
                            MenuProps={{ PaperProps: { sx: { maxHeight: '25%', minWidth: '454px !important' } } }}    // Height of dropdown
                            MuiMenuItem = {{
                                styleOverrides: {
                                    root: {
                                        // fontFamily: "Open Sauce Sans !important",
                                    }
                                }
                            }}
                            inputRef={(ref) => {
                                inputRefs.current[rest?.fieldName] = ref; // store the ref in the inputRefs object
                            }}
                            onClick={() => {
                                if (inputRefs.current[rest?.fieldName]) {
                                  inputRefs.current[rest?.fieldName].focus(); // Set focus on the clicked field
                                  focusedFieldRef.current = inputRefs.current[rest?.fieldName]; // Update the focusedFieldRef
                                }
                            }}
                            onKeyDown={(event) => handleKeyDown(event, rest?.fieldName, fields)} 
                            tabIndex={rest?.sequence}
                            onBlur={(e) => onBlur(e.target.value, e.target.value)}
                            inputProps={{ readOnly: loggedInUser === 'admin' && sessionStorage.getItem('actionType') !== 'Edit' }}
                            disabled={rest?.visibleToStudent === '0'}
                            required={isRequired[rest?.fieldName]}
                            onChange={(e) => { onChange(e.target.value, e.target, rest); setDependencyTick(t => t + 1); }}
                        >
                            {keyValuePairs
                                .filter((selectOption, index) => {
                                    // If annextureType is "Annexure II" and fieldId is 52, exclude the first option
                                    if (annextureType && annextureType === "Annexure II" && rest?.fieldId === 52 && index === 0) {
                                        return false;
                                    }
                                    return true;
                                })
                                .filter((selectOption) => {
                                    // Apply fieldDependencies: hide options whose key matches the selected value of a dependency field,
                                    // and also hide options that share categoryId with a dependency-field's selected option.
                                    if (!rest?.fieldDependencies || rest.fieldDependencies.length === 0) {
                                        return true;
                                    }
                                    const optionCategoryId = subjectList?.find(s => String(s.dropdownFieldId) === String(selectOption.key))?.categoryId;
                                    for (const dep of rest.fieldDependencies) {
                                        const depSectionId = Number(dep.sectionId);
                                        const depFieldId = Number(dep.fieldId);
                                        const depSection = data?.sections.find(s => s?.sectionId === depSectionId);
                                        const depField = depSection?.fieldsList.find(f => f?.fieldId === depFieldId);
                                        if (!depField) continue;
                                        const depSelectedValue = inputValue.current?.[depField.fieldName] || depField.value;
                                        if (depSelectedValue === undefined || depSelectedValue === null || depSelectedValue === '') continue;
                                        const operator = dep.operator || '=';
                                        if (operator === '=') {
                                            if (String(depSelectedValue) === String(selectOption.key)) {
                                                return false;
                                            }
                                            const depCategoryId = subjectList?.find(s => String(s.dropdownFieldId) === String(depSelectedValue))?.categoryId;
                                            if (depCategoryId !== undefined && optionCategoryId !== undefined && depCategoryId === optionCategoryId) {
                                                return false;
                                            }
                                        }
                                    }
                                    return true;
                                })
                                .map((selectOption, index) => (
                                    <MenuItem key={index} value={selectOption.key}>{selectOption.value}</MenuItem>
                                ))
                            }
                        </Select>
                        {Object.entries(textError).length > 0 &&
                            Object.entries(textError).map(([name, { isError, errorMessage }]) => (
                                isError === true &&
                                rest?.fieldName === name && (
                                <Typography className="error-message" key={name}>
                                    {errorMessage}
                                </Typography>
                            )
                        ))}
                        </>
                        )}</ScreenView>
                    );
                }
                break;
            case "Date":
                const dateFromDb = dayjs(value);
                inputDate = dayjs(inputValue.current[rest?.fieldName])

                return(
                    <ScreenView>{mobileView => (
                    <>
                    {mobileView ? (
                        <TextField
                            className={
                                isRequired[rest?.fieldName] === true ? "formInputRequired" 
                                : isRequired[rest?.fieldName] === false? 'formInputField'
                                : rest?.isRequired === 1 ? "formInputRequired" : 'formInputField'
                            }
                            id={rest?.dbColumnName}
                            autoComplete="off"
                            sx={{ width: '100%', mt: 2, textAlign: 'left' }}
                            name={rest?.fieldName}
                            placeholder="DD/MM/YYYY"
                            defaultValue={
                                debData?.[rest?.fieldName] !== undefined && debData?.[rest?.fieldName] !== "" 
                                    ? dayjs(debData?.[rest?.fieldName]).format('DD/MM/YYYY')
                                    : (pickedData.current?.[rest?.fieldName] !== null && pickedData.current?.[rest?.fieldName] !== undefined 
                                        ? dayjs(pickedData.current?.[rest?.fieldName]).format('DD/MM/YYYY')
                                        : (isMultipleFields === 1 ? "" : (dateFromDb.isValid() ? dateFromDb.format('DD/MM/YYYY') : "")))
                            }
                            inputRef={(ref) => {
                                inputRefs.current[rest?.fieldName] = ref;
                            }}
                            onClick={() => {
                                if (inputRefs.current[rest?.fieldName]) {
                                    inputRefs.current[rest?.fieldName].focus();
                                    focusedFieldRef.current = inputRefs.current[rest?.fieldName];
                                }
                            }}
                            onChange={(e) => {
                                const inputValue = e.target.value;
                                // Only allow numbers and forward slashes, and limit length
                                const formattedValue = inputValue.replace(/[^\d/]/g, '').substring(0, 10);
                                
                                // Auto-format as user types, but don't do complex validation here
                                let formatted = formattedValue;
                                if (formattedValue.length >= 2 && formattedValue.indexOf('/') === -1) {
                                    formatted = formattedValue.substring(0, 2) + '/' + formattedValue.substring(2);
                                }
                                if (formatted.length >= 5) {
                                    const slashCount = (formatted.match(/\//g) || []).length;
                                    
                                    if (slashCount === 1) {
                                        // We have DD/MM, now add the second slash
                                        formatted = formatted.substring(0, 5) + '/' + formatted.substring(5);
                                    }
                                }
                                
                                // Update the input value without triggering complex validation
                                e.target.value = formatted.substring(0, 10);
                                
                                // Don't call handleDateChange or validation here - save it for onBlur
                                // This reduces conflicts between onChange and onBlur
                            }}

                            onBlur={(e) => {
                                const inputValue = e.target.value;
                                
                                // Clear any existing timeout that might interfere
                                if (window.dateBlurTimeout) {
                                    clearTimeout(window.dateBlurTimeout);
                                }
                                
                                // Use setTimeout to ensure the blur event completes properly
                                window.dateBlurTimeout = setTimeout(() => {
                                    if (inputValue.length === 10) {
                                        const [day, month, year] = inputValue.split('/');
                                        const currentYear = new Date().getFullYear();
                                        
                                        
                                        // Validate year - should not be greater than current year
                                        if (parseInt(year) > currentYear) {
                                            setTextError(prevTextError => ({
                                                ...prevTextError,
                                                [rest?.fieldName]: { 
                                                    isError: true, 
                                                    errorMessage: `Year cannot be greater than ${currentYear}` 
                                                },
                                            }));
                                            // Don't return here, continue to call handleDateClose
                                        }
                                        
                                        // Use a more explicit date parsing approach
                                        const date = dayjs(`${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`, 'YYYY-MM-DD', true);
                                        
                                        if (date.isValid()) {
                                            
                                            // Additional check: ensure the date is not in the future
                                            if (date.isAfter(dayjs())) {
                                                setTextError(prevTextError => ({
                                                    ...prevTextError,
                                                    [rest?.fieldName]: { 
                                                        isError: true, 
                                                        errorMessage: 'Date cannot be in the future' 
                                                    },
                                                }));
                                                // Don't return here, continue to call handleDateClose
                                            } else {
                                                // Clear any previous errors only if date is valid and not in future
                                                setTextError(prevTextError => ({
                                                    ...prevTextError,
                                                    [rest?.fieldName]: { 
                                                        isError: false, 
                                                        errorMessage: '' 
                                                    },
                                                }));
                                            }
                                            
                                            const formattedDate = date.format('YYYY-MM-DD');
                                            
                                            // Update pickedData.current to store the dayjs object for handleDateClose (same as desktop)
                                            pickedData.current = {
                                                ...pickedData.current,
                                                [rest?.fieldName]: date
                                            };
                                            
                                            handleDateClose(rest?.fieldName, rest, isMultipleFields);
                                            onBlur && onBlur(formattedDate);
                                        } else {
                                            // For invalid dates, still call handleDateClose but with null
                                            pickedData.current = {
                                                ...pickedData.current,
                                                [rest?.fieldName]: null
                                            };
                                            
                                            setTextError(prevTextError => ({
                                                ...prevTextError,
                                                [rest?.fieldName]: { 
                                                    isError: true, 
                                                    errorMessage: 'Please enter a valid date in DD/MM/YYYY format' 
                                                },
                                            }));
                                            
                                            // Call handleDateClose even for invalid dates
                                            handleDateClose(rest?.fieldName, rest, isMultipleFields);
                                        }
                                    } else if (inputValue.length > 0 && inputValue.length < 10) {
                                        // Incomplete date
                                        setTextError(prevTextError => ({
                                            ...prevTextError,
                                            [rest?.fieldName]: { 
                                                isError: true, 
                                                errorMessage: 'Please enter a complete date in DD/MM/YYYY format' 
                                            },
                                        }));
                                        
                                        // Call handleDateClose for incomplete dates too
                                        pickedData.current = {
                                            ...pickedData.current,
                                            [rest?.fieldName]: null
                                        };
                                        handleDateClose(rest?.fieldName, rest, isMultipleFields);
                                    } else if (inputValue.length === 0) {
                                        // Empty field
                                        pickedData.current = {
                                            ...pickedData.current,
                                            [rest?.fieldName]: null
                                        };
                                        handleDateClose(rest?.fieldName, rest, isMultipleFields);
                                    }
                                }, 100); // Small delay to ensure proper event handling
                            }}
                            onKeyDown={(event) => handleKeyDown(event, rest?.fieldName, fields)}
                            // readOnly={
                            //     (loggedInUser === 'admin' && sessionStorage.getItem('actionType') !== 'Edit') || 
                            //     (
                            //     rest?.dbColumnName.toLowerCase() === 'dob' &&
                            //     (
                            //         (inputValue.current?.[rest?.fieldName] && inputValue.current[rest.fieldName].trim() !== '') ||
                            //         (debData?.[rest?.fieldName] && debData[rest.fieldName].trim() !== '') ||
                            //         (value && value.trim() !== '')
                            //     )
                            //     )
                            // }
                            required={isRequired[rest?.fieldName]}
                            inputProps={{
                                maxLength: 10,
                                pattern: "[0-9]{2}/[0-9]{2}/[0-9]{4}"
                            }}
                        />
                    ) : (
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer sx={{ mt:mobileView? 1 : 2, 
                            // ...(rest?.visibleToStudent === '2' && { display: 'none' })
                            }} components={[ 'DatePicker', 'TimePicker', 'DateTimePicker', 'DateRangePicker',]}>
                            <DemoItem sx={{mt: 0}} componentName="DatePicker" name={rest?.fieldName} valueType="date">
                                <DatePicker 
                                    className={
                                        isRequired[rest?.fieldName] === true ? "formInputRequired" 
                                        : isRequired[rest?.fieldName] === false? 'formInputField'
                                        : rest?.isRequired === 1 ? "formInputRequired" : 'formInputField'
                                    }
                                    id={rest?.dbColumnName}
                                    onClose={(date) => handleDateClose(rest?.fieldName, rest, isMultipleFields)}
                                    format='DD/MM/YYYY'
                                    key={rest?.fieldId}
                                    name={rest?.fieldName}
                                    disableFuture
                                    maxDate = {rest?.dbColumnName === 'DOB' ? year : null}
                                    defaultValue={ debData?.[rest?.fieldName] !== undefined && debData?.[rest?.fieldName] !== "" ? dayjs(debData?.[rest?.fieldName]) : (
                                        // inputValue[rest?.fieldName] !== null && inputValue[rest?.fieldName] !== undefined ? inputDate :
                                        pickedData.current?.[rest?.fieldName] !== null && pickedData.current?.[rest?.fieldName] !== undefined ? dayjs(pickedData.current?.[rest?.fieldName]) :
                                        isMultipleFields === 1 ? null : dateFromDb !== null ? dateFromDb :
                                        // selectedDate !== null ? selectedDate[rest?.fieldName] :
                                        null
                                    )}
                                    // readOnly={
                                    //     (loggedInUser === 'admin' && sessionStorage.getItem('actionType') !== 'Edit') || 
                                    //     (
                                    //       rest?.dbColumnName.toLowerCase() === 'dob' &&
                                    //       (
                                    //         (inputValue.current?.[rest?.fieldName] && inputValue.current[rest.fieldName].trim() !== '') ||
                                    //         (value && value.trim() !== '')
                                    //       )
                                    //     )
                                    //   }
                                    onChange={(date) => handleDateChange(date, rest?.fieldName)}
                                    inputRef={(ref) => {
                                        inputRefs.current[rest?.fieldName] = ref; // store the ref in the inputRefs object
                                    }}
                                    // onClick={() => {
                                    //     if (inputRefs.current[rest?.fieldName]) {
                                    //       inputRefs.current[rest?.fieldName].focus(); // Set focus on the clicked field
                                    //       focusedFieldRef.current = inputRefs.current[rest?.fieldName]; // Update the focusedFieldRef
                                    //     }
                                    // }}
                                    slotProps={{
                                        textField: {
                                        onBlur: (e) => {
                                            handleDateClose(rest?.fieldName, rest, isMultipleFields);
                                        }
                                        }
                                    }}
                                    onKeyDown={(event) => handleKeyDown(event, rest?.fieldName, fields)} 
                                    tabIndex={rest?.sequence}
                                    required={isRequired[rest?.fieldName]}
                                />
                            </DemoItem>
                        </DemoContainer>
                    </LocalizationProvider>
                    )}
                    
                    {Object.entries(textError).length > 0 &&
                        Object.entries(textError).map(([name, { isError, errorMessage }]) => (
                            isError === true &&
                            rest?.fieldName === name && (
                                <Typography className="error-message" key={name}>
                                    {errorMessage}
                                </Typography>
                            )
                    ))}
                </>
                )}</ScreenView>
                );
                break;
            case "CheckBox":
                return (
                    <FormGroup>
                        <FormControlLabel sx={{mt: 2, ml: 0.1, width: '100%', 
                            border: '0.5px solid #dcd0d0',
                            borderLeft: (rest?.fieldRefType === 'SubjectId' && (rest?.isRequired === 1 || isRequired[rest?.fieldName])) ? '2px solid red' : '',
                            borderRadius: '4px' }} 
                            control={
                            <Checkbox
                            // id="section-one-checkbox"
                                id={rest?.dbColumnName}
                                disabled={
                                    (Number(rest?.sectionId) === 13 && rest?.fieldRefType === 'SubjectId' && (allowedOptionalSubjectIds || []).includes(String(rest?.fieldName).split(' - ')[0].trim())) ||
                                    (loggedInUser === 'admin' && sessionStorage.getItem('actionType') !== 'Edit')
                                }
                                // onBlur={(e) => onBlur(e.target.checked)}
                                // onChange={(e) => handleCheckboxChange(rest?.fieldName, e)}
                                onChange={(e) => {
                                    handleCheckboxChange(rest?.fieldName, rest, e);
                                    // handleCheckListChange(rest, rest?.fieldRefTypeId, rest?.fieldRefTypeId, e);

                                    // onBlur(e.target.checked, e.target.checked);
                                    // if (rest?.fieldRefType !== 'SubjectId') {
                                    //     onBlur(rest?.fieldRefTypeId, rest?.fieldRefTypeId);
                                    // }
                                }}
                                checked={
                                    (Number(rest?.sectionId) === 13 && rest?.fieldRefType === 'SubjectId' && (allowedOptionalSubjectIds || []).includes(String(rest?.fieldName).split(' - ')[0].trim())) ||
                                    (checked[rest?.fieldName] ?? (value === 'true' || (rest?.fieldRefType === 'SubjectId' && value === rest?.fieldRefTypeId.toString())))
                                }
                                // checked={checked[rest?.fieldName] || value === 'true' || false}
                                // checked={inputValue[rest?.fieldName] || (rest?.sectionId === 5 || rest?.sectionId === 6) ? true : value}
                            />
                            }
                            label={
                                <Typography
                                    sx={{
                                    // fontFamily: "Open Sauce Sans",
                                    fontSize: '16px',
                                    fontWeight: 400,
                                    fontStyle: 'normal'
                                    }}
                                >
                                    {rest?.fieldName}&nbsp;
                                    {(rest?.fieldRefType !== 'SubjectId' && (
                                        <span>{rest?.helpText}</span>
                                    ))}
                                    {(rest?.isRequired === 1 || isRequired[rest?.fieldName]) && (
                                        <span style={{ color: "red" }}>*</span>
                                    )}
                                </Typography>
                                
                            } 
                        />  
                        {Object.entries(textError).length > 0 &&
                            Object.entries(textError).map(([name, { isError, errorMessage }]) => (
                                isError === true &&
                                rest?.fieldName === name && (
                                    <Typography className="error-message" key={name}>
                                        {errorMessage}
                                    </Typography>
                                )
                            ))
                        }
                    </FormGroup>
                );
                break;        
            case "File":
                let uploadedFile = file !== null ? file[rest?.fieldName] : null
                let uploadedFileName = fileName !== null && fileName !== undefined ? fileName[rest?.fieldName] : null
                let fileExtension = extension !== null && extension !== undefined ? extension[rest?.fieldName] : null
                let validationState = validationError !== null ? validationError[rest?.fieldName] : null
                let uploadedFileExtension = value !== null ? value.split('.').pop() : null

                return(
                    <ScreenView>
                        {mobileView => (
                            <Box >
                                <Box sx={{width: '100%'}} >
                                <TextField
                                    className={
                                        isRequired[rest?.fieldName] === true ? "formInputRequired" 
                                        : isRequired[rest?.fieldName] === false? 'formInputField'
                                        : rest?.isRequired === 1 ? "formInputRequired" : 'formInputField'
                                    }
                                    // className={(isRequired[rest?.fieldName] ? (isRequired[rest?.fieldName] === true ? "formInputRequired" : "formInputField") : (rest?.isActive === 1 ? "formInputRequired" : "formInputField"))}
                                    // className={(rest?.isRequired === 1 && isRequired[rest?.fieldName] === true) ? "formInputRequired" : "formInputField"}
                                    id={rest?.dbColumnName}
                                    sx={{width: mobileView ? '75%' : '80%', mt:mobileView? 1 : 3}}
                                    required={isRequired[rest?.fieldName]}
                                    tabIndex={-1}
                                    inputProps={{
                                        tabIndex: -1, // This disables tab focus on the input itself
                                        // ...other inputProps if any...
                                    }}
                                    InputProps={{
                                        readOnly: loggedInUser === 'admin' && sessionStorage.getItem('actionType') !== 'Edit' ? false : true,
                                        endAdornment: (
                                            (buttonLoading[rest?.fieldName] && buttonLoading['isDelete'] ? 
                                                <>
                                                    <CircularProgress
                                                    size={24}
                                                    sx={{
                                                        color: 'green[500]',
                                                        position: 'absolute',
                                                        top: '50%',
                                                        left: '95%',
                                                        marginTop: '-12px',
                                                        marginLeft: '-12px',
                                                    }}
                                                    />
                                                </>:
                                                value !== null && value !== "" ? (
                                                    uploadedFileExtension === 'pdf' ? (
                                                    <img src={pdfIcon} style={{ width: '50px' }} alt="Uploaded file" />
                                                    ) : uploadedFileExtension === 'doc' || uploadedFileExtension === 'docx' ? (
                                                    <img src={docIcon} style={{ width: '50px' }} alt="Uploaded file doc" />
                                                    ) : uploadedFileExtension === 'png' || uploadedFileExtension === 'jpg' || uploadedFileExtension === 'jpeg' ? (
                                                    <img src={value} style={{ width: '30px' }} alt="Uploaded file image" />
                                                    ) : null
                                                ) 
                                                :<Button sx={{
                                                    background: '#d3d3d3', 
                                                    '&:hover': {
                                                    background: '#d3d3d3'
                                                    }}} 
                                                    tabIndex={-1}
                                                    variant="contained"
                                                    component="label"
                                                    
                                                >
                                                    <FilePresentIcon />
                                                </Button>
                                            )
                                        )
                                    }}
                                    placeholder={uploadedFileName !== null && uploadedFileName !== undefined ? uploadedFileName : rest?.fieldName}
                                />
                                    {value !== "" && 
                                    <>
                                    <VisibilityOutlinedIcon sx={{
                                        marginRight: '2%', 
                                        mt:3, 
                                        marginLeft: '2%', 
                                        color: '#63616a',
                                        cursor: 'pointer'
                                    }} 
                                        onClick = {() => documentPreview(rest?.fieldName, value)}
                                        // onClick={openModal}
                                    />
                                    <DeleteForeverIcon 
                                        sx={{color: '#63616a', cursor: 'pointer'}}
                                        onClick = {() => removeUploadedFile(rest?.fieldName, rest, value)}
                                        // onClick={() => setFile((prevState) => ({...prevState, [rest?.fieldName]: null}))}
                                    />
                                    </>
                                    }
                                </Box>
                                <Box sx={{display: 'flex'}}>
                                    <Typography 
                                        sx={{
                                            textAlign: 'left', width: '60%', mt:1,
                                            // fontFamily: "Open Sauce Sans",
                                            fontSize: '14px',
                                            fontStyle: 'italic',
                                            color: validationState === 'Invalid' ? 'red' : 'black'
                                        }}
                                    >
                                        {/* Hint for file type and size */}
                                        {(() => {
                                            let validTypes = '';
                                            let validMinSize = '';
                                            let validMinSizeUnit = '';
                                            let validMaxSize = '';
                                            let validMaxSizeUnit = '';

                                            rest?.fieldValidations.forEach(element => {
                                                switch (element.property) {
                                                    case 'FileType':
                                                        validTypes = element.value;
                                                        break;
                                                    case 'MinSize':
                                                        validMinSize = element.value-1;
                                                        break;
                                                    case 'MinSizeUnit':
                                                        validMinSizeUnit = element.value;
                                                        break;
                                                    case 'MaxSize':
                                                        validMaxSize = element.value;
                                                        break;
                                                    case 'MaxSizeUnit':
                                                        validMaxSizeUnit = element.value;
                                                        break;
                                                    default:
                                                        break;
                                                }
                                            });

                                            return `Format: ${validTypes} (min size: ${validMinSize+1} ${validMinSizeUnit}, max size: ${validMaxSize} ${validMaxSizeUnit})`;
                                        })()}
                                        {/* Format: .pdf, .doc, .dox (min size:{rest?.fieldValidations[0].property === 'MinSize' ? rest?.fieldValidations[0].value : 0} max size: 1 Mb) */}
                                    </Typography>
                                    <Button 
                                        sx={{
                                            mt: 1,
                                            mr: mobileView ? 8 : 10,
                                            borderColor: buttonLoading[rest?.fieldName] && buttonLoading['isDelete'] === false ? '#fff' : '#FEBF00',
                                            color: '#484848',
                                            textTransform: 'none',
                                            height: '30%',
                                            '&:hover': {
                                                borderColor: '#FEBF00',
                                                background:'#fff'
                                            },
                                        }}
                                        className="upload-button"
                                        variant="outlined"
                                        component="label"
                                        tabIndex={0}
                                        onKeyDown={e => {
                                            if (e.key === 'Enter' || e.key === ' ') {
                                                // Find the file input inside this button and trigger click
                                                const input = e.currentTarget.querySelector('input[type="file"]');
                                                if (input) input.click();
                                            }
                                        }}
                                        
                                    > 
                                        {buttonLoading[rest?.fieldName] && buttonLoading['isDelete'] === false ? 
                                        <>
                                            <CircularProgress
                                            size={24}
                                            sx={{
                                                color: 'green[500]',
                                                position: 'absolute',
                                                top: '50%',
                                                left: '50%',
                                                marginTop: '-12px',
                                                marginLeft: '-12px',
                                            }}
                                            />
                                        </>:
                                            <>
                                                <UploadOutlinedIcon />
                                                Upload
                                            </>
                                        }
                                        {(loggedInUser !== 'admin' || (loggedInUser === 'admin' && sessionStorage.getItem('actionType') === 'Edit' )) && 
                                            <input type="file" 
                                                style={{ display: 'none', width: '100%' }} 
                                                onChange={(e) => handleFile(rest?.fieldName, rest?.sectionId, rest?.fieldId, rest?.validationType, rest?.sequenceId, rest, e)}  
                                            />
                                        }
                                    </Button>
                                </Box>
                            </Box>
                        )}
                    </ScreenView>
                );
            case 'Image':
                return(
                    <ScreenView>
                        {mobileView => (
                            <Grid item>
                            <Box
                                sx={{
                                display: sec.sectionId === 2 ? 'block' : 'inline-block',
                                }}
                            >
                                <FormControl
                                sx={{
                                    width: mobileView ? '100%' : '100%',
                                    textAlign: 'left',
                                    ...(rest?.visibleToStudent === '2' || rest?.fieldType === 'HiddenField'
                                    ? { display: 'none' }
                                    : {}),
                                }}
                                >
                                {/* rest of your code */}
                                <Box
                                    sx={{
                                    flexDirection: mobileView ? 'column' : 'column',
                                    width: mobileView ? '100%' : '100%',
                                    alignItems: 'flex-start',
                                    justifyContent: 'flex-start',
                                    mt:2
                                    }}
                                >
                                    <Box
                                    sx={{
                                        display: mobileView ? 'block' : 'flex',
                                        alignItems: 'center',
                                        ...(rest?.visibleToStudent === '2' ? { display: 'none' } : {}),
                                    }}
                                    >
                                    <Typography sx={{
                                        // fontFamily: "Open Sauce Sans",
                                        fontSize: '16px',
                                        fontStyle: 'normal',
                                        lineHeight: 'normal',
                                    }}>{rest?.fieldName}
                                        { (rest?.isRequired === 1 || isRequired[rest?.fieldName]) && (
                                            <span style={{ color: '#FF0000' }}>*</span>
                                        )}
                                    </Typography>
                                    </Box>
                                    <Box sx={{display: 'flex'}}>
                                        <Box
                                            height={150}
                                            width={200}
                                            my={1}
                                            display="flex"
                                            alignItems="center"
                                            justifyContent="center"
                                            gap={4}
                                            p={2}
                                            sx={{borderRadius: '10px', border: '0.5px solid #972524', cursor: 'pointer' }}
                                            // onClick={() => {(loggedInUser !== 'admin' || (loggedInUser === 'admin' && sessionStorage.getItem('actionType') === 'Edit')) && isAadhaarVerified === false && document.getElementById(rest?.dbColumnName).click()}}
                                            onClick={() => {
                                                // Check if the conditions are met to trigger the file input
                                                if (
                                                    (loggedInUser  !== 'admin' || (loggedInUser  === 'admin' && sessionStorage.getItem('actionType') === 'Edit')) 
                                                    // && isAadhaarVerified === false
                                                ) {
                                                    // Trigger the hidden file input
                                                    imageInputRef.current.click();
                                                    // document.getElementById(field?.dbColumnName).click();
                                                }
                                            }}
                                        >
                                            {file && Object.keys(file).length !== 0 && file[rest?.fieldName] ? (
                                                <>
                                                    <img id={rest?.dbColumnName} src={file[rest?.fieldName]} style={{ width: '200px', height: '150px', borderRadius: '10px' }} alt="Uploaded file" />
                                                    {(loggedInUser !== 'admin' || (loggedInUser === 'admin' && sessionStorage.getItem('actionType') === 'Edit')) && 
                                                        // isAadhaarVerified === false &&
                                                        <input id={rest?.dbColumnName} ref={imageInputRef} type="file" style={{ display: 'none' }} onChange={(e) => handleImageChange(rest?.fieldName, rest?.sectionId, rest?.fieldId, rest, e)} onBlur={handleInputChange} />
                                                    }
                                                </>
                                                
                                                // (Object.keys(file).length !== 0 && (file[rest?.fieldName] && (file[rest?.fieldName] === undefined || file[rest?.fieldName] === null))) || (value !== null && value !== "") ?
                                            ) : (file && Object.keys(file).length !== 0 && file[rest?.fieldName]) || (value !== null && value !== "") ? (
                                                <>
                                                    <img id={rest?.dbColumnName} src={value} style={{ width: '200px', height: '150px', borderRadius: '10px' }} alt="Uploaded file" />
                                                    {(loggedInUser !== 'admin' || (loggedInUser === 'admin' && sessionStorage.getItem('actionType') === 'Edit')) &&
                                                        <input id={rest?.dbColumnName} ref={imageInputRef} type="file" style={{ display: 'none' }} onChange={(e) => handleImageChange(rest?.fieldName, rest?.sectionId, rest?.fieldId, rest, e)} onBlur={handleInputChange} />
                                                    }
                                                </>
                                                // (Object.keys(file).length === 0 || (file[rest?.fieldName] === undefined || file[rest?.fieldName] === null)) && (value === null || value === "")?     
                                            ) : (!file || Object.keys(file).length === 0) || (file || Object.keys(file).length !== 0 && !file[rest?.fieldName]) && (value === null || value === "") ? (
                                                    <Box>
                                                        <Box display="flex" alignItems="center" style={{ cursor: 'pointer' }}>
                                                            <UploadOutlinedIcon />
                                                            <span>Browse from device</span>
                                                        </Box>
                                                        {(loggedInUser !== 'admin' || (loggedInUser === 'admin' && sessionStorage.getItem('actionType') === 'Edit')) && 
                                                            // isAadhaarVerified === false &&
                                                            <input id={rest?.dbColumnName} ref={imageInputRef} type="file" style={{ display: 'none' }} onChange={(e) => handleImageChange(rest?.fieldName, rest?.sectionId, rest?.fieldId, rest, e)} onBlur={handleInputChange} />
                                                        }
                                                    </Box>
                                                ) : (value !== null && value !== "") ? (
                                                    <>
                                                    <img id={rest?.dbColumnName} src={value} style={{ width: '200px', height: '150px', borderRadius: '10px' }} alt="Uploaded file" />
                                                        {(loggedInUser !== 'admin' || (loggedInUser === 'admin' && sessionStorage.getItem('actionType') === 'Edit')) &&
                                                            <input id={rest?.dbColumnName} ref={imageInputRef} type="file" style={{ display: 'none' }} onChange={(e) => handleImageChange(rest?.fieldName, rest?.sectionId, rest?.fieldId, rest, e)} onBlur={handleInputChange} />
                                                        }
                                                    </>
                                                ) : null
                                            }

                                        </Box>
                                        {file && file[rest?.fieldName] && 
                                            // isAadhaarVerified === false && 
                                            (
                                            <DeleteForeverIcon 
                                                sx={{ cursor: 'pointer', alignSelf: 'center', ml: 2 }} 
                                                onClick={() => setFile((prevState) => {
                                                    const { [rest?.fieldName]: _, ...newFile } = prevState; // Destructure to exclude the field
                                                    return newFile; // Return the new object without the specified field
                                                })}
                                            />
                                            // <DeleteForeverIcon 
                                            //     sx={{ cursor: 'pointer', alignSelf: 'center', ml: 2 }} 
                                            //     onClick={() => setFile((prevState) => ({
                                            //         ...prevState,
                                            //         [rest?.fieldName]: null
                                            //     }))}
                                            // />
                                        )}
                                        {/* {file && file[rest?.fieldName] && isAadhaarVerified === false && <DeleteForeverIcon sx={{ cursor: 'pointer', alignSelf: 'center', ml: 2 }} 
                                        // onClick={() => setFile(null)}
                                        />
                                        } */}
                                        
                                    </Box>
                                    {Object.entries(textError).length > 0 &&
                                        Object.entries(textError).map(([name, { isError, errorMessage }]) => (
                                            isError === true &&
                                            rest?.fieldName === name && (
                                            <Typography className="error-message" key={name}>
                                                {errorMessage}
                                            </Typography>
                                        )
                                    ))}
                                    <Typography 
                                        sx={{
                                            textAlign: 'left', width: '100%', 
                                            // fontFamily: "Open Sauce Sans",
                                            fontSize: '14px',
                                            fontStyle: 'normal',
                                            color: 'black'
                                        }}
                                    >
                                        Format: {rest.fieldValidations.map((acc)=>{
                                            if (acc.property === 'FileType') {
                                                return acc.value.replace(/\,/g, ', ');
                                            } else if (acc.property === 'MinSize') {
                                                const minSizeUnit = rest.fieldValidations.find(v => v.property === 'MinSizeUnit').value;
                                                return ` , Min Size: ${acc.value}${minSizeUnit}`;
                                            } else if (acc.property === 'MaxSize') {
                                                const maxSizeUnit = rest.fieldValidations.find(v => v.property === 'MaxSizeUnit').value;
                                                return ` , Max Size: ${acc.value}${maxSizeUnit}`;
                                            }
                                            return '';
                                        }).filter(Boolean).join('')}
                                    </Typography>
                                </Box>
                                </FormControl>
                            </Box>
                            </Grid>
                        )}
                    </ScreenView>
                );
                break;
            case 'Label':
                return(
                    <TextField
                        className={
                            isRequired[rest?.fieldName] === true ? "formInputRequired" 
                            : isRequired[rest?.fieldName] === false? 'formInputField'
                            : rest?.isRequired === 1 ? "formInputRequired" : 'formInputField'
                        }
                            id={rest?.dbColumnName}
                            sx={sx ? sx : { width: '100%', mt: 3, textAlign: 'left', 
                            ...(rest?.visibleToStudent === '2' && { display: 'none' })
                            }}
                            InputProps={{
                                readOnly: true
                            }}
                            disabled = {rest?.visibleToStudent === '0' && !value} 
                            defaultValue={rest?.fieldName}
                            tabIndex={rest?.sequence}
                        />  
                )
            break;
            case 'CheckList':
                let checklist = rest.fieldDataSource
                const checks = checklist
                .split("+")
                .filter(item => item) // Remove empty items
                .map(item => {
                        const [key, value] = item.split("=");
                        return {key, value} ;
                    });

                let items = subjectValue.map(item => Object.keys(item)[0])
                let x = value.split(', ');
                
                return(
                    <ScreenView>
                        {mobileView => (  
                            (rest?.sectionId === 13 ? (
                            <Box sx={{ display: mobileView ? 'block' : 'flex', width: mobileView ? '120%' : '171%', flexDirection: 'row', flexWrap: 'wrap' }}>
                            {checks.map((selectOption, index) => (
                            <Box sx={{ marginLeft: mobileView ? '0%' : index % 2 === 1 ? '33%' : '0' }}>        
                                <TextField
                                    InputProps={{
                                        sx: {
                                            paddingLeft: mobileView ? '3px' : '14px'
                                        },
                                        readOnly: true,
                                        startAdornment: (
                                            <FormGroup>
                                                <FormControlLabel
                                                    key={index}
                                                    value={selectOption.key}
                                                    control={ <Checkbox sx={{padding: '0px'}}/>}
                                                    disabled={(loggedInUser === 'admin' && sessionStorage.getItem('actionType') !== 'Edit') || rest?.visibleToStudent === '0' }
                                                    // checked={value}
                                                    checked={
                                                        subjectValue.some(item => item[selectOption.key] === selectOption.value)
                                                        // ||x.includes(selectOption.key)
                                                    }
                                                    
                                                    onChange={(event) => {
                                                        const isChecked = event.target.checked;
                                                        if (isChecked) {                    // To check
                                                                setSubjectValue(prevSubjectValue => ([
                                                                ...prevSubjectValue,
                                                                { [selectOption.key]: selectOption.value, sequence: rest?.sequence, fieldRefTypeId: rest?.fieldRefTypeId, fieldRefType: rest?.fieldRefType, isDelete: false }
                                                            ]));
                                                        onBlur(selectOption.key, event.target)
                                                        } else {                            // To uncheck
                                                            setSubjectValue(prevSubjectValue =>
                                                                prevSubjectValue.filter(item => !(item[selectOption.key] === selectOption.value))
                                                            );
                                                        }
                                                    }}
                                                    inputRef={(ref) => {
                                                        inputRefs[rest?.fieldName] = ref; // store the ref in the inputRefs object
                                                    }}
                                                    onClick={() => {
                                                        inputRefs[rest?.fieldName].focus(); // focus on the current input field when clicked
                                                    }}
                                                    onKeyDown={(event) => {
                                                        if (event.key === 'Tab') {
                                                            event.preventDefault(); // prevent default tab behavior
                                                            const currentIndex = fields.findIndex(field => field.fieldName === rest?.fieldName);
                                                            const nextIndex = (currentIndex + 1) % fields.length; // wrap around to first field if at end
                                                            const nextFieldName = fields[nextIndex].fieldName; 
                                                            const inputDiv = inputRefs[nextFieldName];
                                                            // inputRefs[nextFieldName].focus(); // focus on the next input field
                                                            if(inputDiv){
                                                                inputDiv.focus();
                                                            }
                                                        }
                                                    }}
                                                    InputLabelProps={{ shrink: false }}
                                                    sx={{ml: 0}}
                                                    
                                                />
                                            </FormGroup>
                                        )
                                    }}
                                    className={
                                        isRequired[rest?.fieldName] === true ? "formInputRequired" 
                                        : isRequired[rest?.fieldName] === false? 'formInputField'
                                        : rest?.isRequired === 1 ? "formInputRequired" : 'formInputField'
                                    }
                                    id={rest?.dbColumnName}
                                    sx={sx ? sx : { width: '176%', mt: 3, textAlign: 'left', paddingLeft: '0px',
                                    ...(rest?.visibleToStudent === '2' && { display: 'none' })
                                    }}
                                    disabled = {rest?.visibleToStudent === '0' && !value} 
                                    defaultValue={selectOption.value}
                                    tabIndex={rest?.sequence}
                                />  
                            </Box>
                            ))}
                            </Box>)
                            :
                            (
                            <>
                            <RadioGroup row
                                // aria-labelledby="demo-row-radio-buttons-group-label"
                                // name="row-radio-buttons-group"
                                defaultValue={inputValue.current[rest?.fieldName] || '' || (isMultipleFields === 1 ? "":value)}
                                sx={{ 
                                    mt:2,
                                    height: 'auto' , 
                                    flexFlow: 'wrap',
                                    border: '0.5px solid rgba(0, 0, 0, 0.26)',
                                    borderRadius: '4px',
                                    borderLeft: (rest?.isRequired === 1 || isRequired[rest?.fieldName]) ? '2px solid red' : '',
                                    // padding: '0.5rem'
                                    // flexWrap: 'inherit'
                                }}
                                id={rest?.dbColumnName}
                            >
                                {/* <div style={{ border: '1px solid' }}> */}
                                {checks.map((selectOption, index) => (
                                    <FormControlLabel
                                        key={index}
                                        value={selectOption.key}
                                        control={ <Checkbox
                                            inputRef={(ref) => {
                                                inputRefs.current[`${rest?.fieldName}-${index}`] = ref; // Store ref for each option
                                            }}
                                        />}
                                        label={selectOption.value}
                                        InputLabelProps={{ shrink: false }}
                                        sx={{ml: 1, mr:0, ml:0}}
                                        disabled={(loggedInUser === 'admin' && sessionStorage.getItem('actionType') !== 'Edit') || rest?.visibleToStudent === '0'}
                                        // checked={checkedItems[item.name]}
                                        checked={checkedItems.current[rest?.fieldName] && checkedItems.current[rest?.fieldName][selectOption.key]}
                                        onChange={(e) => {
                                            handleCheckListChange(rest, selectOption.key, selectOption.value, e);
                                            // onBlur(selectOption.key, selectOption.key);
                                        }} 
                                        onKeyDown={(event) => handleKeyDown(event, rest?.fieldName, fields, checks)}
                                        inputRef={(ref) => {
                                            inputRefs.current[`${rest?.fieldName}-${index}`] = ref; // store the ref in the inputRefs object
                                        }}
                                        tabIndex={rest?.sequence}
                                        onClick={() => {
                                            inputRefs.current[`${rest?.fieldName}-${index}`].focus(); // focus on the current input field when clicked
                                        }}
                                        required={isRequired[rest?.fieldName]}
                                        
                                    />
                                ))}
                                {/* </div> */}
                                
                            </RadioGroup> 
                            {Object.entries(textError).length > 0 &&
                                Object.entries(textError).map(([name, { isError, errorMessage }]) => (
                                    isError === true &&
                                    rest?.fieldName === name && (
                                        <Typography className="error-message" key={name}>
                                            {errorMessage}
                                        </Typography>
                                    )
                                ))
                            }
                            </>
                            )
                            )
                        )}
                    </ScreenView>
                )
            break;
            case 'Paragraph':
                return (
                    <div
                        style={{
                            padding: 16,
                            border: '1px solid #ccc',
                            borderRadius: 4,
                            width: '113%',
                            minHeight: 100,
                            marginTop: '21px'
                        }}
                        
                    >
                        <div dangerouslySetInnerHTML={{ __html: rest?.fieldDataSource }}></div>
                    </div>
                  );
                break;
            default:
                return null;

        }

    })

    // Allowed optionalSubjectIds for section 13.
    // 1) Collect selected values from every field (any section) with non-empty fieldDependencies — these are
    //    dropdownFieldId values.
    // 2) Filter subjectList to entries whose dropdownFieldId matches a selected value.
    // 3) Intersect those optionalSubjectIds with section-13 field name prefixes.
    const allowedOptionalSubjectIds = useMemo(() => {
        if (!data || !subjectList || subjectList.length === 0) return [];
        const sec13 = data.sections.find(s => s?.sectionId === 13);
        if (!sec13) return [];

        const selectedDropdownFieldIds = data.sections.flatMap(section =>
            (section?.fieldsList || [])
                .filter(f => Array.isArray(f.fieldDependencies) && f.fieldDependencies.length > 0)
                .map(f => inputValue.current?.[f.fieldName] ?? f.value)
                .filter(v => v !== undefined && v !== null && v !== '')
                .map(v => String(v))
        );

        if (selectedDropdownFieldIds.length === 0) return [];

        const sec13Prefixes = sec13.fieldsList
            .filter(f => f.fieldRefType === 'SubjectId')
            .map(f => String(f.fieldName).split(' - ')[0].trim());

        return subjectList
            .filter(s => selectedDropdownFieldIds.includes(String(s.dropdownFieldId)))
            .map(s => String(s.optionalSubjectId).trim())
            .filter(id => sec13Prefixes.includes(id));
    }, [data, subjectList, dependencyTick]);

    // Sync auto-checked subjects into subjectValue so existing save flow includes them unchanged.
    useEffect(() => {
        if (!data) return;
        const sec13 = data.sections.find(s => s?.sectionId === 13);
        if (!sec13) return;

        const updates = {};
        sec13.fieldsList.forEach(f => {
            if (f.fieldRefType !== 'SubjectId') return;
            const prefix = String(f.fieldName).split(' - ')[0].trim();
            if (!allowedOptionalSubjectIds.includes(prefix)) return;

            const newObject = {
                sectionId: f.sectionId,
                fieldId: f.fieldId,
                sequenceId: 0,
                value: f.fieldRefTypeId.toString(),
                imageExtension: "",
                imageSize: "",
                fieldRefType: f.fieldRefType,
                fieldRefTypeId: f.fieldRefTypeId,
                fieldTypeId: f.fieldTypeId,
                isDelete: false,
            };
            const alreadyPresent = inputOnChange.current.some(
                item => item.sectionId === newObject.sectionId
                    && item.fieldId === newObject.fieldId
                    && item.fieldRefTypeId === newObject.fieldRefTypeId
            );
            if (!alreadyPresent) {
                inputOnChange.current.push(newObject);
            }
            updates[f.fieldName] = true;
        });
        if (Object.keys(updates).length > 0) {
            setChecked(prev => ({ ...prev, ...updates }));
        }
    }, [allowedOptionalSubjectIds, data]);

    // Re-seed inputOnChange for previously saved section-13 subjects on reload.
    // Why: after save, inputOnChange.current is cleared. On re-entry the checkbox
    // reflects saved state via field.value, but the save payload reads from
    // inputOnChange.current and would send listOfFields: [] without this.
    // Scope: only when active section is 11 (parent of 13), so other sections'
    // saves don't carry section-13 entries.
    useEffect(() => {
        if (!data) return;
        if (id !== 11) return;
        const sec13 = data.sections.find(s => s?.sectionId === 13);
        if (!sec13) return;

        sec13.fieldsList.forEach(f => {
            if (f.fieldRefType !== 'SubjectId') return;
            if (String(f.value) !== String(f.fieldRefTypeId)) return;

            const alreadyPresent = inputOnChange.current.some(
                item => item.sectionId === f.sectionId
                    && item.fieldId === f.fieldId
                    && item.fieldRefTypeId === f.fieldRefTypeId
            );
            if (alreadyPresent) return;

            inputOnChange.current.push({
                sectionId: f.sectionId,
                fieldId: f.fieldId,
                sequenceId: 0,
                value: f.fieldRefTypeId.toString(),
                imageExtension: "",
                imageSize: "",
                fieldRefType: f.fieldRefType,
                fieldRefTypeId: f.fieldRefTypeId,
                fieldTypeId: f.fieldTypeId,
                isDelete: false,
            });
        });
    }, [data, id]);

    // Usestate to add existing value in subjectValue list to edit
    useEffect(()=>{
        if (data !== null) {
            let sec = data.sections.find(sec => sec.sectionId === 13)

            if(sec !== undefined){
                let fields = sec.fieldsList;

                fields.map((element) =>{
                    let checklist = element.fieldDataSource

                    const checks = checklist
                    .split("+")
                    .filter(item => item) // Remove empty items
                    .map(item => {
                            const [key, value] = item.split("=");
                            return {key, value} ;
                        });

                    let savedValues = element.value 
                    let x = savedValues.split(', ');
                    const existingChecks = x.map(val => {
                        const check = checks.find(check => check.key === val);
                        if (check) {
                            return {[check.key]: check.value, sequence: element?.sequence, fieldRefTypeId: element?.fieldRefTypeId, fieldRefType: element?.fieldRefType, isDelete: false};
                        }
                        return null;
                        }).filter(Boolean);
                    if(id === 11){
                        // Merge saved subjects without duplicating ones already present.
                        // This effect re-runs every time `id` becomes 11 (e.g. navigating to a
                        // previous section and back). A plain append would re-add the saved
                        // subject on each re-entry, inflating subjectValue.length and tripping
                        // the MaxSelections check with a false "Select a maximum of N subjects" error.
                        setSubjectValue(prevSubjectValue => {
                            const existingKeys = new Set(prevSubjectValue.map(item => Object.keys(item)[0]));
                            const newChecks = existingChecks.filter(check => !existingKeys.has(Object.keys(check)[0]));
                            return [...prevSubjectValue, ...newChecks];
                        });
                        // setSubjectValue(existingChecks)
                    }
                })
            }
        }
    },[data, id])

    useEffect(() => {
        if (data !== null) {
            let sec = data.sections.find(section => section.sectionId === id && id !== 13)
            if(sec){
                let fields = sec.fieldsList
                if (fields) {
                    const checklistFields = fields.filter(element => element.fieldType === 'CheckList' && element.value !== '')
                    checklistFields.forEach(element => {
                    let checkedValue = element.value.replace(/\s+/g, '').split(','); // remove whitespace and split on commas
            
                    // checkedValue.forEach(check => {
                    //     setCheckedItems((prevCheckedItems) => ({
                    //     ...prevCheckedItems,
                    //     [element.fieldName]: {
                    //         ...prevCheckedItems[element.fieldName],
                    //         [check]: true,
                    //     },
                    //     }));
                    // })
                    checkedValue.forEach(check => {
                        if (!checkedItems.current[element.fieldName]) {
                            checkedItems.current[element.fieldName] = {};
                        }
                        checkedItems.current[element.fieldName][check] = true;
                    });
                    const isCreated = createObject(element, element.value)
                    // const fieldToSave = {
                    //     sectionId: element.sectionId,
                    //     fieldId: element.fieldId,
                    //     sequenceId: 0,
                    //     value: element.value,
                    //     imageExtension: "",
                    //     imageSize: "",
                    //     fieldRefType: "",
                    //     fieldRefTypeId: 0,
                    //     fieldTypeId: element.fieldTypeId,
                    //     isDelete: false,
                    // };
            
                    // // setListOfFieldsArray((prevList) => [...prevList, fieldToSave]);
                    // inputOnChange.current = ([
                    //     ...inputOnChange.current,
                    //     fieldToSave
                    // ])
                    })
                }
            }
        }
      }, [data, id])

    const callAnnextureApi = async() => {
        try {
            const { data,loading,error } = await CallAPI(annexture, 'POST', { 
                    "enquiryId": enquiryId,
                }
            ); 
            setAnnextureData(data);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }

    const [tableList, setTableList] = useState({})
    const [forceRender, setForceRender] = useState(false); 
    // Validation function
    const handleInputChange = async (value, type, name, target, isMultipleFields, displayValue) => {
        let isError = false;
        let errorMessage = '';
        
        // Check if field is required and value is empty or only whitespace
        const trimmedValue = value ? value.trim() : '';
        const isRequiredField = (isRequired[target?.fieldName] ? (isRequired[target?.fieldName] === true ) : target?.isRequired === 1 );
        
        if (isRequiredField && trimmedValue === '' && target.dbColumnName.toLowerCase() !== 'debid') {
            isError = true;
            errorMessage = `${target?.fieldName} is required`;
        }
        
        // Only run other validations if the field has content
        if (trimmedValue && target?.fieldValidations) {
            target.fieldValidations.forEach(element => {
                switch (element.property) {
                    case 'InputType':
                        if(element.value === 'Numbers only'){
                            const numberRegex = /^[0-9]*$/;
                            if(!numberRegex.test(trimmedValue)){
                                isError = true;
                                errorMessage = (
                                    <ul>
                                        <li>Only numbers are allowed</li>
                                    </ul>
                                );
                            };
                        }

                        if(element.value === 'Email'){
                            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                            if(!emailRegex.test(trimmedValue)){
                                isError = true;
                                errorMessage = 'Please enter email address in format: yourname@example.com';
                            };
                        }

                        if(element.value === 'Alphanumeric'){
                            let AlphanumericRegex = /^[a-zA-Z0-9_ ]*$/;
                            if(!AlphanumericRegex.test(trimmedValue)){
                                isError = true;
                                errorMessage = (
                                    <ul>
                                        <li>Allowed alphabets are (a-z or A-Z)</li>
                                        <li>Allowed numbers are (0-9)</li>
                                    </ul>
                                );
                            };
                        }

                        if(element.value === 'Alphanumeric (With special characters)'){
                            let AlphanumericSpecialRegex =  /^[a-zA-Z0-9-,.:()/_@+;% ]*$/;
                            if(!AlphanumericSpecialRegex.test(trimmedValue)){
                                isError = true;
                                errorMessage = (
                                    <ul>
                                        <li>Allowed alphabets are (a-z or A-Z)</li>
                                        <li>Allowed numbers are (0-9)</li>
                                        <li>Allowed special characters are (@ , . ( ) / _ - : + ; % ) </li>
                                    </ul>
                                );
                            };
                        }

                        if(element.value === 'Text only (With special characters)'){
                            let textSpecialRegex =/^[a-zA-Z-+' ]*$/;
                            if(!textSpecialRegex.test(trimmedValue)){
                                isError = true;
                                errorMessage = (
                                    <ul>
                                        <li>Allowed alphabets are (a-z or A-Z)</li>
                                        <li>Allowed special characters are (' - +)</li>
                                    </ul>
                                );
                            };
                        }

                        if(element.value === 'Text only'){
                            let textSpecialRegex =/^[a-zA-Z ]*$/;
                            if(!textSpecialRegex.test(trimmedValue)){
                                isError = true;
                                errorMessage = (
                                    <ul>
                                        <li>Allowed alphabets are (a-z or A-Z)</li>
                                    </ul>
                                );
                            };
                        }

                        break;
                case 'MinLength':
                    if(trimmedValue === undefined || trimmedValue.length < parseInt(element.value)){
                        isError = true;
                        errorMessage = (
                            <ul>
                                <li>Minimum length is {element.value}</li>
                            </ul>
                        );
                    }
                    break;
                case 'MaxLength':
                    if(trimmedValue !== undefined && trimmedValue.length > parseInt(element.value)){
                        isError = true;
                        errorMessage = (
                            <ul>
                                <li>Maximum length is {element.value}</li>
                            </ul>
                        );
                    }
                    break;
                default:
                    break;
            }
        });
        }
    
        // Update inputValue
        if(target?.fieldType !== 'RadioButton'){
            inputValue.current = {
                ...inputValue.current,
                [name]: isError ? '' : trimmedValue,
            };

            // const isCreated = createObject(target, isError ? '' : trimmedValue.toString())
        }
    
        // Trigger a re-render only once
        // if (isError || textError[name]) {
        //     // setForceRender(prev => !prev);

        //     setTextError(prevTextError => ({
        //         ...prevTextError,
        //         [name]: { isError, errorMessage },
        //     }))

        //     // Remove from inputValue
        //     if (inputValue.current.hasOwnProperty(name)) {
        //         delete inputValue.current[name];
        //     }

        //     // Remove from inputOnChange by fieldId, sectionId, and sequenceId
        //     inputOnChange.current = inputOnChange.current.filter(
        //         (item) =>
        //             !(item.fieldId === target?.fieldId &&
        //             item.sectionId === target?.sectionId &&
        //             item.sequenceId === (target?.sequenceId ?? 0))
        //     );
        //     return;
        // }

        if (isError) {
            // Set error and remove value
            setTextError(prevTextError => ({
                ...prevTextError,
                [name]: { isError, errorMessage },
            }));
            if (inputValue.current.hasOwnProperty(name)) {
                delete inputValue.current[name];
            }
            inputOnChange.current = inputOnChange.current.filter(
                (item) =>
                    !(item.fieldId === target?.fieldId &&
                    item.sectionId === target?.sectionId &&
                    item.sequenceId === (target?.sequenceId ?? 0))
            );
            return;
        } else if (textError[name]?.isError) {
            // If previously there was an error and now input is valid, clear the error
            setTextError(prevTextError => ({
                ...prevTextError,
                [name]: { isError: false, errorMessage: "" },
            }));
        }


        // UMS1-1186: DEB ID restriction check on blur. Runs whether or not the form has a
        // Verify button configured. Returning before createObject keeps the value out of
        // inputOnChange.current, which is what fieldWiseSave auto-saves for students.
        if(isError === false && target?.dbColumnName?.toLowerCase() === 'debid' && trimmedValue !== ''){
            const debRestrictionMessage = await checkDebIdRestriction(trimmedValue)

            if(debRestrictionMessage !== null){
                setIsDebVerified(false)
                await updateTextError(name, { isError: true, errorMessage: debRestrictionMessage })

                return;
            }
        }

        let newObject = {}
        if(isError === false){

            if(target?.fieldType !== 'RadioButton'){
                inputValue.current = {
                    ...inputValue.current,
                    [name]: trimmedValue
                }
            }

            if(isMultipleFields === 1){
                if(target?.fieldType === 'DropDown' || target?.fieldType === 'RadioButton'){
                    let keyValuePairs = target?.fieldDataSource
                    .split("+")
                    .filter(item => item) // Remove empty items
                    .map(item => {
                        const [key, value] = item.split("=");
                        return {key, value} ;
                    });
            
                    const selectedPair = keyValuePairs.find(pair => pair.key === value.toString());
                    const selectedValue = selectedPair ? selectedPair.value : '';
                    tableValue.current = {
                        ...tableValue.current,
                        [name]: selectedValue
                    }
                }else{
                    tableValue.current = {
                        ...tableValue.current,
                        [name]: displayValue || trimmedValue
                    }
                }
                
            }

            // const isMobileView = window.innerWidth <= 768; // or use your existing mobile detection logic
            // if (isMobileView) {
                // setInputTrigger(prev => prev + 1);
            // }
            
            const isCreated = createObject(target, trimmedValue.toString())
        }else{
            setTextError(prevTextError => ({
                ...prevTextError,
                [name]: { isError, errorMessage },
            }))
        }
        
    }

    // To save subject section
    useEffect(() => {
        if (subjectValue.length > 0) {
            const groupedFields = subjectValue.reduce((acc, item) => {
                const key = item.fieldRefTypeId;
                const valueKey = Object.keys(item)[0].toString(); // Ensure the key is a string
    
                if (!acc[key]) {
                    acc[key] = {
                        'sectionId': 13,
                        'fieldId': 73,
                        'sequenceId': 0,
                        'value': valueKey, // Set the first value as a string
                        "imageExtension": "",
                        "imageSize": "",
                        "fieldRefType": item.fieldRefType,
                        "fieldRefTypeId": item.fieldRefTypeId,
                        "fieldTypeId": item.fieldTypeId,
                        "isDelete" : false,
                    };
                } else {
                    if (typeof acc[key].value === 'string') {
                        acc[key].value = [acc[key].value]; // Convert the value to an array of strings
                    }
                    acc[key].value.push(valueKey);
                }
                return acc;
            }, {});
    
            setListOfFieldsArray(Object.values(groupedFields).map(field => ({
                ...field,
                value: Array.isArray(field.value) ? field.value.join(', ') : field.value // Join the values with a comma
            })));

            inputOnChange.current = Object.values(groupedFields).map(field => ({
                ...field,
                value: Array.isArray(field.value) ? field.value.join(', ') : field.value // Join the values with a comma
            }));
        }
    }, [subjectValue]);
    
    useEffect(() => {
        // Set dependent field mandatory based on selection
        if(data !== null && inputOnChange.current.length > 0){
            const lastChangedField = lastChangedFieldRef.current
                ?? inputOnChange.current[inputOnChange.current.length - 1];
            const sourceSectionId = lastChangedField.sectionId;
            const dependentField = data.fieldDepedancyList.find((item) => parseInt(item.fieldId, 10) === lastChangedField.fieldId);

            if (dependentField) {
                dependentField.fieldDepedancies.forEach((dep) => {
                  const dependentFieldValue = dep.value;
                  const dependentSectionId = dep.sectionId;
                  const dependentType = dep.dependancyType;
                  const dependentFieldId = dep.fieldId;
                  const dependentFieldRefId = dep.fieldRefId;
            
                  let sec = data.sections.find((section) => section.sectionId === parseInt(dependentSectionId));
                  let fields = sec.fieldsList.find((f) => f.fieldId === parseInt(dependentFieldId));
                  if(dependentFieldId === '54' && dependentFieldRefId !== ''){
                    fields = sec.fieldsList.find((f) => f.fieldDataSource === dependentFieldRefId)
                  }
                  if (dependentFieldValue.includes(lastChangedField.value) && dependentType === '2') {
                    setIsRequired((prevRequired) => ({
                      ...prevRequired,
                      [fields.fieldName]: true,
                    }));
                  } else if(dependentFieldValue.includes(lastChangedField.value) && dependentType === '4') {
                    setIsRequired((prevRequired) => ({
                      ...prevRequired,
                      [fields.fieldName]: false,
                    }));
                  } else if(dependentFieldValue.includes(lastChangedField.value) && dependentType === '5') {
                        setDisabledFields((prevDisabled) => ({
                            ...prevDisabled,
                            [fields.fieldName]: true,
                        }));
                  } else if(dependentFieldValue.includes(lastChangedField.value) && dependentType === '6') {
                        setDisabledFields((prevDisabled) => ({
                            ...prevDisabled,
                            [fields.fieldName]: false,
                        }));
                  } else if(dependentFieldValue.includes(lastChangedField.value) && dependentType === '7') {
                        setFieldVisibility((prevDisabled) => ({
                            ...prevDisabled,
                            [fields.fieldName]: false,
                        }));
                  } else if(dependentFieldValue.includes(lastChangedField.value) && dependentType === '8') {
                    setFieldVisibility((prevDisabled) => ({
                        ...prevDisabled,
                        [fields.fieldName]: true,
                    }));
                  } 
                  else{
                    setIsRequired((prevRequired) => {
                        const newRequired = { ...prevRequired };
                        delete newRequired[fields.fieldName];
                        return newRequired;
                    });

                    setDisabledFields((prevRequired) => {
                        const newRequired = { ...prevRequired };
                        delete newRequired[fields.fieldName];
                        return newRequired;
                    });

                    setFieldVisibility((prevRequired) => {
                        const newRequired = { ...prevRequired };
                        delete newRequired[fields.fieldName];
                        return newRequired;
                    });
                  }
                });
            }
        }

        // Check conditions before calling fieldWiseSave
        if (loggedInUser === 'student' && data && id && id !== 11) {
            let sec = data.sections.find(section => section.sectionId === id)

            // if(sec.isMultipleFields !== 1){
                fieldWiseSave();
            // }
        }
        // if (!(listOfFields.fieldId === 23 && kycFlag === 1) && id !== 5 && id !== 6 && id !== 11) {
        //     fieldWiseSave();
        // }
    }, [inputOnChange.current, data, id, dependencyTick]);
    
    // Field wise save
    const fieldWiseSave = async(forceSave = false) => {
        const currentSec = data?.sections?.find(section => section.sectionId === id);
        if(currentSec?.isMultipleFields === 1 && !forceSave){
            return;
        }
        if(inputOnChange.current.length > 0){
            let isMultipleFields = inputOnChange.current[0].sequenceId
            // For multi-sequence sections, keep only entries whose sequenceId matches the
            // current row being added. This drops stale-sequence stubs left over from
            // previous saves so field values never leak into the wrong sequence.
            // Skip this filter when the buffer includes an isDelete entry (delete flow
            // legitimately spans multiple sequenceIds and must be preserved as-is).
            if(isMultipleFields !== 0){
                const hasDeleteEntry = inputOnChange.current.some(item => item.isDelete === true);
                if(!hasDeleteEntry){
                    const currentSeq = tableRowSequence && tableRowSequence[id];
                    if(currentSeq){
                        inputOnChange.current = inputOnChange.current.filter(item => item.sequenceId === currentSeq);
                    }
                }
                const allEmptyNonDelete = inputOnChange.current.length > 0 && inputOnChange.current.every(item =>
                    item.isDelete === false && (item.value === '' || item.value === null || item.value === undefined)
                );
                if(allEmptyNonDelete || inputOnChange.current.length === 0){
                    inputOnChange.current = []
                    return;
                }
            }
            const requestModel =  {
                "enquiryId": enquiryId,
                "admissionFormId": admissionFormId,
                "userId": loggedInUser === 'admin' && sessionStorage.getItem('actionType') === 'Edit' ? parseInt(sessionStorage.getItem('userId')) : 0,
                "listOfSection": [
                    {
                    "sectionId": id,
                    "isMultiple": isMultipleFields !== 0 ? 1 : 0,
                    "listOfFields": inputOnChange.current
                    }
                ]
            }

            try{
                const { statusCode,loading,error } = await CallAPI(saveField, 'POST', { requestModel })
                setSaveApiResponse(statusCode);
                if(isMultipleFields !== 0){
                    inputOnChange.current = []
                }
                // setIsRequired({})
			}catch(error){
                console.log(error);
            }
        }
        
    }
    
    let aadhaarNumber = ''
    const [radioButtonValue, setRadioButtonValue] = useState('');

    const handleChange = (value, name, rest, section) => {
        if(rest?.dbColumnName === 'AadharNo'){
            aadhaarNumber = value
            // setAadhaarData(value)
        }
        else if(rest?.dbColumnName.toLowerCase() === 'debid'){
            setDebId = value
            setIsDebVerified(false);

            inputValue.current = {
                ...inputValue.current,
                [rest?.fieldName]: value
            }
        }

        if(rest?.fieldId === 52){
            setInterested(value)
        }

        if(rest?.fieldType !== 'TextField' && rest?.fieldType !== 'TextArea'){
            if(data !== null){
                // const lastChangedField = inputOnChange.current[inputOnChange.current.length - 1];

                const dependentField = data.fieldDepedancyList.find((item) => parseInt(item.fieldId, 10) === rest?.fieldId);

                if (dependentField) {
                    dependentField.fieldDepedancies.forEach((dep) => {
                    const dependentFieldValue = dep.value;
                    const dependentSectionId = dep.sectionId;
                    const dependentType = dep.dependancyType;
                    const dependentFieldId = dep.fieldId;
                    const dependentFieldRefId = dep.fieldRefId;
                
                    let sec = data.sections.find((section) => section.sectionId === parseInt(dependentSectionId));
                    let fields = sec.fieldsList.find((f) => f.fieldId === parseInt(dependentFieldId));
                    if(dependentFieldId === '54' && dependentFieldRefId !== ''){
                        fields = sec.fieldsList.find((f) => f.fieldDataSource === dependentFieldRefId)
                    }
                    if (dependentFieldValue.includes(value) && dependentType === '2') {
                        setIsRequired((prevRequired) => ({
                        ...prevRequired,
                        [fields.fieldName]: true,
                        }));
                    } else if(dependentFieldValue.includes(value) && dependentType === '4') {
                        setIsRequired((prevRequired) => ({
                        ...prevRequired,
                        [fields.fieldName]: false,
                        }));
                    } else if(dependentFieldValue.includes(value) && dependentType === '7') {
                        setFieldVisibility((prevDisabled) => ({
                            ...prevDisabled,
                            [fields.fieldName]: false,
                        }));
                    } 
                    else{
                        setIsRequired((prevRequired) => {
                            const newRequired = { ...prevRequired };
                            delete newRequired[fields.fieldName];
                            return newRequired;
                        });
                    }
                    });
                }
            }
        }

        if(rest?.fieldType === 'RadioButton'){
            setRadioButtonValue((prevValue) => ({
                ...prevValue,
                [rest?.fieldName]: value
            }))

            if (textError[rest?.fieldName]?.isError === true) {
                setTextError((prev) => ({
                    ...prev,
                    [rest.fieldName]: {
                        isError: false,
                        errorMessage: ''
                    }
                }));
            }

            const isCreated = createObject(rest, value.toString())

            if(rest?.fieldType === 'RadioButton'){
                let keyValuePairs = rest?.fieldDataSource
                .split("+")
                .filter(item => item) // Remove empty items
                .map(item => {
                    const [key, value] = item.split("=");
                    return {key, value} ;
                });
        
                const selectedPair = keyValuePairs.find(pair => pair.key === value.toString());
                const selectedValue = selectedPair ? selectedPair.value : '';
                
                tableValue.current = {
                    ...tableValue.current,
                    [name]: selectedValue
                }
            }
        }else {
            if(section.isMultipleFields === 1){
                if(rest?.fieldType === 'DropDown'){
                    let keyValuePairs = rest?.fieldDataSource
                    .split("+")
                    .filter(item => item) // Remove empty items
                    .map(item => {
                        const [key, value] = item.split("=");
                        return {key, value} ;
                    });

                    const selectedPair = keyValuePairs.find(pair => pair.key === value.toString());
                    const selectedValue = selectedPair ? selectedPair.value : '';
                    
                    tableValue.current = {
                        ...tableValue.current,
                        [rest?.fieldName]: selectedValue
                    }
                }
            }

            inputValue.current = {
                ...inputValue.current,
                [rest?.fieldName]: value
            }
            // if(isDebVerified === true && section.sectionId === 1){
            //     setInputTrigger(prev => prev + 1);
            // }

            const isCreated = createObject(rest, value.toString())
        }
    };

    // To set error and error message
    const updateTextError = async (fieldName, { isError, errorMessage }) => {
        setTextError(prevTextError => ({
            ...prevTextError,
            [fieldName]: { isError, errorMessage },
        }));
    };

    // Clear the 'DEB ID verification is mandatory' error once a dependency turns the field
    // optional — the Verify button is gone by then, so the user has no way to clear it.
    useEffect(() => {
        if(data === null) return;

        data.sections.forEach(section => {
            const debField = section.fieldsList?.find(f => f.dbColumnName?.toLowerCase() === 'debid');

            if(debField !== undefined && isDebOptionalByDependency(debField) && textError[debField.fieldName]?.isError === true){
                updateTextError(debField.fieldName, { isError: false, errorMessage: '' });
            }
        });
    }, [isRequired, data, textError]);

    // To set field value empty for section 5 and 6
    useEffect(()=>{
        if( data !== null && tableRowSequence !== null){
            var sec = data.sections.find(section => section.sectionId === id);
            
            if(sec && (sec.isMultiFieldSection === 1) && editFlag === 0){
                const updatedFields = sec.fieldsList
                    .filter(field => field.multipleSequence === 0 || field.multipleSequence === 1 )
                    .map(field => ({
                        sectionId: sec.sectionId,
                        fieldId: field.fieldId,
                        // sequenceId: tableRowSequence[id], // Assuming this should be dynamically set based on your logic
                        sequenceId: tableInputValue[id] ? tableInputValue[id].length + 1 : tableRowSequence[id], // Assuming this should be dynamically set based on your logic
                        value: '',
                        imageExtension: "",
                        imageSize: "",
                        fieldRefType: "", 
                        fieldRefTypeId: 0,
                        fieldTypeId: field.fieldTypeId,
                        isDelete : false,
                }));
                // setListOfFieldsArray(prevList => [...prevList, ...updatedFields])
                // setListOfFieldsArray(updatedFields);
                updatedFields.forEach(field => {
                    const existingIndex = inputOnChange.current.findIndex(
                        item => item.sectionId === field.sectionId && item.fieldId === field.fieldId && item.sequenceId === field.sequenceId
                    );
            
                    if (existingIndex !== -1) {
                        // Update the existing object
                        inputOnChange.current[existingIndex] = field;
                    } else {
                        // Add new entry
                        inputOnChange.current.push(field);
                    }
                });
            }
            

        }
    }, [id, data, tableRowSequence])

    const [SnackbarOpen, setSnackbarOpen] = useState(false);

    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
          return;
        }
        setSnackbarOpen(false);
    };

    // save and proceed for form preview
    const handleNextAdmin = (flag, isMultipleFields, fieldList, sequence, sectionId) => {
        let nextId = id + 1;
        let nextSequence = 1

        if(sectionId === 11){
            let sec = data.sections.find(section =>section.sectionId === sectionId)
            nextSequence = sec.sequence + 1
        }else{
            nextSequence = sequence + 1;
        }
        setLastSaveSection(id)

        if(nextSequence !== null){
            var nextSection = data.sections.find(section => section.sequence === nextSequence);
            // let lastSection = tempData.sections.pop();
            // let lastSectionId = lastSection.sectionId;
            if(nextSection === undefined){
                return;
                // Navigate('/preview', { state: { lastActiveSection: lastActiveSection, CategoryId: CategoryId, CourseId:CourseId, enquiryId: enquiryId, name: name } })
            }  

            if( nextSection.isActive === 1 && nextSection.parentSectionId === 0 && nextSection.sectionId !== 14){
                setId(nextSection.sectionId)
                setCurrentSection(nextSection.sectionId)  //  Set active section id
            } else if(nextSection.sectionId === 14){
                setId(nextSection.sectionId)
                setCurrentSection(nextSection.sectionId)  //  Set active section id
            }
            else{
                let nextSec = data.sections.find(n => n.sequence === nextSection.sequence + 1);

                while (nextSec !== undefined && nextSec.isActive === 0) {
                    let currentSequence = nextSec.sequence + 1;
                    nextSec = data.sections.find(y => y.sequence === currentSequence);
                }

                if(nextSec){
                    setId(nextSec.sectionId)
                    setCurrentSection(nextSec.sectionId)
                }else {
                    console.log('in final else')
                    // Navigate('/preview', { state: { lastActiveSection: lastActiveSection, CategoryId: CategoryId, CourseId:CourseId, enquiryId: enquiryId, name: name } })
                }
            }    
        }

        window.scrollTo(0, 0);
    }
const [errorLabel, setErrorLabel] = useState(false);

    useEffect(() => {
        if(data !== null){
            let dependancyList =  data.fieldDepedancyList

            dependancyList.forEach((element) =>{
                let sec = data.sections.find(section => section.sectionId === parseInt(element.sectionId))
                let field = sec.fieldsList.find(f => f.fieldId === parseInt(element.fieldId))

                if(!inputValue.current[field.fieldName] && field.value !== ''){
                    element.fieldDepedancies.forEach((dependent) => {
                        let dependentSec = data.sections.find(sec => sec.sectionId === parseInt(dependent.sectionId))
                        let dependentField = dependentSec.fieldsList.find(f => f.fieldId === parseInt(dependent.fieldId))
                        if(dependent.fieldId === '54'){
                            dependentField = dependentSec.fieldsList.find(f => f.fieldDataSource === dependent.fieldRefId)
                        }
                        // Skip on-load evaluation for intra-section dependencies inside a multi-field section.
                        // Parent field.value there reflects a previously saved row; applying it to the fresh
                        // template row would leave the dependent field stuck as mandatory/disabled/hidden
                        // even though the current row hasn't selected the trigger value.
                        if (
                            String(dependent.sectionId) === String(element.sectionId) &&
                            sec.isMultipleFields === 1
                        ) {
                            return;
                        }
                        // if(field.value === dependent.value && dependent.dependancyType === '2'){
                        if(dependent.value.includes(field.value) && dependent.dependancyType === '2'){
                            setIsRequired((prevRequired) => ({
                                ...prevRequired,
                                [dependentField.fieldName]: true,
                            }));
                            
                        }else if(dependent.value.includes(field.value) && dependent.dependancyType === '4'){
                            setIsRequired((prevRequired) => ({
                                ...prevRequired,
                                [dependentField.fieldName]: false,
                            }));
                        }else if(dependent.value.includes(field.value) && dependent.dependancyType === '5'){
                            setDisabledFields((prevDisabled) => ({
                                ...prevDisabled,
                                [dependentField.fieldName]: true,
                            }));
                        }else if(dependent.value.includes(field.value) && dependent.dependancyType === '6'){
                            setDisabledFields((prevDisabled) => ({
                                ...prevDisabled,
                                [dependentField.fieldName]: false,
                            }));
                        }else if(dependent.value.includes(field.value) && dependent.dependancyType === '7'){
                            setFieldVisibility((prevDisabled) => ({
                                ...prevDisabled,
                                [dependentField.fieldName]: false,
                            }));
                        }else if(dependent.value.includes(field.value) && dependent.dependancyType === '8'){
                            setFieldVisibility((prevDisabled) => ({
                                ...prevDisabled,
                                [dependentField.fieldName]: true,
                            }));
                        }
                    })

                }
            })
        }
    },[data])

    // Save and Proceed
    const handleContinue = async (flag, isMultipleFields, fieldList, sequence, sectionId) => {
        const nextId = id + 1;
        let nextSequence = sequence + 1;

        if(sectionId === 11 || sectionId === 3){
            let sec = data.sections.find(section => section.sectionId === sectionId)
            nextSequence = sec.sequence + 1
        }

        let currentSec = data.sections.find(section => section.sectionId === id)

        let isError = false;
        let errorMessage = '';
        let proceedFlag = true;
        let templateRowClearedForProceed = false;

        if(id === 1){
            if(debEnable !== null && debEnable === 1  && isDebVerified == false){
                let sec = data.sections.find(section => section.sectionId === id)
                let field = sec.fieldsList.find(f => f.dbColumnName.toLowerCase() === 'debid')

                if(field !== undefined && field.isActive === 1 && field.isRequired === 1 && !isDebOptionalByDependency(field)){
                    isError = true
                    proceedFlag = false
                    errorMessage = 'DEB ID verification is mandatory'

                    await updateTextError(field.fieldName, { isError, errorMessage });
                }
            }

            // Block proceed if the on-blur DEB restriction check left an active error
            // on the DEB ID field (isDebVerified is cleared by checkDebIdRestriction).
            let debSec = data.sections.find(section => section.sectionId === id)
            let debField = debSec?.fieldsList.find(f => f.dbColumnName.toLowerCase() === 'debid')
            if(debField && textError[debField.fieldName]?.isError === true){
                isError = true
                proceedFlag = false
            }

        }

        if(id === 2){
            if(kycFlag === 1 && isAadhaarVerified === false){
                let sec = data.sections.find(section => section.sectionId === id)
                let field = sec.fieldsList.find(f => f.dbColumnName === 'AadharNo')

                if(field !== undefined){
                    isError = true
                    proceedFlag = false
                    errorMessage = 'Aadhaar number verification is mandatory'

                    await updateTextError(field.fieldName, { isError, errorMessage });
                }
            }
            
            if(debEnable !== null && debEnable === 0){
            // Validate DEB ID details (debid/dob/emailid/mobileno) against server
                const dbColumnToFieldMap = {
                    'debid': 'debId',
                    'dob': 'dob',
                    'emailid': 'emailId',
                    'mobileno': 'mobileNo',
                };

                const findFieldByDbColumn = (dbCol) => {
                    for(const section of data.sections){
                        if(!section.fieldsList) continue;
                        const found = section.fieldsList.find(f => f.dbColumnName && f.dbColumnName.toLowerCase() === dbCol);
                        if(found) return found;
                    }
                    return undefined;
                };

                const readFieldValue = (fieldObj) => {
                    if(!fieldObj) return '';
                    const v = inputValue.current[fieldObj.fieldName];
                    if(v !== undefined && v !== null && v !== '') return v;
                    return fieldObj.value !== undefined && fieldObj.value !== null ? fieldObj.value : '';
                };

                const debIdField = findFieldByDbColumn('debid');
                const dobField = findFieldByDbColumn('dob');
                const emailField = findFieldByDbColumn('emailid');
                const mobileField = findFieldByDbColumn('mobileno');

                const debIdValue = readFieldValue(debIdField);

                if(proceedFlag && debIdValue){
                    try {
                        const validateResponse = await CallAPI(ValidateDebIdDetails, 'POST', {
                            enquiryId: enquiryId,
                            debId: debIdValue,
                            dob: readFieldValue(dobField),
                            emailId: readFieldValue(emailField),
                            mobileNo: readFieldValue(mobileField),
                        });

                        if(validateResponse && validateResponse.isSuccess === false){
                            const dataList = Array.isArray(validateResponse.data) ? validateResponse.data : [];
                            const anyFieldError = dataList.some(item => item.isError === true);

                            if(anyFieldError){
                                for(const item of dataList){
                                    if(item.isError === true){
                                        const dbCol = (item.dbColumn || '').toLowerCase();
                                        const fieldObj = findFieldByDbColumn(dbCol);
                                        if(fieldObj){
                                            await updateTextError(fieldObj.fieldName, {
                                                isError: true,
                                                errorMessage: item.errorMessage,
                                            });
                                        }
                                    }
                                }
                                isError = true;
                                proceedFlag = false;
                            } else {
                                setMandatoryMsg(validateResponse.message);
                                setSnackbarOpen(true);
                                isError = true;
                                proceedFlag = false;
                            }
                        }
                    } catch(validateErr){
                        console.log(validateErr);
                    }
                }
            }
        }

        // Validation for any required field is empty in address section
        if(id === 3){
            data.sections.forEach(sec => {
                if(sec.parentSectionId === 3){
                    let fieldList = sec.fieldsList
                    fieldList.forEach( async element => {
                        const fieldInInputOnChange = inputOnChange.current.some(
                            (inputObject) => inputObject.fieldId === element.fieldId // Assuming 'field' represents 'fieldId'
                        );

                        if((isRequired[element.fieldName] ? (isRequired[element.fieldName] === true ) : element.isRequired === 1 )  && element.isActive === 1 && (element.value === null || element.value === "")){
                            if ((element.dbColumnName.toLowerCase() === 'stateid' && modifiedApiDropdownData[element.fieldName].length === 0) ) {
                                console.log('')
                            }else if(element.dbColumnName.toLowerCase() === 'cityid' && modifiedApiDropdownData[element.fieldName].length === 0){
                                console.log('')
                            }else if(element.dbColumnName.toLowerCase() === 'pstateid' && modifiedApiDropdownData[element.fieldName].length === 0){
                                console.log('')
                            }else if(element.dbColumnName.toLowerCase() === 'pcityid' && modifiedApiDropdownData[element.fieldName].length === 0){
                                console.log('')
                            }else if(element.dbColumnName.toLowerCase() === 'districtid' && modifiedApiDropdownData[element.fieldName].length === 0){
                                console.log('')
                            }else if(element.dbColumnName.toLowerCase() === 'pdistrictid' && modifiedApiDropdownData[element.fieldName].length === 0){
                                console.log('')
                            }
                            else{
                                if(inputValue.current[element.fieldName] === undefined || inputValue.current[element.fieldName] === '' || Object.keys(inputValue).length === 0){
                                    isError = true;
                                    proceedFlag = false;        //If error exist set flag to false
                                    errorMessage = `${element.fieldName} is required`
                                    await updateTextError(element.fieldName, { isError, errorMessage });
                                }
                            
                            }
                        }
                    });
                }
                
            })
            
        }

        if(id === 11){
            data.sections.forEach(async sec => {
                if(sec.parentSectionId === 11 && sec.sectionId === 13){
                    let fieldList = sec.fieldsList
                    let updatedListOfFieldsArray = subjectValue.filter(field => field.sequence === 1);

                    for (const fieldObject of fieldList) {

                        // if (fieldObject.value && fieldObject.value !== '') {
                        //     continue; // Skip validation if value is not an empty string
                        // }

                        // Parse fieldDataSource to extract sequence IDs
                        const sequenceIds = fieldObject.fieldDataSource.split('+').map(entry => entry.split('=')[0]);
                      
                        // Filter subjectValue array based on sequence IDs
                        let updatedListOfFieldsArray = subjectValue.filter(field =>
                          sequenceIds.includes(Object.keys(field)[0])
                        );
                      
                        // Extract validation rules
                        const validations = fieldObject.fieldValidations.reduce((acc, validation) => {
                          acc[validation.property] = parseInt(validation.value, 10);
                          return acc;
                        }, {});
                      
                        // Validate MinSelections
                        let isValidMin = true;
                        if (validations.MinSelections !== undefined) {
                          isValidMin = updatedListOfFieldsArray.length >= validations.MinSelections;
                        }
                      
                        // Validate MaxSelections
                        let isValidMax = true;
                        if (validations.MaxSelections !== undefined) {
                          isValidMax = updatedListOfFieldsArray.length <= validations.MaxSelections;
                        }

                        if (!isValidMin) {
                            isError = true;
                            errorMessage = `Select at least ${validations.MinSelections} subjects`;
                            await updateTextError(fieldObject.fieldName, { isError, errorMessage });
                        } else if (!isValidMax) {
                            isError = true;
                            errorMessage = `Select a maximum of ${validations.MaxSelections} subjects`;
                            await updateTextError(fieldObject.fieldName, { isError, errorMessage });
                        }
                      };
                }
                
            })
            
        }

        if(currentSec.isMultipleFields === 1){
            let fieldList = currentSec.fieldsList;
            let hasFilledAtLeastOneField = false;
            let hasError = false;

            if (!currentSec) return;

            // Remove all fields with sequenceId 0
            let updatedListOfFieldsArray = listOfFieldsArray.filter(field => field.sequenceId !== 0);

            // Apply specific flags for sections
            const isExamMandatory = id === 5 && examMandatoryFlag === 1;
            const isWorkMandatory = id === 6 && workMandatoryFlag === 1;

            const isTableCompletelyEmpty = Object.keys(tableInputValue).length === 0;
            const isSectionEmpty = tableInputValue[currentSec.sectionId] === undefined || tableInputValue[currentSec.sectionId].length === 0;
            // Template row is empty when there are no keys, or every recorded value is blank.
            // handleChange writes '' for cleared fields rather than deleting the key, so a plain
            // Object.keys length check would treat "typed then cleared" as filled.
            const inputSnapshot = inputValue.current || {};
            const inputKeys = Object.keys(inputSnapshot);
            const isTemplateRowEmpty = inputKeys.length === 0 || inputKeys.every(k => {
                const v = inputSnapshot[k];
                return v === undefined || v === null || (typeof v === 'string' ? v.trim() === '' : false);
            });

            // Section-level mandatory: at least one record required
            if (isSectionEmpty && (isExamMandatory || isWorkMandatory)) {
                isError = true;
                proceedFlag = false;
                const label = id === 5 ? 'education' : 'work experience';
                setMandatoryMsg(`Please add at least one ${label} record to continue.`);
                setSnackbarOpen(true);
                window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
            }

            // Section optional AND table empty AND template row empty → allow proceed, skip per-field checks.
            // Table has records AND template row empty → allow proceed (fresh input row is not being added).
            const shouldValidate = !isError && !isTemplateRowEmpty;

            // If we're allowing proceed on an empty template row, clear any stale per-field
            // errors from earlier typing so hasTextError doesn't silently block navigation.
            if(!shouldValidate && isTemplateRowEmpty){
                templateRowClearedForProceed = true;
                const sectionFieldNames = new Set(fieldList.map(f => f.fieldName));
                setTextError(prev => {
                    const next = { ...prev };
                    sectionFieldNames.forEach(name => { delete next[name]; });
                    return next;
                });
                inputValue.current = {};
                inputOnChange.current = inputOnChange.current.filter(item => item.sectionId !== currentSec.sectionId);
            }
            
            if (Object.keys(requiredKeys.current).length > 0) {
                const sectionId = currentSec.sectionId?.toString(); // Convert to string for key match
                const tableRecords = tableInputValue[sectionId] || [];
                const sectionFields = requiredKeys.current[sectionId] || {};
                let missingValues = [];

                Object.entries(sectionFields).forEach(([fieldName, requiredValues]) => {
                    requiredValues.forEach(requiredValue => {
                    const found = tableRecords.find(record => record[fieldName] === requiredValue);
                    if (!found) {
                        missingValues.push(requiredValue);
                    }
                    });
                });

                if (missingValues.length > 0) {
                    isError = true;
                    proceedFlag = false;

                    // Format message nicely: "SSC, UG details are mandatory."
                    let formattedList = missingValues
                    .filter((v, i, self) => self.indexOf(v) === i) // Remove duplicates if any
                    .join(', ')
                    .replace(/, ([^,]*)$/, ' and $1');

                    const errorMessage = `${formattedList} details are mandatory.`;

                    setMandatoryMsg(errorMessage);
                    setSnackbarOpen(true);
                    window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
                }
                // const tableRecords = tableInputValue[currentSec.sectionId] || [];
                // let missingValues = [];

                // Object.entries(requiredKeys.current).forEach(([fieldName, requiredValues]) => {
                //     requiredValues.forEach((requiredValue) => {
                //         // Check if any record in tableRecords has the requiredValue for the fieldName
                //         const found = tableRecords.find(record => record[fieldName] === requiredValue);
                //         if (!found) {
                //             missingValues.push(requiredValue);
                //         }
                //     });
                // });

                // if (missingValues.length > 0) {
                //     isError = true;
                //     proceedFlag = false;

                //     // Format message: e.g., "SSC and HSC details are mandatory."
                //     let formattedList = missingValues.join(', ').replace(/, ([^,]*)$/, ' and $1');
                //     const errorMessage = `${formattedList} details are mandatory.`;

                //     setMandatoryMsg(errorMessage);
                //     setSnackbarOpen(true);
                //     window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
                // }
            }

            // if(Object.keys(requiredKeys.current).length > 0 && id === 5){
            //     const tableRecords = tableInputValue[currentSec.sectionId] || [];
            //     Object.entries(requiredKeys.current).forEach(([fieldName, requiredValues]) => {
            //         requiredValues.forEach((requiredValue) => {
            //             // Check if any record in tableRecords has the requiredValue for the fieldName
            //             const found = tableRecords.find(record => record[fieldName] === requiredValue);
            //             if (!found) {
            //                 isError = true;
            //                 proceedFlag = false;
            //                 errorMessage = `${requiredValue} is required`;
            //                 setMandatoryMsg(errorMessage);
            //                 setSnackbarOpen(true);
            //                 window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
            //             }
            //         });
            //     });
            // }
            if (shouldValidate) {
                if (isError === false) {
                    fieldList.forEach(async element => {
                        if ((isRequired[element.fieldName] ? (isRequired[element.fieldName] === true) : element.isRequired === 1) && element.isActive === 1 && (element.value === null || element.value === "" || element.multipleSequence === 1)) {
                            if (inputValue.current[element.fieldName] === undefined || inputValue.current[element.fieldName] === '' || Object.keys(inputValue.current).length === 0) {
                            // if(element.value === ''){
                                isError = true;
                                proceedFlag = false; // If error exists, set flag to false
                                errorMessage = `${element.fieldName} is required`;
                                await updateTextError(element.fieldName, { isError, errorMessage });
                            }
                        }
                    });
                }
            } else {
                let emptyFieldsCount = 0;

                fieldList.forEach(element => {
                    if ((isRequired[element.fieldName] ? (isRequired[element.fieldName] === true) : element.isRequired === 1) && element.isActive === 1) {
                        if (inputValue.current[element.fieldName] === undefined || inputValue.current[element.fieldName] === '') {
                            emptyFieldsCount++;
                        }
                    }
                });

                if (Object.keys(inputValue.current).length === 0 || inputValue.current.length === undefined) {
                    // Skip if all fields are empty
                    proceedFlag = true;
                } else {
                    fieldList.forEach(element => {
                        if ((isRequired[element.fieldName] ? (isRequired[element.fieldName] === true) : element.isRequired === 1) && element.isActive === 1) {
                            if (inputValue.current[element.fieldName] === undefined || inputValue.current[element.fieldName] === '') {
                                emptyFieldsCount++;

                                if (element.value === null || element.value === "" || element.multipleSequence === 1) {
                                 isError = true;
                                    errorMessage = `${element.fieldName} is required`;
                                    updateTextError(element.fieldName, { isError, errorMessage });
                                }
                            } else{
                                hasFilledAtLeastOneField = true;
                            }
                        }
                    });
                }
            }

            // Collect unique sequence IDs from the updated list
            const sequenceIds = [...new Set(updatedListOfFieldsArray.map(field => field.sequenceId))];

            const updatedFields = fieldList.map(field => ({
                sectionId: field.sectionId,
                fieldId: field.fieldId,
                sequenceId: tableRowSequence[field.sectionId],
                value: inputValue.current[field.fieldName] || '',
                imageExtension: "",
                imageSize: "",
                fieldRefTypeId: 0,
                fieldRefType: "",
                fieldTypeId: field.fieldTypeId,
                isDelete: false,
            }));

            // Update state with the new list
            // setListOfFieldsArray([]);
            // setListOfFieldsArray(updatedListOfFieldsArray);
            // Only overwrite inputOnChange with saved rows when validation passed OR we
            // explicitly cleared the template row for a proceed. Otherwise the user's
            // in-progress typing in the template row (e.g. mandatory field 1 filled
            // before Save & Continue error) would be wiped, so a subsequent Add would
            // save only the fields typed after the error.
            if(proceedFlag === true || templateRowClearedForProceed === true){
                inputOnChange.current = []
                inputOnChange.current = updatedListOfFieldsArray
            }
        }

        if (id === 7){
            if(annextureFlag === false){
                proceedFlag = false;
                setSnackbarOpen(true);
            }
        }
        if (id === 14) {
            let sec = data.sections.find(section => section.sectionId === id);
            
            if (sec && sec.fieldsList) {
                let field = sec.fieldsList.find(f => f.fieldId === 74); // Adjust the fieldId if necessary
        
                if (field && field.fieldValidations) {
                    const validations = field.fieldValidations.reduce((acc, validation) => {
                        acc[validation.property] = parseInt(validation.value, 10);
                        return acc;
                    }, {});
        
                    // Validate MinSelections
                    let isValidMin = true;
                    if (validations.MinSelections !== undefined) {
                        isValidMin = listOfFieldsArray.length >= validations.MinSelections;
                    }
        
                    // Validate MaxSelections
                    let isValidMax = true;
                    if (validations.MaxSelections !== undefined) {
                        isValidMax = listOfFieldsArray.length <= validations.MaxSelections;
                    }
        
                    if (!isValidMin) {
                        isError = true;
                        errorMessage = `Select at least ${validations.MinSelections} opportunity`;
                        setSnackbarOpen(true);
                        await updateTextError(field.fieldName, { isError, errorMessage });
                    } else if (!isValidMax) {
                        isError = true;
                        errorMessage = `Select a maximum of ${validations.MaxSelections} opportunity`;
                        setSnackbarOpen(true);
                        await updateTextError(field.fieldName, { isError, errorMessage });
                    }
                } else {
                    console.log('fieldValidations is undefined for field:', field);
                }
            } else {
                console.log('sec or sec.fieldsList is undefined');
            }
        }

        let enteredValue = ''
        let errorFields = [];
        // Validation for any required field is empty
        fieldList.forEach( async element => {
            if(isDebFieldLocked(element)){
                return;
            }

            if(currentSec.isMultipleFields === 0 && id !== 3 && id !== 7){
                if(
                    (isRequired[element.fieldName] && isRequired[element.fieldName] === true) || 
                    (isRequired[element.fieldName] === undefined && element.isRequired === 1)
                ){
                    if(element.isActive === 1 && (element.value === null || element.value === "") && element.fieldType !== 'CheckList'){
                        if( element.fieldType === 'File'){
                            setValidationError((prevState) => ({
                                ...prevState,
                                [element.fieldName] : 'Invalid'
                            }))
                        }

                        async function checkFieldCondition(fieldName, fieldId) {
                            const fieldInDebData = debData.hasOwnProperty(fieldName);
                            const fieldInInputValue = inputValue.current.hasOwnProperty(fieldName);
                            const isDebDataEmpty = fieldInDebData && debData[fieldName] === "";
                            const isInputValueEmpty = fieldInInputValue && inputValue.current[fieldName].trim() === "" ;
                            const fieldInInputOnChange = inputOnChange.current.some(
                                (inputObject) => inputObject.fieldId === fieldId && inputObject.value && inputObject.value.trim() !== ""// Assuming 'field' represents 'fieldId'
                            );
                            
                            if(element.value === ''){
                                let modifiedInput = inputOnChange.current.find((inputObject) => inputObject.fieldId === fieldId)
                                if(modifiedInput){
                                    enteredValue = modifiedInput.value;
                                }
                            }else{
                                enteredValue = element.value
                            }
                    
                            // Scenario 1: Field is present in debData (empty) & inputValue (empty) & value is empty
                            if (isDebDataEmpty && isInputValueEmpty) {
                                isError = true;
                                proceedFlag = false;        //If error exist set flag to false
                                errorMessage = `${element.fieldName} is required`
                                // await updateTextError(element.fieldName, { isError, errorMessage });
                                return true;
                            }
                            // Scenario 2: Field is not present in all
                            if (!fieldInDebData && !fieldInInputValue && !fieldInInputOnChange) {
                                isError = true;
                                proceedFlag = false;        //If error exist set flag to false
                                // errorMessage = `${element.fieldName} is required`
                                errorFields.push(element.fieldName);
                                // await updateTextError(element.fieldName, { isError, errorMessage });
                                // return true;
                            }
                    
                            // Scenario 3: Field is not present in debData and fieldInInputOnChange but present in inputValue and is empty
                            if (!fieldInDebData && fieldInInputValue && isInputValueEmpty && !fieldInInputOnChange) {
                                isError = true;
                                proceedFlag = false;        //If error exist set flag to false
                                errorMessage = `${element.fieldName} is required`
                                // await updateTextError(element.fieldName, { isError, errorMessage });
                                return true;
                            }

                            // Scenario 4: Field in input value and in inputOnChange
                            // if ((fieldInInputValue && !isInputValueEmpty && fieldInInputOnChange) || (fieldInInputValue && isInputValueEmpty && fieldInInputOnChange)) {
                            //     console.log('in scenario 4');
                            //     console.log(fieldName);

                            //     const validationResults = await Promise.all(
                            //         element.fieldValidations.map(async (x) => {
                            //             switch (x.property) {
                            //                 case 'MinLength':
                            //                     if (enteredValue.length < parseInt(x.value)) {
                            //                         isError = true;
                            //                         proceedFlag = false;
                            //                         errorMessage = `Minimum length is ${x.value}`;
                                                    
                            //                         await updateTextError(element.fieldName, { isError, errorMessage });

                            //                         return true;
                            //                     }
                            //                 break;
                            //                 case 'MaxLength':
                            //                     if (enteredValue.length > parseInt(x.value)) {
                            //                         isError = true;
                            //                         proceedFlag = false;
                            //                         errorMessage = `Maximun length is ${x.value}`;
                                                    
                            //                         await updateTextError(element.fieldName, { isError, errorMessage });

                            //                         return true;
                            //                     }
                            //                 break;
                            //                 case 'InputType':
                            //                     if (x.value === 'Numbers only') {
                            //                         const numberRegex = /^[0-9]*$/;
                            //                         if (!numberRegex.test(enteredValue)) {
                            //                             isError = true;
                            //                             proceedFlag = false;
                            //                             errorMessage = 'Only numbers are allowed';
                            //                             await updateTextError(element.fieldName, { isError, errorMessage });
                            //                             return true; // Validation failed
                            //                         }
                            //                     }
                            //                     // break;

                            //                     if(x.value === 'Email'){
                            //                         const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                            //                         if(!emailRegex.test(enteredValue)){
                            //                             isError = true;
                            //                             proceedFlag = false;
                            //                             errorMessage = 'Please enter email address in format: yourname@example.com';
                            //                             await updateTextError(element.fieldName, { isError, errorMessage });
                            //                             return true;
                            //                         };
                            //                     }
                            //                     // break;

                            //                     if(x.value === 'Alphanumeric'){
                            //                         let AlphanumericRegex = /^[a-zA-Z0-9_ ]*$/;
                            //                         if(!AlphanumericRegex.test(enteredValue)){
                            //                             isError = true;
                            //                             proceedFlag = false
                            //                             errorMessage = "Only the following characters are allowed: alphabets (A-Z, a-z) and numbers (0-9)"
                            //                             // await updateTextError(element.fieldName, { isError, errorMessage });
                            //                             return true;
                            //                         };
                            //                     }
                            //                     // break;

                            //                     if(x.value === 'Alphanumeric (With special characters)'){
                            //                         let AlphanumericSpecialRegex =  /^[a-zA-Z0-9-,.:()_@+; ]*$/;
                            //                         if(!AlphanumericSpecialRegex.test(enteredValue)){
                            //                             isError = true;
                            //                             proceedFlag = false;
                            //                             errorMessage = "Only the following characters are allowed: alphabets (A-Z, a-z), numbers (0-9), and special characters (@, ., (, ), /, _, -, :, +, ;)";
                            //                             // await updateTextError(element.fieldName, { isError, errorMessage });
                            //                             return true;
                            //                         };
                            //                     }
                            //                     // break;

                            //                     if(x.value === 'Text only (With special characters)'){
                            //                         let textSpecialRegex =/^[a-zA-Z-+' ]*$/;
                            //                         if(!textSpecialRegex.test(enteredValue)){
                            //                             isError = true;
                            //                             proceedFlag = false;
                            //                             errorMessage = "Only the following characters are allowed: alphabets (A-Z, a-z), special characters (',  -,  +)";
                            //                             // await updateTextError(element.fieldName, { isError, errorMessage });
                            //                             return true;
                            //                         };
                            //                     }
                            //                     // break;

                            //                     if(x.value === 'Text only'){
                            //                         let textSpecialRegex =/^[a-zA-Z ]*$/;
                            //                         if(!textSpecialRegex.test(enteredValue)){
                            //                             isError = true;
                            //                             proceedFlag = false;
                            //                             errorMessage = "Only alphabets are allowed"
                            //                             // await updateTextError(element.fieldName, { isError, errorMessage });
                            //                             return true;
                            //                         };
                            //                     }
                            //                     // break;

                            //                 default:
                            //                     return false; // Validation passed
                            //             }
                            //         })
                            //     );

                            //     // If any validation failed, return true
                            //     if (validationResults.includes(true)) {
                            //         return true;
                            //     }
                            // }
                    
                            return false;
                        }
                    
                        const checkCondition = await checkFieldCondition(element.fieldName, element.fieldId)
                        if(checkCondition === true){
                            isError = true;
                            proceedFlag = false;
                            await updateTextError(element.fieldName, { isError, errorMessage })
                        } else{
                            isError = false
                            proceedFlag = true;
                            errorMessage = '';
                            await updateTextError(element.fieldName, { isError, errorMessage });
                        }

                        if (errorFields.length > 0) {
                            for (const fieldName of errorFields) {
                                await updateTextError(fieldName, { isError: true, errorMessage: `${fieldName} is required` });
                            }
                            window.scrollTo({ top: 0, behavior: 'smooth' });
                            return;
                        }
                        
                        // if (checkFieldCondition(element.fieldName, element.fieldId)) {
                        //     console.log('in')
                        //     isError = true;
                        //     proceedFlag = false;        //If error exist set flag to false
                        //     errorMessage = `${element.fieldName} is required`
                        //     await updateTextError(element.fieldName, { isError, errorMessage });
                        // }
                        // if((debData[element.fieldName] === undefined || (debData[element.fieldName] !== undefined && debData[element.fieldName] === '')) || (inputValue[element.fieldName] === undefined || inputValue[element.fieldName] === '' || Object.keys(inputValue).length === 0)){
                        //     isError = true;
                        //     proceedFlag = false;        //If error exist set flag to false
                        //     errorMessage = `${element.fieldName} is required`
                        //     await updateTextError(element.fieldName, { isError, errorMessage });
                        // }
                        
                    }
                }

                if((isRequired[element.fieldName] ? (isRequired[element.fieldName] === true ) : element.isRequired === 1 )  && element.isActive === 1 && element.fieldType === 'CheckList'){
                    await Promise.all(element.fieldValidations.map(async x => {
                        // const trueCount = Object.values(checkedItems.current[element.fieldName]).filter(value => value).length;
                        const trueCount = checkedItems?.current[element.fieldName]
                            ? Object.values(checkedItems.current[element.fieldName]).filter(value => value).length
                            : 0;
                        switch (x.property) {
                        case 'MinSelections':
                          if (trueCount < parseInt(x.value)) {
                            isError = true;
                            proceedFlag = false;
                            errorMessage = `Please select atleast ${x.value} options`;
                            await updateTextError(element.fieldName, { isError, errorMessage });
                          }else{
                            isError = false;
                            proceedFlag = true;
                            errorMessage = '';
                            await updateTextError(element.fieldName, { isError, errorMessage });
                          }
                          break;
                        case 'MaxSelections':
                          if (trueCount > parseInt(x.value)) {
                            isError = true;
                            proceedFlag = false;
                            errorMessage = `You can only select up to ${x.value} options`;
                            await updateTextError(element.fieldName, { isError, errorMessage });
                          }else{
                            isError = false;
                            proceedFlag = true;
                            errorMessage = '';
                            await updateTextError(element.fieldName, { isError, errorMessage });
                          }
                          break;
                      }
                    }));
                }

                if((isRequired[element.fieldName] ? (isRequired[element.fieldName] === true ) : element.isRequired === 1 ) && element.isActive === 1 && element.fieldType === 'CheckBox'){
                    const elementId = document.getElementById(element?.dbColumnName);
                    if(elementId){
                        if(elementId.checked === false){
                            isError = true;
                            proceedFlag = false; 
                            errorMessage = `${element.fieldName} is required`
                            // alert("Stop")
                            setErrorLabel(true);
                            await updateTextError(element.fieldName, { isError, errorMessage });
                        }
                    }
                }
            }
            
        });

        let filteredSections = data.sections.filter(section => section.parentSectionId === 0 && section.isActive === 1);
        let sortedSections = filteredSections.sort((a, b) => b.sequence - a.sequence);
        let lastSection = sortedSections[0];

        if(sortedSections[0].sectionId === 14 && Insterested === '1'){
            lastSection = sortedSections[0]
        }else if(sortedSections[0].sectionId === 14 && Insterested !== '1'){
            lastSection = sortedSections[1]
        }

        let requireFlag = 0
        let renderToSection = ''
        if(sectionId === lastSection.sectionId){
            data.sections.forEach((sec) => {
                if (sec.isMultipleFields === 1) {
                sec.fieldsList = sec.fieldsList.filter(field => 
                    field.multipleSequence === Math.min(...sec.fieldsList.filter(f => f.isActive === 1).map(f => f.multipleSequence))
                );
                }
                let shouldCheckRequired = false;
                if(sec.isActive === 1 && sec.parentSectionId === 0){
                    shouldCheckRequired = true;
                } else if(sec.isActive === 1 && sec.parentSectionId !== 0){
                    const parentSec = data.sections.find(s => s.sectionId === sec.parentSectionId);
                    if(parentSec && parentSec.isActive === 1){
                        shouldCheckRequired = true;
                    }
                }
                if(shouldCheckRequired){
                    sec.fieldsList.forEach((element) => {
                    if(isDebFieldLocked(element)){
                    return;
                }

                if (((isRequired[element.fieldName] && isRequired[element.fieldName] === true) ||
                        (isRequired[element.fieldName] === undefined && element.isRequired === 1)) && (element.value === '') && id !== element.sectionId && element.isActive === 1) {
                        renderToSection = element
                        requireFlag = 1
                        return;
                    }
                    })
                }
            })
            
        }


        let renderSection = data.sections.find(section => section.sectionId === renderToSection.sectionId)
        setEditSection(renderSection)

        if(requireFlag === 1){
            setIsModalOpen(true)
            setTitleMsg('')
            setContent(`Please complete all required fields in the ${renderSection.sectionName}. You will be redirected to the incomplete section`)
            setModalContentIdentity('confirmation')
            return;
        }

        const currentSectionFields = currentSec?.fieldsList || [];
        // When the multi-sequence template row was legitimately empty (typed-then-cleared),
        // skip stale hasTextError blocking — errors were queued to clear this tick.
        const hasTextError = templateRowClearedForProceed ? false : Object.entries(textError).some(([fieldName, error]) => {
            if (!error.isError) return false;
            // Find the field in the current section
            const field = currentSectionFields.find(f => f.fieldName === fieldName);
            if (!field) return false;
            // Check if field is active and mandatory
            const isMandatory =
                field.isActive === 1 &&
                ((isRequired[field.fieldName] && isRequired[field.fieldName] === true) ||
                (isRequired[field.fieldName] === undefined && field.isRequired === 1));
            return isMandatory;
        });

        // && !hasTextError
        // If error doesn't exist save and proceed
        if(proceedFlag === true && inputValue.current !== null && isError === false && hasTextError === false){
            setLoading(true)
            setListOfFieldsArray((prevList) => {
                const updatedList = [...(Array.isArray(prevList) ? prevList : [])];
            
                inputOnChange.current.forEach((inputObject) => {
                    const existingIndex = updatedList.findIndex(
                        (item) =>
                            item.sectionId === inputObject.sectionId &&
                            item.fieldId === inputObject.fieldId &&
                            item.sequenceId === inputObject.sequenceId
                    );
            
                    if (existingIndex !== -1) {
                        // Update existing entry
                        updatedList[existingIndex] = { ...inputObject };
                    } else {
                        // Add new entry
                        updatedList.push(inputObject);
                    }
                });
            
                return updatedList; // Return the updated list to set state
            });

            saveFields(id, isMultipleFields, nextSequence, nextId, flag);
        }
    }

    // save field and section wise with model
    const saveFields = async(id, isMultipleFields, nextSequence, nextId, flag) => {
        await new Promise((resolve) => setTimeout(resolve, 200)); // Wait for state update
        
        let inputOnChangeFiltered;
        if(isMultipleFields === 1){
            inputOnChangeFiltered = inputOnChange.current.filter(
                (item) => item.sectionId === id
            )

            // Normalize multi-sequence payload:
            // 1. Group entries by sequenceId.
            // 2. Drop any sequence group where every field is empty (leftover placeholders).
            // 3. For remaining sequence groups, backfill missing fields with empty strings
            //    so the payload always carries all fields for that sequence.
            const sec = data?.sections?.find(s => s.sectionId === id);
            const activeFields = sec ? sec.fieldsList.filter(f => f.isActive === 1) : [];

            const grouped = inputOnChangeFiltered.reduce((acc, item) => {
                const key = item.sequenceId;
                if(!acc[key]) acc[key] = [];
                acc[key].push(item);
                return acc;
            }, {});

            const normalized = [];
            Object.keys(grouped).forEach(seqKey => {
                const entries = grouped[seqKey];
                const hasAnyValue = entries.some(e => e.isDelete === true || (e.value !== '' && e.value !== null && e.value !== undefined));
                if(!hasAnyValue) return; // skip all-empty sequence

                const seqNum = Number(seqKey);
                activeFields.forEach(field => {
                    const existing = entries.find(e => e.fieldId === field.fieldId);
                    if(existing){
                        normalized.push(existing);
                    }else{
                        normalized.push({
                            sectionId: id,
                            fieldId: field.fieldId,
                            sequenceId: seqNum,
                            value: '',
                            imageExtension: '',
                            imageSize: '',
                            fieldRefType: '',
                            fieldRefTypeId: 0,
                            fieldTypeId: field.fieldTypeId,
                            isDelete: false,
                        });
                    }
                });
            });

            inputOnChangeFiltered = normalized;
        } else if(id === 3){
            inputOnChangeFiltered = inputOnChange.current.filter(
                (item) => [3, 9, 10].includes(item.sectionId)
            );
        } else {
            inputOnChangeFiltered = inputOnChange.current;
        }
        
        const requestModel =  {
            "enquiryId": enquiryId,
            "userId": loggedInUser === 'admin' && sessionStorage.getItem('actionType') === 'Edit' ? parseInt(sessionStorage.getItem('userId')) : 0,
            "admissionFormId": admissionFormId,
            "listOfSection": [
                {
                "sectionId": id,
                "isMultiple": isMultipleFields,
                "listOfFields": id === 4 
                    ? [] 
                    : ((id === 3 || id === 11) 
                        ? inputOnChangeFiltered.length > 0 
                            ? inputOnChangeFiltered 
                            : (Array.isArray(listOfFieldsArray) 
                            ? listOfFieldsArray.filter(item => item.sectionId !== 5 && item.sectionId !== 6) 
                            : []) 
                        : inputOnChangeFiltered.length > 0 
                            ? inputOnChangeFiltered 
                            : (Array.isArray(listOfFieldsArray) 
                            ? listOfFieldsArray 
                            : []))

                // "listOfFields": id === 4 ? [] : ((id === 3 || id === 11) ? listOfFieldsArray.filter(item => item.sectionId !== 5 && item.sectionId !== 6) : (listOfFieldsArray.filter(item => item.sectionId === id)))
                }
            ]
        }
        // Section wise Save API
        try{
            const { statusCode,loading,error } = await CallAPI(saveField, 'POST', { requestModel })
            setSaveApiResponse(statusCode);

            if(statusCode === 200){
                setLastSaveSection(id)
                // setInputValue({})
                inputValue.current = {}
                // setTableValue({})
                tableValue.current = {}
                setListOfFields({})
                setListOfFieldsArray([])
                setTextError({})
                inputOnChange.current = []
                setFile(null)

                if(id > 2){
                    setDebData({})
                }

                const currentSequence = data.sections.find(sec => sec.sectionId === id).sequence;
                if(data.feeAppToSec && data.feeAppToSec !==0 && currentSequence === data.feeAppToSec && data.paymentStatus === 0){
                    Navigate('/preview', { state: { CategoryId: CategoryId, CourseId:CourseId, enquiryId: enquiryId, name: name } } )
                }                

                const currentSection = data.sections.find(sec =>sec.sectionId === id)
                let nextSec = data.sections.find(n => n.sequence === currentSection.sequence + 1);

                while (nextSec !== undefined && nextSec.isActive === 0) {
                    let currentSequence = nextSec.sequence + 1;
                    nextSec = data.sections.find(y => y.sequence === currentSequence);
                }

                try {
                    const { data,loading,error } = await CallAPI(Form, 'POST', { 
                         "unvId": univId,
                         "categoryId": CategoryId,
                         "courseId": CourseId,
                         "isMultiFieldSection": nextSec.isMultipleFields,
                        "sectionId": nextSec.sectionId,
                        "isPreview": 0,
                         "enquiryId": enquiryId,
                         "mobileNo": mobileNo,
                         "dob": dateOfBirth,
                         "name": name,
                        "AdminUserId": adminUserId,
                        "Action": action
                     }
                   ); 
                     setData(data);
                     setLastActiveSec(data.lastActiveSection)
                     sessionStorage.setItem('lastActiveSection', data.lastActiveSection)
                     setTimeout(() => {
                        setLoading(false); // Set loading state to false after a short delay
                      }, 1000);
                } catch (error) {
                    console.error('Error fetching data:', error);
                    setTimeout(() => {
                        setLoading(false); // Set loading state to false after a short delay
                      }, 5000);
                }
                    if(nextSequence !== null){
                        let currentSec = data.sections.find(sec => sec.sectionId === id)        // For section name in save message 
                        var nextSection = data.sections.find(section => section.sequence === nextSequence && section.parentSectionId === 0);
                        // let lastSection = tempData.sections.pop();
                        // let lastSectionId = lastSection.sectionId;
                        if(nextSection === undefined){
                            Navigate('/preview', { state: { lastActiveSection: lastActiveSection, CategoryId: CategoryId, CourseId:CourseId, enquiryId: enquiryId, name: name } })
                        }  
                        if( nextSection.isActive === 1 && nextSection.parentSectionId === 0 && nextSection.sectionId !== 14){
                            setId(nextSection.sectionId)
                            setCurrentSection(nextSection.sectionId)  //  Set active section id
                            setActiveId(nextSection.sectionId)
                            setActiveId(nextSection.sectionId)
                            setSnackbarOpen(true);
                            setSuccessMessage(
                                <Box sx={{display: 'flex'}}>
                                    <CheckCircleIcon sx={{color: '#17AA00', 
                                        '& .MuiSvgIcon-root': {
                                            fill: '#FFFFFF', // white tick
                                        },
                                    }}/>
                                    <Typography>&nbsp;your {currentSec.sectionName} have been successfully saved.</Typography>
                                </Box>
                            )
                        } else if(nextSection.sectionId === 14 && Insterested === '1'){
                            setId(nextSection.sectionId)
                            setCurrentSection(nextSection.sectionId)  //  Set active section id
                            setActiveId(nextSection.sectionId)
                        }
                        else{
                            let nextSec = data.sections.find(n => n.sequence === nextSection.sequence + 1);

                            while (nextSec !== undefined && nextSec.isActive === 0) {
                                let currentSequence = nextSec.sequence + 1;
                                nextSec = data.sections.find(y => y.sequence === currentSequence);
                            }

                            if(nextSec && nextSec.sectionId !== 14){
                                setId(nextSec.sectionId)
                                setCurrentSection(nextSec.sectionId)
                                setActiveId(nextSec.sectionId)
                            }else if(nextSec && nextSec.sectionId === 14 && Insterested === '1'){
                                setId(nextSec.sectionId)
                                setCurrentSection(nextSec.sectionId)
                                setActiveId(nextSec.sectionId)
                            }else {
                                Navigate('/preview', { state: { lastActiveSection: lastActiveSection, CategoryId: CategoryId, CourseId:CourseId, enquiryId: enquiryId, name: name } })
                            }
                        }    
                    }else{
                        // // Set the section based on sectionId from navbar
                        setId(nextId);
                        setCurrentSection(nextId)
                        setActiveId(nextId)
                    }
                    
                    if(flag === 1){
                        setCurrentSection(nextId);
                    }
    
                    window.scrollTo(0, 0);      //Scroll on top of the page on save and continue
                     // }
            }
        }catch(error){
            console.log(error);
        }
    }


    // Fetch saved multi-sequence rows from server and bind into the table for the given section
    const bindMultiSequenceTable = async (sectionId) => {
        try {
            const response = await CallAPI(getMultiSequenceData, 'POST', {
                enquiryId: enquiryId,
                sectionId: sectionId
            });

            if (!response || response.isSuccess !== true || !Array.isArray(response.data)) {
                setMandatoryMsg(response?.message || 'Failed to load saved data. Please try again.');
                setSnackbarOpen(true);
                return false;
            }

            const sec = data.sections.find(s => s.sectionId === sectionId);
            if (!sec) return false;

            const fieldById = new Map(sec.fieldsList.map(f => [f.fieldId, f]));
            const rowsBySequence = [];

            response.data
                .slice()
                .sort((a, b) => a.sequence - b.sequence)
                .forEach(item => {
                    const rowIndex = item.sequence - 1;
                    if (rowIndex < 0) return;

                    const template = sec.fieldsList
                        .filter(f => f.isActive === 1)
                        .reduce((acc, f) => { acc[f.fieldName] = ""; return acc; }, {});

                    // Preserve original server sequence so gaps (e.g. missing seq 3) don't
                    // shift subsequent rows when the table compacts undefined slots.
                    template._sequenceId = item.sequence;

                    (item.fields || []).forEach(fr => {
                        const field = fieldById.get(fr.fieldId);
                        if (!field) return;
                        let displayValue = fr.value;

                        if ((field.fieldType === 'DropDown' || field.fieldType === 'RadioButton') && field.fieldDataSource && fr.value !== "" && fr.value !== null && fr.value !== undefined) {
                            const pairs = field.fieldDataSource
                                .split("+")
                                .filter(Boolean)
                                .map(kv => {
                                    const [k, v] = kv.split("=");
                                    return { key: k, value: v };
                                });
                            const match = pairs.find(p => p.key === String(fr.value));
                            if (match) displayValue = match.value;
                        }
                        template[field.fieldName] = displayValue;
                    });

                    rowsBySequence[rowIndex] = template;
                });

            const compactRows = rowsBySequence.filter(r => r !== undefined);

            setTableInputValue(prev => ({
                ...prev,
                [sectionId]: compactRows
            }));

            setTableRowSequence(prev => ({
                ...prev,
                [sectionId]: compactRows.length + 1
            }));

            return true;
        } catch (err) {
            console.log(err);
            setMandatoryMsg('Failed to load saved data. Please try again.');
            setSnackbarOpen(true);
            return false;
        }
    }

    // Add filled values into table
    const addData = async (sectionId) => {
        let sec = data.sections.find(section => section.sectionId === sectionId);
        // Restrict validation to the template (input) row only. Without this filter, saved
        // rows' fields (multipleSequence 1, 2, ...) leak into the mandatory check and
        // pre-filled values from earlier rows silently satisfy the mandatory rule.
        const activeFields = sec.fieldsList.filter(field => field.isActive === 1);
        const templateSequence = Math.min(...activeFields.map(f => f.multipleSequence));
        let fieldList = activeFields.filter(field => field.multipleSequence === templateSequence);
        let isError = false;
        let errorMessage = '';
        let proceedFlag = true;

        if(isError === false){
            // Validate synchronously so `isError`/`proceedFlag` are settled before the
            // save block runs. fieldList is already restricted to the template row, so we
            // don't need the multipleSequence !== 1 escape hatch anymore.
            for(const element of fieldList){
                if(element.isActive !== 1) continue;
                const requiredCheck =
                    (isRequired[element.fieldName] === undefined && element.isRequired === 1) ||
                    isRequired[element.fieldName] === true;
                if(!requiredCheck) continue;

                const isRadio = element?.fieldType === 'RadioButton';
                const currentValue = isRadio ? radioButtonValue[element.fieldName] : inputValue.current[element.fieldName];
                const isEmpty = currentValue === undefined || currentValue === null || currentValue === '';

                if(isEmpty){
                    isError = true;
                    proceedFlag = false;
                    errorMessage = `${element.fieldName} is required`;
                    if((loggedInUser !== 'admin' || (loggedInUser === 'admin' && sessionStorage.getItem('actionType') === 'Edit'))){
                        await updateTextError(element.fieldName, { isError, errorMessage });
                    }
                }
            }
        }

        if(isError === true || proceedFlag === false){
            window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
            return;
        }

        const hasRowInput = (inputOnChange.current && inputOnChange.current.length > 0)
            || Object.keys(tableValue.current || {}).length > 0
            || Object.keys(radioButtonValue || {}).length > 0;
        if(hasRowInput && proceedFlag === true && isError === false){           // If all inputs are not null then add values in table
            const template = sec.fieldsList
            .filter(field => field.isActive === 1)
            .reduce((acc, field) => {
                acc[field.fieldName] = "";
                return acc;
            }, {});

            // Merge the template with the inputValue
            const completeInputValue = { ...template, ...tableValue.current };
            const allRows = tableInputValue[sectionId] || [];
            // In edit mode, exclude the row being edited from duplicate checks so
            // editing non-key fields (e.g. marks/grade) on the row doesn't collide with
            // its own persisted values.
            const editingRowIndex = editFlag === 1 ? (tableRowSequence[sectionId] - 1) : -1;
            const existingRows = allRows.filter((_, idx) => idx !== editingRowIndex);

            // --- Duplicate check start ---
            const isDuplicate = existingRows.some(row =>
                Object.keys(completeInputValue).every(
                    key => row[key] === completeInputValue[key]
                )
            );
            if (isDuplicate) {
                setMandatoryMsg("Duplicate entry not allowed.");
                setSnackbarOpen(true);
                return; // Do not add duplicate
            }

            // --- Per-field uniqueness check ---
            for (const field of fieldList) {
                if (field.isDuplicate === 1) {
                    const value = completeInputValue[field.fieldName];
                    const isFieldDuplicate = existingRows.some(row => row[field.fieldName] === value);
                    if (isFieldDuplicate) {
                        setMandatoryMsg(`Duplicate entry not allowed for ${field.fieldName}.`);
                        setSnackbarOpen(true);
                        window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
                        return;
                    }
                }
            }
            if(editFlag === 1){
                replaceRecord(sectionId, tableRowSequence[sectionId]-1)
            }

            sec.fieldsList.forEach((field) => {
                const isFieldPresent = inputOnChange.current.some(
                    (item) => item.fieldId === field.fieldId && item.sectionId === field.sectionId && item.sequenceId === tableRowSequence[sectionId]
                );
        
                if (!isFieldPresent) {
                    // Append the missing field with an empty string as the value
                    inputOnChange.current.push({
                        sectionId: field.sectionId,
                        fieldId: field.fieldId,
                        sequenceId: tableRowSequence[sectionId], // Use the current sequence ID
                        value: "", // Empty string for missing fields
                        imageExtension: "",
                        imageSize: "",
                        fieldRefType: field.fieldRefType || "",
                        fieldRefTypeId: field.fieldRefTypeId || 0,
                        fieldTypeId: field.fieldTypeId || 0,
                        isDelete: false,
                    });
                }
            });
    
            inputValue.current = {}           // set input value to empty
            setSelectedDate(null)           // set selected date to null
            pickedData.current = null
            setRadioButtonValue({})         // set radio button value to empty
            tableValue.current = {}

            // Clear validation errors for this section's fields now that the row was added successfully
            const sectionFieldNames = new Set(sec.fieldsList.map(f => f.fieldName));
            setTextError(prev => {
                const next = { ...prev };
                sectionFieldNames.forEach(name => { delete next[name]; });
                return next;
            });
            setIsRequired(prev => {
                const next = { ...prev };
                sectionFieldNames.forEach(name => {
                    if (Object.prototype.hasOwnProperty.call(next, name)) {
                        next[name] = false;
                    }
                });
                return next;
            });
            if(editFlag === 0){
                setTableRowSequence((prevTableRowSequence) => ({
                    ...prevTableRowSequence,
                    [sectionId]: tableInputValue[sectionId] ? tableInputValue[sectionId].length + 2 : 2
                    // [sectionId]: tableRowSequence[sectionId] + 1,
                }));

                // Reset all dependency-driven state (isRequired, disabledFields,
                // fieldVisibility) for the fields dependent on this section's controls,
                // so the fresh template row starts with default flags regardless of the
                // parent radio/dropdown selection made for the row just added.
                if (data && data.fieldDepedancyList) {
                    const currentSectionFieldIds = new Set(
                        (sec?.fieldsList || []).map(f => String(f.fieldId))
                    );
                    const dependentFieldNames = new Set();

                    data.fieldDepedancyList.forEach(entry => {
                        // Only process dependency entries whose *parent* field lives in the current section.
                        if (!currentSectionFieldIds.has(String(entry.fieldId))) return;
                        (entry.fieldDepedancies || []).forEach(d => {
                            const targetSec = data.sections.find(s => s.sectionId === parseInt(d.sectionId)) || sec;
                            const targetField = targetSec?.fieldsList.find(f => String(f.fieldId) === String(d.fieldId));
                            if (targetField) dependentFieldNames.add(targetField.fieldName);
                        });
                    });

                    if (dependentFieldNames.size > 0) {
                        setIsRequired(prev => {
                            const next = { ...prev };
                            dependentFieldNames.forEach(name => { delete next[name]; });
                            return next;
                        });
                        setDisabledFields(prev => {
                            const next = { ...prev };
                            dependentFieldNames.forEach(name => { delete next[name]; });
                            return next;
                        });
                        setFieldVisibility(prev => {
                            const next = { ...prev };
                            dependentFieldNames.forEach(name => { delete next[name]; });
                            return next;
                        });
                    }
                }

                // setInputTrigger(prev => prev + 1);
                try {
                    await fieldWiseSave(true);
                    await bindMultiSequenceTable(sectionId);
                } catch (saveErr) {
                    console.log(saveErr);
                    setMandatoryMsg('Failed to save data. Please try again.');
                    setSnackbarOpen(true);
                }
            }else{
                const lengthOfArray = tableInputValue[sectionId] ? tableInputValue[sectionId].length: 0;
                setTableRowSequence((prevTableRowSequence) => ({
                    ...prevTableRowSequence,
                    [sectionId]: lengthOfArray+1,
                }));

                // Reset all dependency-driven state (isRequired, disabledFields,
                // fieldVisibility) for the fields dependent on this section's controls,
                // so the fresh template row starts with default flags regardless of the
                // parent radio/dropdown selection made for the row just added.
                if (data && data.fieldDepedancyList) {
                    const currentSectionFieldIds = new Set(
                        (sec?.fieldsList || []).map(f => String(f.fieldId))
                    );
                    const dependentFieldNames = new Set();

                    data.fieldDepedancyList.forEach(entry => {
                        // Only process dependency entries whose *parent* field lives in the current section.
                        if (!currentSectionFieldIds.has(String(entry.fieldId))) return;
                        (entry.fieldDepedancies || []).forEach(d => {
                            const targetSec = data.sections.find(s => s.sectionId === parseInt(d.sectionId)) || sec;
                            const targetField = targetSec?.fieldsList.find(f => String(f.fieldId) === String(d.fieldId));
                            if (targetField) dependentFieldNames.add(targetField.fieldName);
                        });
                    });

                    if (dependentFieldNames.size > 0) {
                        setIsRequired(prev => {
                            const next = { ...prev };
                            dependentFieldNames.forEach(name => { delete next[name]; });
                            return next;
                        });
                        setDisabledFields(prev => {
                            const next = { ...prev };
                            dependentFieldNames.forEach(name => { delete next[name]; });
                            return next;
                        });
                        setFieldVisibility(prev => {
                            const next = { ...prev };
                            dependentFieldNames.forEach(name => { delete next[name]; });
                            return next;
                        });
                    }
                }

                // setInputTrigger(prev => prev + 1);
                try {
                    await fieldWiseSave(true);
                    await bindMultiSequenceTable(sectionId);
                } catch (saveErr) {
                    console.log(saveErr);
                    setMandatoryMsg('Failed to save data. Please try again.');
                    setSnackbarOpen(true);
                }
            }

            setEditFlag(0)
            
        }
        isError = false;
        proceedFlag = true;
        
    }

    // For multiple record section - if value is fetched from db add into table
    useEffect(() => {
        if (data !== null) {
            const newTableInputValue = {};
            data.sections.forEach((section) => {
                // if (section.sectionId === 5 || section.sectionId === 6) {
                if (section.isMultipleFields === 1) {
                    const sortedFields = section.fieldsList
                        .slice() // Create a shallow copy to avoid mutating the original array
                        .sort((a, b) => a.sequence - b.sequence); // Assuming 'sequence' is the correct property name
                    sortedFields.forEach((field) => {
                        // Check if the field value is non-null
                        if (field.value !== null && field.value !== undefined && field.value !== "") {
                            // Initialize the sectionData array if it doesn't exist
                            if (!newTableInputValue[section.sectionId]) {
                                newTableInputValue[section.sectionId] = [];
                            }
    
                            // Ensure the array has enough elements for the given sequence
                            while (newTableInputValue[section.sectionId].length < field.multipleSequence) {
                                newTableInputValue[section.sectionId].push({});
                            }
    
                            if(field.fieldType === 'RadioButton' || field.fieldType === 'DropDown'){
                                // Resolve display label from fieldDataSource (same logic as add/bindMultiSequenceTable)
                                let displayValue = field.valueLabel;
                                if(field.fieldDataSource && field.value !== "" && field.value !== null && field.value !== undefined){
                                    const pairs = field.fieldDataSource
                                        .split("+")
                                        .filter(Boolean)
                                        .map(kv => {
                                            const [k, v] = kv.split("=");
                                            return { key: k, value: v };
                                        });
                                    const match = pairs.find(p => p.key === String(field.value));
                                    if(match) displayValue = match.value;
                                }
                                newTableInputValue[section.sectionId][field.multipleSequence - 1][field.fieldName] = displayValue;
                            }else{
                                // Add field data to the appropriate sequence-based entry
                                newTableInputValue[section.sectionId][field.multipleSequence - 1][field.fieldName] = field.value;
                            }
                            
                        }                     
                        
                    });
                    const lengthOfArray = newTableInputValue[section.sectionId] ? newTableInputValue[section.sectionId].length : 0;
                    setTableRowSequence((prevTableRowSequence) => ({
                        ...prevTableRowSequence,
                        [section.sectionId]: lengthOfArray + 1,
                    }));
    
                }
            });
            setTableInputValue(newTableInputValue);

        }
    }, [data]);

    // On landing on a multi-sequence section, refresh table from getMultiSequenceData
    // so add/edit/delete and direct-load use the same source of truth.
    useEffect(() => {
        if(data !== null && id){
            const sec = data.sections.find(s => s.sectionId === id);
            if(sec && sec.isMultipleFields === 1){
                bindMultiSequenceTable(id);
            }
        }
    }, [id, data]);

    useEffect(() => {
        if(inputOnChange.current){
            console.log(inputOnChange.current);
        }
    },[inputOnChange.current])

    // on edit add table data into inputFeilds
    const editRecord = (record, sectionId, index) => {
        let sec = data.sections.find(section => section.sectionId === sectionId)
        let fieldList = sec.fieldsList.filter(field => field.multipleSequence === Math.min(...sec.fieldsList.filter(field => field.isActive === 1).map(field => field.multipleSequence)));
        let newListOfFieldsArray = []

        fieldList.forEach(field => {
            if(field.fieldType === 'RadioButton' || field.fieldType === 'DropDown'){
                if(field.fieldType.toLowerCase() === 'dropdown' && field.fieldDataSourceType === 'API'){
                    if(modifiedApiDropdownData[field.fieldName] !== undefined){
                        const selectedData = modifiedApiDropdownData[field.fieldName].find((item) => item.value === record[field.fieldName])
                        const matchingKey = selectedData?.key.toString() || "";

                        newListOfFieldsArray.push({
                            'sectionId': sectionId,
                            'fieldId': field.fieldId,
                            'sequenceId': index + 1,
                            'value': matchingKey || "",  // Ensure to get the correct value from element
                            "imageExtension": "",
                            "imageSize": "",
                            "fieldRefType": "", 
                            "fieldRefTypeId": 0,
                            "fieldTypeId": field?.fieldTypeId,
                            "isDelete" : false,
                        });

                    }
                }
                else if(record[field.fieldName] !== ''){
                    const dataSourceArray = field.fieldDataSource.split('+');
                    const keyValuePairs = dataSourceArray.map(item => {
                        const [key, value] = item.split('=');
                        return { key, value };
                    });
                    const matchingKey = keyValuePairs.find(pair => pair.value === record[field.fieldName])?.key;

                    newListOfFieldsArray.push({
                        'sectionId': sectionId,
                        'fieldId': field.fieldId,
                        'sequenceId': index + 1,
                        'value': matchingKey || "",  // Ensure to get the correct value from element
                        "imageExtension": "",
                        "imageSize": "",
                        "fieldRefType": "", 
                        "fieldRefTypeId": 0,
                        "fieldTypeId": field?.fieldTypeId,
                        "isDelete" : false,
                    });
                }
                
            }
            else{
                newListOfFieldsArray.push({
                    'sectionId': sectionId,
                    'fieldId': field.fieldId,
                    'sequenceId': index + 1,
                    'value': record[field.fieldName] || "",  // Ensure to get the correct value from element
                    "imageExtension": "",
                    "imageSize": "",
                    "fieldRefType": "", 
                    "fieldRefTypeId": 0,
                    "fieldTypeId": field?.fieldTypeId,
                    "isDelete" : false,
                });
            }

            if(field.fieldType === 'RadioButton' || field.fieldType === 'DropDown'){
                if(field.fieldDataSourceType === 'API'){
                    if(modifiedApiDropdownData[field.fieldName] !== undefined){
                        const selectedData = modifiedApiDropdownData[field.fieldName].find((item) => item.value === record[field.fieldName])
             
                        if(selectedData){
                            inputValue.current = {
                                ...inputValue.current,
                                [field.fieldName]: selectedData.key.toString()
                            };
                        }
                    }
                }else{
                    let dataSource = field.fieldDataSource
                    const map = dataSource.split('+').reduce((acc, pair) => {
                        const [key, value] = pair.split('=');
                        acc[value] = key;
                        return acc;
                    }, {});

                    inputValue.current = {
                        ...inputValue.current,
                        [field.fieldName]: map[record[field.fieldName]]
                    };
                }
            }else{
                // setInputValue((prevRecord) => ({
                //     ...prevRecord,
                //     [field.fieldName]: record[field.fieldName] !== undefined ? record[field.fieldName] : ''
                // }));

                inputValue.current = {
                    ...inputValue.current,
                    [field.fieldName]: record[field.fieldName] !== undefined ? record[field.fieldName] : ''
                };

                if(field.fieldType === 'Date'){
                    pickedData.current = {
                        ...pickedData.current,
                        [field.fieldName]: record[field.fieldName] !== undefined ? record[field.fieldName] : ''
                    }

                    setRadioButtonValue((prevValue) => ({ 
                        ...prevValue,
                        [field.fieldName]: record[field.fieldName] !== undefined ? record[field.fieldName] : ''
                    }));
                }
            }
        });

        tableValue.current = {
            ...tableValue.current,
            ...record
        }

        inputOnChange.current = ([
            ...inputOnChange.current,
            ...newListOfFieldsArray
        ])

        // Re-apply field dependencies for the record being edited so dependent fields
        // reflect the correct mandatory/disabled/visibility state driven by this row's
        // populated parent values (the on-load effect intentionally skips intra-section
        // multi-field deps, so edit must resolve them explicitly).
        if (data && data.fieldDepedancyList) {
            fieldList.forEach(parentField => {
                const parentEntry = data.fieldDepedancyList.find(
                    e => parseInt(e.fieldId, 10) === parentField.fieldId
                );
                if (!parentEntry) return;

                const parentValue = inputValue.current[parentField.fieldName];
                if (parentValue === undefined || parentValue === null || parentValue === '') return;

                parentEntry.fieldDepedancies.forEach(dep => {
                    const depSec = data.sections.find(s => s.sectionId === parseInt(dep.sectionId));
                    if (!depSec) return;
                    let depField = depSec.fieldsList.find(f => f.fieldId === parseInt(dep.fieldId));
                    if (dep.fieldId === '54' && dep.fieldRefId !== '') {
                        depField = depSec.fieldsList.find(f => f.fieldDataSource === dep.fieldRefId);
                    }
                    if (!depField) return;

                    const matches = Array.isArray(dep.value)
                        ? dep.value.includes(String(parentValue))
                        : String(dep.value).includes(String(parentValue));
                    if (!matches) return;

                    switch (dep.dependancyType) {
                        case '2':
                            setIsRequired(prev => ({ ...prev, [depField.fieldName]: true }));
                            break;
                        case '4':
                            setIsRequired(prev => ({ ...prev, [depField.fieldName]: false }));
                            break;
                        case '5':
                            setDisabledFields(prev => ({ ...prev, [depField.fieldName]: true }));
                            break;
                        case '6':
                            setDisabledFields(prev => ({ ...prev, [depField.fieldName]: false }));
                            break;
                        case '7':
                            setFieldVisibility(prev => ({ ...prev, [depField.fieldName]: false }));
                            break;
                        case '8':
                            setFieldVisibility(prev => ({ ...prev, [depField.fieldName]: true }));
                            break;
                        default:
                            break;
                    }
                });
            });
        }

        // setInputTrigger(prev => prev + 1);
        setEditFlag(1);
        setTableRowSequence((prevTableRowSequence) => ({
            ...prevTableRowSequence,
            [sectionId]: index + 1,
        }));

        window.scroll(0, 0);

    };

    const replaceRecord = async (sectionId, rowIndex) => {
        let sec = data.sections.find(section => section.sectionId === sectionId)
        let fieldList = sec.fieldsList.filter(field => field.multipleSequence === 1);
        const modifiedArray = [...tableInputValue[sectionId]]; // Get the array for the specified sectionId
        modifiedArray.splice(rowIndex, 1); // Remove one element at the specified rowIndex

        const newModifiedListOfFieldsArray = []

        modifiedArray.forEach((element, index) => {
            fieldList.forEach(field => {
                if(field.fieldType === 'RadioButton' || field.fieldType === 'DropDown'){
                    if(element[field.fieldName] !== ''){
                        const dataSourceArray = field.fieldDataSource.split('+');
                        const keyValuePairs = dataSourceArray.map(item => {
                            const [key, value] = item.split('=');
                            return { key, value };
                        });
                        const matchingKey = keyValuePairs.find(pair => pair.value === element[field.fieldName])?.key;

                        newModifiedListOfFieldsArray.push({
                            'sectionId': sectionId,
                            'fieldId': field.fieldId,
                            'sequenceId': index+1,
                            'value': matchingKey || "",  // Ensure to get the correct value from element
                            "imageExtension": "",
                            "imageSize": "",
                            "fieldRefType": "", 
                            "fieldRefTypeId": 0,
                            "isDelete" : false,
                        });
                    }
                    
                }else{
                    newModifiedListOfFieldsArray.push({
                        'sectionId': sectionId,
                        'fieldId': field.fieldId,
                        'sequenceId': index+1,
                        'value': element[field.fieldName] || "",  // Ensure to get the correct value from element
                        "imageExtension": "",
                        "imageSize": "",
                        "fieldRefType": "", 
                        "fieldRefTypeId": 0,
                        "isDelete" : false,
                    });
                }
            });
        });

        setTableInputValue(prevInputValue => ({
            ...prevInputValue,
            [sectionId]: modifiedArray // Update the state with the modified array for the specified sectionId
        }));
        setEditFlag(0)
        setDeleteFlag(1);   
    
        
    };
    
    // let row = 0
    // Delete row of table based on section id
    const deleteRecord = async (sectionId, rowIndex) => {
        setIsModalOpen(true)
        setTitleMsg('Delete Confirmation')
        setContent('Are you sure you want to delete this record?')
        setModalContentIdentity('alert')
        // row = rowIndex
        setRow(rowIndex)
           
        // setEditFlag(0)
        // setListOfFieldsArray(newListOfFieldsArray)
        // setDeleteFlag(1); 
        
    };

    useEffect(() => {
        if(data){
            let sec = data.sections.find(section => section.sectionId === id)

            if(modalResponse === true && sec.isMultipleFields === 1){
                deleteRecordContinue(id, row)
            }else if(modalResponse === true){
                let sec = data.sections.find(section => section.sectionId === editSection.sectionId)
                if(sec.parentSectionId !== 0){
                    setId(sec.parentSectionId)
                    setCurrentSection(sec.parentSectionId)
                    setActiveId(sec.parentSectionId)
                }else{
                    setId(editSection.sectionId)
                    setCurrentSection(editSection.sectionId)
                    setActiveId(editSection.sectionId)
                }
            }
        }
        setModalResponse(false)
    }, [modalResponse, data])

    const deleteRecordContinue = async(sectionId, rowIndex) => {
        if(modalResponse === true){
            let sec = data.sections.find(section => section.sectionId === sectionId)
            let fieldList = sec.fieldsList.filter(field => field.multipleSequence === Math.min(...sec.fieldsList.filter(field => field.isActive === 1).map(field => field.multipleSequence)))
            // let fieldList = sec.fieldsList.filter(field => field.multipleSequence === 1);
            const modifiedArray = [...tableInputValue[sectionId]]; // Get the array for the specified sectionId
            let deleteObj = modifiedArray[rowIndex]
            // Use the original server-assigned sequenceId when available (rows loaded via
            // getMultiSequenceData carry _sequenceId); fall back to rowIndex + 1 for rows
            // added client-side before a refresh.
            const deletedSequenceId = (deleteObj && deleteObj._sequenceId) ? deleteObj._sequenceId : rowIndex + 1;
            modifiedArray.splice(rowIndex, 1); // Remove one element at the specified rowIndex

            const newListOfFieldsArray = [];
            const newModifiedListOfFieldsArray = []

            if(editFlag === 1){
                modifiedArray.forEach((element, index) => {
                    fieldList.forEach(field => {
                        newModifiedListOfFieldsArray.push({
                            'sectionId': sectionId,
                            'fieldId': field.fieldId,
                            'sequenceId': rowIndex + 1,
                            'value': element[field.fieldName] || "",  // Ensure to get the correct value from element
                            "imageExtension": "",
                            "imageSize": "",
                            "fieldRefType": "", 
                            "fieldRefTypeId": 0,
                            "fieldTypeId": field?.fieldTypeId,
                            "isDelete" : false,
                        });
                    });
                });
        
                setTableInputValue(prevInputValue => ({
                    ...prevInputValue,
                    [sectionId]: modifiedArray // Update the state with the modified array for the specified sectionId
                }));
                setEditFlag(0)
                // setListOfFieldsArray(newModifiedListOfFieldsArray)
                if (newModifiedListOfFieldsArray.length > 0) {
                    newModifiedListOfFieldsArray.forEach((field) => {
                        const existingIndex = inputOnChange.current.findIndex(
                            (item) =>
                                item.sectionId === field.sectionId &&
                                item.fieldId === field.fieldId &&
                                item.sequenceId === field.sequenceId
                        );
                
                        if (existingIndex !== -1) {
                            // Update the existing object
                            inputOnChange.current[existingIndex] = field;
                        } else {
                            // Add new entry
                            inputOnChange.current.push(field);
                        }
                    });
                
                }
                setDeleteFlag(1);   
            }else{
                // Emit every field of the deleted row with isDelete: true — including untouched/non-mandatory
                // fields — so the backend removes the entire sequence, not just the filled cells.
                fieldList.forEach((field) => {
                    const rawValue = deleteObj ? deleteObj[field.fieldName] : undefined;
                    let outValue = '';

                    if(rawValue !== undefined && rawValue !== null && rawValue !== ''){
                        if(field.fieldType === 'RadioButton' || field.fieldType === 'DropDown'){
                            if(field.fieldDataSourceType === 'API'){
                                if(modifiedApiDropdownData[field.fieldName] !== undefined){
                                    const selectedData = modifiedApiDropdownData[field.fieldName].find((item) => item.value === rawValue);
                                    if(selectedData){
                                        outValue = selectedData.key.toString();
                                    }
                                }
                            }else if(field.fieldDataSource){
                                const keyValuePairs = field.fieldDataSource.split('+').map(item => {
                                    const [k, v] = item.split('=');
                                    return { key: k, value: v };
                                });
                                const selectedPair = keyValuePairs.find(pair => pair.value === rawValue);
                                outValue = selectedPair ? selectedPair.key : '';
                            }
                        }else{
                            outValue = rawValue;
                        }
                    }

                    newListOfFieldsArray.push({
                        'sectionId': sectionId,
                        'fieldId': field.fieldId,
                        'sequenceId': deletedSequenceId,
                        'value': outValue,
                        "imageExtension": "",
                        "imageSize": "",
                        "fieldRefType": "",
                        "fieldRefTypeId": 0,
                        "fieldTypeId": field?.fieldTypeId,
                        "isDelete": true,
                    });
                });

                modifiedArray.forEach((element, index) => {
                    fieldList.forEach(field => {
                        if(field.fieldType === 'RadioButton' || field.fieldType === 'DropDown'){
                            if(element[field.fieldName] !== ''){
                                if(field.fieldDataSourceType === 'API'){
                                    const selectedData = modifiedApiDropdownData[field.fieldName].find((item) => item.value === element[field.fieldName]);

                                    if(selectedData){
                                        newListOfFieldsArray.push({
                                            'sectionId': sectionId,
                                            'fieldId': field.fieldId,
                                            'sequenceId': index + 1,
                                            'value': selectedData.key.toString() || "",  // Ensure to get the correct value from element
                                            "imageExtension": "",
                                            "imageSize": "",
                                            "fieldRefType": "", 
                                            "fieldRefTypeId": 0,
                                            "fieldTypeId": field?.fieldTypeId,
                                            "isDelete" : false,
                                        });
                                    }

                                }else{
                                    const dataSourceArray = field.fieldDataSource.split('+');
                                    const keyValuePairs = dataSourceArray.map(item => {
                                        const [key, value] = item.split('=');
                                        return { key, value };
                                    });
                                    const matchingKey = keyValuePairs.find(pair => pair.value === element[field.fieldName])?.key;

                                    newListOfFieldsArray.push({
                                        'sectionId': sectionId,
                                        'fieldId': field.fieldId,
                                        'sequenceId': index + 1,
                                        'value': matchingKey || "",  // Ensure to get the correct value from element
                                        "imageExtension": "",
                                        "imageSize": "",
                                        "fieldRefType": "", 
                                        "fieldRefTypeId": 0,
                                        "fieldTypeId": field?.fieldTypeId,
                                        "isDelete" : false,
                                    });
                                }
                            }
                            
                        }else{
                            newListOfFieldsArray.push({
                                'sectionId': sectionId,
                                'fieldId': field.fieldId,
                                'sequenceId': index + 1,
                                'value': element[field.fieldName] || "",  // Ensure to get the correct value from element
                                "imageExtension": "",
                                "imageSize": "",
                                "fieldRefType": "", 
                                "fieldRefTypeId": 0,
                                "fieldTypeId": field?.fieldTypeId,
                                "isDelete" : false,
                            });
                        }
                        
                    });
                });
    
                const requestModel =  {
                    "enquiryId": enquiryId,
                    "userId": loggedInUser === 'admin' && sessionStorage.getItem('actionType') === 'Edit' ? parseInt(sessionStorage.getItem('userId')) : 0,
                    "admissionFormId": admissionFormId,
                    "listOfSection": [
                        {
                        "sectionId": sectionId,
                        "isMultiple": 1,
                        "listOfFields": newListOfFieldsArray
                        }
                    ]
                }
        
                try{
                    const { statusCode,loading,error } = await CallAPI(saveField, 'POST', { requestModel })
                    setSaveApiResponse(statusCode);
                    if(statusCode === 200){
                        setTableInputValue(prevInputValue => ({
                            ...prevInputValue,
                            [sectionId]: modifiedArray // Update the state with the modified array for the specified sectionId
                        }));
                        setEditFlag(0)
                        if(newModifiedListOfFieldsArray.length === 0){
                            setDeleteSequenceFlag(1)
                            const updatedFields = fieldList
                                .filter(field => field.multipleSequence === 0 || field.multipleSequence === 1 )
                                .map(field => ({
                                    sectionId: sec.sectionId,
                                    fieldId: field.fieldId,
                                    sequenceId: tableInputValue[id].length, // Assuming this should be dynamically set based on your logic
                                    value: '',
                                    imageExtension: "",
                                    imageSize: "",
                                    fieldRefType: "", 
                                    fieldRefTypeId: 0,
                                    fieldTypeId: field?.fieldTypeId,
                                    isDelete : false,
                            }));
                            // setListOfFieldsArray(updatedFields);
                            
                            // Update inputOnChange instead of setListOfFieldsArray
                            updatedFields.forEach(field => {
                                const existingIndex = inputOnChange.current.findIndex(
                                    item => item.sectionId === field.sectionId && item.fieldId === field.fieldId && item.sequenceId === field.sequenceId
                                );

                                if (existingIndex !== -1) {
                                    // Update the existing object
                                    inputOnChange.current[existingIndex] = field;
                                } else {
                                    // Add new entry
                                    inputOnChange.current.push(field);
                                }
                            });
                        }else{
                            // Update inputOnChange with newModifiedListOfFieldsArray
                            newModifiedListOfFieldsArray.forEach(field => {
                                const existingIndex = inputOnChange.current.findIndex(
                                    item => item.sectionId === field.sectionId && item.fieldId === field.fieldId && item.sequenceId === field.sequenceId
                                );

                                if (existingIndex !== -1) {
                                    // Update the existing object
                                    inputOnChange.current[existingIndex] = field;
                                } else {
                                    // Add new entry
                                    inputOnChange.current.push(field);
                                }
                            });
                            // setListOfFieldsArray(newListOfFieldsArray)
                        }
                        setDeleteFlag(1);           // Set the delete flag to 1 to call save function
                        setModalResponse(false);
                    }
                }
                catch(error){
                    console.log(error);
                }
            }
        }
    }

    useEffect(() => {
        if(deleteFlag === 1){
            fieldWiseSave();
            setListOfFields({})
        }
        setDeleteFlag(0)
    },[deleteFlag])

    const [sections, setSections] = useState([]);

    useEffect(() => {
		if (data !== null) {
			const updatedSections = data.sections.map(section => ({ ...section }));
			updatedSections.forEach((section) => {
                
				if (section.parentSectionId !== 0) {
                    const parentSection = updatedSections.find(parent => parent.sectionId === section.parentSectionId);
                    if (parentSection) {
                        parentSection.fieldsList = parentSection.fieldsList.concat(section.fieldsList);
                    }

                }
			});
              

            updatedSections.forEach(section => {
                if(section.sectionId === 3){
                    section.fieldsList.sort((a, b) => a.sequence - b.sequence)
                }
            })
			setSections(updatedSections);
		}
	}, [data]);

    const checkboxRef = useRef(null);
    const [isChecked, setIsChecked] = useState(false);

    const handleAddressCheckbox = (e) => {
        const checked = e.target.checked;
        setIsChecked(checked);
        copyAddress(checked);
    };

    const copyAddress = () => {
        let checkbox = document.getElementById('check');
        let corrSection = data.sections.find((section) => section.sectionId === 9)
        let perSection = data.sections.find((section) => section.sectionId === 10)

        if (checkboxRef.current.checked === true) {
            const fieldMapping = {};

            const minLength = Math.min(corrSection.fieldsList.length, perSection.fieldsList.length);
    
            for (let i = 0; i < minLength; i++) {
                if (corrSection.fieldsList[i].fieldDataSource === perSection.fieldsList[i].fieldDataSource) {
                    fieldMapping[corrSection.fieldsList[i].fieldId] = perSection.fieldsList[i].fieldId;
                }
            }

            const updatedValues = [...inputOnChange.current];

            if(updatedValues.length !== 0){
                inputOnChange.current.forEach((element) => {
                    if (fieldMapping.hasOwnProperty(element.fieldId)) {
                        const mappedFieldId = fieldMapping[element.fieldId];
                        const originalValue = element.value;
                        const sec = data.sections.find(section => section.sectionId === 10)
                        const f = sec.fieldsList.find(field => field.fieldId === mappedFieldId)

                        // Find the target element in the updatedValues array
                        const targetElement = updatedValues.find(el => el.fieldId === mappedFieldId);
                        if (targetElement) {
                            targetElement.value = originalValue;
                            
                        } else {
                            // If the target element does not exist, create a new entry for it
                            updatedValues.push({
                                // sectionId: (mappedFieldId === 13 || mappedFieldId === 14 || mappedFieldId === 42 || mappedFieldId === 43 || mappedFieldId === 44 || mappedFieldId === 45) ? 10 : element.sectionId,
                                sectionId: 10,
                                fieldId: mappedFieldId,
                                sequenceId: element.sequenceId,
                                value: originalValue,
                                imageExtension: "",
                                imageSize: "",
                                fieldRefType: "", 
                                fieldRefTypeId: 0,
                                fieldTypeId: element?.fieldTypeId,
                                isDelete: false,
                            });
                        }

                        const existingIndex = inputOnChange.current.findIndex(
                            (item) =>
                                item.sectionId === 10 &&
                                item.fieldId === mappedFieldId &&
                                item.sequenceId === element.sequenceId
                        );
        
                        if (existingIndex !== -1) {
                            inputOnChange.current[existingIndex] = {
                                sectionId: 10,
                                fieldId: mappedFieldId,
                                sequenceId: element.sequenceId,
                                value: originalValue,
                                imageExtension: "",
                                imageSize: "",
                                fieldRefType: "",
                                fieldRefTypeId: 0,
                                fieldTypeId: element?.fieldTypeId,
                                isDelete: false,
                            };
                        } else {
                            inputOnChange.current.push({
                                sectionId: 10,
                                fieldId: mappedFieldId,
                                sequenceId: element.sequenceId,
                                value: originalValue,
                                imageExtension: "",
                                imageSize: "",
                                fieldRefType: "",
                                fieldRefTypeId: 0,
                                fieldTypeId: element?.fieldTypeId,
                                isDelete: false,
                            });
                        }

                        if(originalValue && f.dbColumnName.toLowerCase() === 'pcountryid'){
                            let stateField = sec.fieldsList.find(x => x.dbColumnName.toLowerCase() === 'pstateid')
                            let filteredStateList = apiDropdownData[stateField.fieldName].filter(s => s.valueId === originalValue.toString())

                            setModifiedApiDropdownData((prevModifiedApiData) => ({
                                ...prevModifiedApiData,
                                [stateField.fieldName]: filteredStateList
                            }));
                        }
                        if(originalValue && f.dbColumnName.toLowerCase() === 'pstateid'){
                            let cityField = sec.fieldsList.find(x => x.dbColumnName.toLowerCase() === 'pcityid')
                            let filteredCityList = apiDropdownData[cityField.fieldName].filter(s => s.valueId === originalValue.toString())

                            setModifiedApiDropdownData((prevModifiedApiData) => ({
                                ...prevModifiedApiData,
                                [cityField.fieldName]: filteredCityList
                            }));

                            let districtField = sec.fieldsList.find(x => x.dbColumnName.toLowerCase() === 'pdistrictid')

                            if(districtField){
                                let filteredDistrictList = apiDropdownData[districtField.fieldName].filter(s => s.valueId === originalValue.toString())

                                setModifiedApiDropdownData((prevModifiedApiData) => ({
                                    ...prevModifiedApiData,
                                    [districtField.fieldName]: filteredDistrictList
                                }));
                            }
                        }

                        inputValue.current = {
                            ...inputValue.current,
                            [f.fieldName]: originalValue
                        };
                        // setListOfFieldsArray([])
                        // setListOfFieldsArray(updatedValues)
                        setForceRender((prev) => !prev);
                    
                    }
                });
            }
        }
        
    };

    const handleLocationClick = () => {
        if((loggedInUser !== 'admin' || (loggedInUser === 'admin' && sessionStorage.getItem('actionType') === 'Edit'))){
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(showPosition);
            } else {
                alert("Geolocation is not supported by this browser.");
            }
        }
    }


    function showPosition(position) {
        let sec = data.sections.find(section => section.sectionId === 3)
        let fields;
        
        if (sec !== undefined) {
            fields = sec.fieldsList;
            let found = fields.some((field) => {
            return field.dbColumnName.includes('StateId') || field.dbColumnName.includes('CountryId') || field.dbColumnName.includes('CityId');
            });
            
            if (!found) {
            sec = data.sections.find(section => section.sectionId === 9)
            fields = sec.fieldsList;
            }
        } else {
            sec = data.sections.find(section => section.sectionId === 9)
            fields = sec.fieldsList;
        }

        fetch(`https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=${position.coords.latitude}&longitude=${position.coords.longitude}`)
            .then(response => response.json())
            .then(data => {
                const city = data.city.trim().toLowerCase();
                const state = data.principalSubdivision.trim().toLowerCase();
                const country = data.countryName.trim().toLowerCase();
                const pincode = data.postcode;

                let updatedListOfFieldsArray = []

                let stateField = fields.find(field => field.dbColumnName.toLowerCase() === 'stateid')

                if(stateField){
                    let stateKey = apiDropdownData[stateField.fieldName].find(s => s.value.trim().toLowerCase() === state)
                    let dependentField = fields.find(field => field.dbColumnName.toLowerCase() === 'cityid')
                    let cityFilteredList = apiDropdownData[dependentField.fieldName].filter(c => c.valueId === stateKey.key.toString())
                    
                    setModifiedApiDropdownData(prevApiData => ({
                        ...prevApiData,
                        [dependentField.fieldName]: cityFilteredList
                    }))

                    // setInputValue((prevInputValue) => ({
                    //     ...prevInputValue,
                    //     [stateField.fieldName]: stateKey.key.toString()
                    // }));

                    inputValue.current = {
                        ...inputValue.current,
                        [stateField.fieldName]: stateKey.key.toString()
                    };

                    const isCreated = createObject(stateField, stateKey.key.toString())
                }

                let districtField = fields.find(field => field.dbColumnName.toLowerCase() === 'districtid') 

                if(districtField){
                    let stateKey = apiDropdownData[stateField.fieldName].find(s => s.value.trim().toLowerCase() === state)
                    let districtFilteredList = apiDropdownData[districtField.fieldName].filter(c => c.valueId === stateKey.key.toString())

                    setModifiedApiDropdownData(prevApiData => ({
                        ...prevApiData,
                        [districtField.fieldName]: districtFilteredList
                    }))

                }

                let countryField = fields.find(field => field.dbColumnName.toLowerCase() === 'countryid')

                if(countryField){
                    let countryKey = apiDropdownData[countryField.fieldName].find(c => c.value.trim().toLowerCase() === country)
                    let dependentField = fields.find(field => field.dbColumnName.toLowerCase() === 'stateid')
                    let stateFilteredList = apiDropdownData[dependentField.fieldName].filter(c => c.valueId === countryKey.key.toString())
                    
                    setModifiedApiDropdownData(prevApiData => ({
                        ...prevApiData,
                        [dependentField.fieldName]: stateFilteredList
                    }))

                    // setInputValue((prevInputValue) => ({
                    //     ...prevInputValue,
                    //     [countryField.fieldName]: countryKey.key.toString()
                    // }));

                    inputValue.current = {
                        ...inputValue.current,
                        [countryField.fieldName]: countryKey.key.toString()
                    }

                    const isCreated = createObject(countryField, countryKey.key.toString())

                }

                let cityField = fields.find(field => field.dbColumnName.toLowerCase() === 'cityid')

                if(cityField){
                    let cityKey = apiDropdownData[cityField.fieldName].find(ci => ci.value.trim().toLowerCase() === city)
                    
                    inputValue.current = {
                        ...inputValue.current,
                        [cityField.fieldName]: cityKey.key.toString()
                    }

                    const isCreated = createObject(cityField, cityKey.key.toString())

                }

            })
            .catch(error => {
                console.error(error);
            });
    }

    const loginDataLoadedRef = useRef(false);
// && !dataLoadedRef.current
    // To fetch data filled during login
    useEffect(() => {
        if (data !== null && loggedInUser !== 'admin' && (debEnable !== null && debEnable === 0) && lastSaveSection < 2 && !loginDataLoadedRef.current) {
          const section = data.sections.find(section => section.sectionId === 2);
          if (!section) return;
      
          const fields = section.fieldsList;
          let requiredFields;
          if(fullNameFlag !== null && fullNameFlag === 1){
            requiredFields = ['firstname', 'dob', 'mobileno', 'emailid'];
          }else{
            requiredFields = ['firstname', 'middlename', 'lastname', 'dob', 'mobileno', 'emailid'];
          }
          const fieldsToSave = [];
      
          requiredFields.forEach(fieldName => {
            const field = fields.find(field => field.dbColumnName.toLowerCase() === fieldName);
            if (field) {
              let value;
              switch (fieldName) {
                case 'firstname':
                    if(fullNameFlag !== null && fullNameFlag === 1){
                        value = RegisterName
                    }else{
                        value = RegisterName.split(' ')[0];
                    }
                    break;
                case 'middlename':
                    value = RegisterName.split(' ').length > 2 ? RegisterName.split(' ')[1] : '';
                    break;
                case 'lastname':
                    value = RegisterName.split(' ').length > 1 ? RegisterName.split(' ').pop() : '';
                    break;
                case 'dob':
                    value = Registerdob;
                    break;
                case 'mobileno':
                    value = RegisterMobile;
                    break;
                case 'emailid':
                    value = RegisterEmail || '';
                    break;
                default:
                    value = '';
              }
      
              if (field.value === '') {
                if(field.fieldType === 'Date'){
                    pickedData.current = {
                        ...pickedData.current,
                        [field.fieldName]: Registerdob !== undefined ? Registerdob : ''
                    };
                }

                // setInputValue(prevInputValue => ({ ...prevInputValue, [field.fieldName]: value }));
                fieldsToSave.push({
                  sectionId: 2,
                  fieldId: field.fieldId,
                  sequenceId: 0,
                  value: value,
                  imageExtension: '',
                  imageSize: '',
                  fieldRefType: '',
                  fieldRefTypeId: 0,
                  fieldTypeId: field?.fieldTypeId,
                  isDelete: false,
                });

                inputValue.current = {
                    ...inputValue.current,
                    [field.fieldName]: value
                }
              }
            }
          });
          if (fieldsToSave.length > 0 && id === 2) {
            // setListOfFieldsArray(fieldsToSave);
            inputOnChange.current = fieldsToSave
            // const isMobileView = window.innerWidth <= 768; // or use your existing mobile detection logic
            // if (isMobileView) {
            //     setInputTrigger(prev => prev + 1);
            // }
            loginDataLoadedRef.current = true;
          }
        }
      }, [data, loggedInUser, debEnable, lastSaveSection, loginDataLoadedRef]);

    //   set maxsequence of subject
    useEffect(() => {
        if(data !== null){
            let sec = data.sections.filter(section => section.parentSectionId === 11 && section.isActive === 1)
            if(sec){
                setMaxSubjectSequence(sec.length)
            }

            let multipleFieldSection = data.sections.filter(s => s.isMultipleFields === 1 && s.sectionId === id)
        }
    }, data)


    const handleAnnexture = () => {
        setAnnextureFlag(true)
        if(annextureData !== null && !(Insterested === null || Insterested === '') && (loggedInUser !== 'admin' || (loggedInUser === 'admin' && sessionStorage.getItem('actionType') === 'Edit') )){
            setIsModalOpen(true);
            setTitleMsg("");
            setModalContentIdentity("documentPreview")
            setContent(<div dangerouslySetInnerHTML={{ __html: annextureData }}></div>)
                
        }
        // if(annextureData !== null && !(Insterested === null || Insterested === '') && (loggedInUser !== 'admin' || (loggedInUser === 'admin' && sessionStorage.getItem('actionType') === 'Edit') )){
        //     let url = annextureData.annexureFile.fileUrl
        //     // let url = 'https://d1i48f37ueygxm.cloudfront.net/Annexure/AnnexureTemplate/Annexure I.html'
        //     // fetch('https://uatums.digivarsity.com/Document/Data_101/Annexure%20I.html')
        //     fetch(url)
        //     .then(response => response.text())
        //     .then(html => {
        //         // Replace all placeholders with their corresponding values
        //         let modifiedContent = html;
        //         annextureData.keyValue.forEach(item => {
        //             const regex = new RegExp(item.key, 'g'); // 'g' flag for global replacement
        //             modifiedContent = modifiedContent.replace(regex, item.value);
        //         });
        //         // annextureData.keyValue.forEach(item => {
        //         //     modifiedContent = modifiedContent.replace(item.key, item.value);
        //         // });
        //         setContent(modifiedContent);
        //         setIsModalOpen(true);
        //         setTitleMsg("");
        //         // setContent(<div dangerouslySetInnerHTML={{ __html: modifiedContent }}></div>)
        //         setContent(<iframe srcDoc={modifiedContent} width={700} height={500} frameBorder="0"></iframe>)
        //         setModalContentIdentity('documentPreview')
        //     })
        //     .catch(error => console.error('Error fetching HTML content:', error));

            
        // }else if(loggedInUser === 'admin' && sessionStorage.getItem('actionType') !== 'Edit'){
        //     fetch('https://uatums.digivarsity.com/Document/Data_101/Annexure%20I.html')
        //     .then(response => response.text())
        //     .then(html => {
        //         // Replace all placeholders with their corresponding values
        //         let modifiedContent = html;
        //         annextureData.keyValue.forEach(item => {
        //             modifiedContent = modifiedContent.replace(item.key, '');
        //         });
        //         setContent(modifiedContent);

        //         setIsModalOpen(true);
        //         setTitleMsg("");
        //         // setContent(<div dangerouslySetInnerHTML={{ __html: modifiedContent }}></div>)
        //         setContent(<iframe srcDoc={modifiedContent} width={700} height={500} frameBorder="0"></iframe>)
        //         setModalContentIdentity('documentPreview')
        //     })
        //     .catch(error => console.error('Error fetching HTML content:', error));
        // }
    }

    // Back function
    const handleBack = (sequence, sectionId) => {
        let prevSequence = 1
        if(sectionId === 11){
            let sec = data.sections.find(section => section.sectionId === sectionId)
            prevSequence = sec.sequence - 1
        }else{
            prevSequence = sequence-1
        }
        if(prevSequence === 0 && loggedInUser === 'student'){
            Navigate('/course-selection')
            setLastSaveSection(0)
        }else{
            let sec = data.sections.find(section => section.parentSectionId === 0 && section.sequence === prevSequence)
            if(sec){
                if(sec.isActive === 1 && sec.parentSectionId === 0){
                    setCurrentSection(sec.sectionId)
                    setId(sec.sectionId)
                }else{
                    let previous = data.sections.find(section => section.sequence === prevSequence-1)
                    if(previous === undefined){
                        if(loggedInUser !== 'admin'){
                            Navigate('/course-selection')
                        }else{
                            return;
                        }
                        
                        // Navigate('/course-selection')
                    }else{
                        while(previous !== undefined && previous.isActive === 0){
                            let currentSequence = previous.sequence - 1;
                            previous = data.sections.find(y => y.sequence === currentSequence);
                        }

                        setCurrentSection(previous.sectionId)
                        setId(previous.sectionId)
                    }
                }
            }
        }
        setListOfFieldsArray([])
        inputOnChange.current = []
        // setInputValue({})
        inputValue.current = {}

    }

    const [validSections, setValidSections] = useState(null)
    useEffect(() => {
        if(data !== null){
            let validSection = data.sections.filter(
                (section) => section.parentSectionId !== 0 && section.parentSectionId === 3 && section.isActive === 1
            );
            setValidSections(validSection)
        }
    },[data])

    const handleDataFromJob = (listToSave) => {
        setListOfFieldsArray(listToSave)
        inputOnChange.current = listToSave
    }

    const handleJobDataLength = (jobLength) => {
        jobDataLength = jobLength
        // setJobDataLength(jobLength)
    }

    // Address section fields
    const SectionGrid = ({ section, index }) => {
        return (
            <ScreenView>
            {mobileView => (
                <Grid container direction="column" sx={{textAlign: 'left'}}>
                    <Typography
                    sx={{textAlign: 'left', mt:1,
                        color: '#000',
                        // fontFamily: "Open Sauce Sans",
                        fontSize: '17px',
                        fontStyle: 'normal',
                        fontWeight: 600,
                        lineHeight: '167%', 
                    }}>{section.sectionName}
                    &nbsp;&nbsp;
                    {section.sequence === 2 && (
                        <div style={{ display: 'inline-flex', alignItems: 'center' }}>
                        <input ref={checkboxRef} id='check' type='checkbox' onChange={handleAddressCheckbox} />
                        <Typography sx={{ fontSize: '13px' }}>Same as Correspondence address</Typography>
                        </div>
                    )}
                    </Typography>
                    {section?.fieldsList
                    .sort((a, b) => a.sequence - b.sequence)
                    .map((field, fieldIndex) => (
                        <Grid item key={fieldIndex}>
                        <Box sx={{ display: section.sectionId === 3 ? 'block' : 'display-inline',  }}>
                            <FormControl sx={{ width: mobileView ? '100%' : '100%', textAlign: 'left', 
                            ...(field.visibleToStudent === '2' || field.fieldType === "HiddenField" || fieldVisibility[field.fieldName] === false ? { display: 'none' }: {}),
                            }}>
                            {/* rest of your code */}
                            <Box sx={{
                                direction: mobileView ? 'column' : 'column',
                                width: mobileView ? '100%' : '80%',
                                alignItems: 'left',
                                justifyContent: 'flex-start',
                            }}>
                                <Box sx={{ display: mobileView ? 'block' : 'flex', alignItems: 'center', 
                                // ...(field.visibleToStudent === '2' ? { display: 'none' }: {}) 
                                }}>
                                    {field.fieldType !== 'CheckBox' && field.fieldType !== 'RadioButton' &&
                                    <InputLabel
                                        className="formLabel"
                                        shrink={false}
                                        // sx={{ ...(field.visibleToStudent === '2' ? { display: 'none' } : {}) }}
                                        // sx={{ position: 'relative', textAlign: 'left' }}
                                    >
                                        {field.fieldName}
                                        {(field.fieldType === 'RadioButton' || field.fieldType === 'Photo' || field.fieldType === 'File') &&
                                            <span style={{ color: 'red' }}>*</span>
                                        }
                                    </InputLabel>
                                    }
                                    {field.helpText !== null && field.helpText !== '' && field.fieldType !== 'RadioButton' && ( 
                                        <Popup
                                            trigger={
                                                <InfoOutlinedIcon
                                                    sx={{
                                                        marginBottom: mobileView ? '0%' : '-6%',
                                                        marginLeft: mobileView ? '109px' : '15px',
                                                        marginTop: mobileView ? '-2%' : '0%',
                                                        position: mobileView ? 'absolute' : 'relative',
                                                        color: '#484848',
                                                        width: '4%'
                                                    }}
                                                />
                                            }
                                                on="hover" // Set the on prop to 'hover'
                                                position="right center"
                                            >
                                            <Box>{field.helpText}</Box>
                                        </Popup>
                                    )}
                                </Box>
                                <Input
                                    type={field.fieldType}
                                    defaultValue={inputValue.current[field.fieldName] || '' ||field.value}
                                    onBlur={(loggedInUser !== 'admin' || (loggedInUser === 'admin' && sessionStorage.getItem('actionType') === 'Edit')) ? (value) => handleInputChange( 
                                        value, 
                                        field.validationType, 
                                        field.fieldName,
                                        {...field}, 
                                        section.isMultipleFields
                                    ): undefined}
                                    onChange={(value) => handleChange(value, field.fieldName, {...field}, {...section})}
                                    {...field}
                                />
                            </Box>
                            </FormControl>
                        </Box>
                        </Grid>
                    ))}
                </Grid>
          )}</ScreenView>
        );
    };

    // personal detail first 3 fields
    const PersonalGrid = (section, index) => {
    return (
        <ScreenView>
        {mobileView => (
            <Grid container direction="column" sx={{ textAlign: 'left' }}>
            {section.section.fieldsList
            .sort((a, b) => a.sequence - b.sequence)
            .filter(field => {
                if(section.section.fieldsList.some(f => f.dbColumnName.toLowerCase() === 'photo' && f.sequence === 4) &&
                    !section.section.fieldsList.some(f => f.sequence === 1 && f.fieldType === 'Image')){
                    return [1, 2, 3].includes(field.sequence) && field.isActive === 1;
                  }
                  if(section.section.fieldsList.some(f => f.dbColumnName.toLowerCase() === 'photo' && [1, 2, 3].includes(f.sequence))){
                    return field.sequence !== section.section.fieldsList.find(f => f.dbColumnName.toLowerCase() === 'photo').sequence && [1, 2, 3, 4].includes(field.sequence) && field.isActive === 1;
                  }
                  if(section.section.fieldsList.some(f => f.dbColumnName.toLowerCase() === 'photo' && ![1, 2, 3, 4].includes(f.sequence))){
                    return [1, 2, 3].includes(field.sequence) && field.isActive === 1;
                  }
                  if(section.section.fieldsList.some(f => f.dbColumnName.toLowerCase() === 'photo' && f.sequence !== 1) &&
                        section.section.fieldsList.some(f => f.sequence === 1 && f.fieldType === 'Image' && f.dbColumnName.toLowerCase() !== 'photo')){
                        return [1].includes(field.sequence) && field.isActive === 1;
                    }
                  return [1, 2, 3].includes(field.sequence) && field.isActive === 1;
                
            })
            .map((field, fieldIndex) => (
                <Grid item key={fieldIndex}>
                <Box
                    sx={{
                    display: section.sectionId === 2 ? 'block' : 'inline-block',
                    width: '81%'
                    }}
                >
                    <FormControl
                    sx={{
                        width: mobileView ? '100%' : '100%',
                        textAlign: 'left',
                        ...(field.visibleToStudent === '2' || field.fieldType === 'HiddenField' || fieldVisibility[field.fieldName] === false
                        ? { display: 'none' }
                        : {}),
                    }}
                    >
                    {/* rest of your code */}
                    <Box
                        sx={{
                        flexDirection: mobileView ? 'column' : 'column',
                        width: mobileView ? '100%' : '100%', // width: mobileView ? '100%' : '225%',
                        alignItems: 'flex-start',
                        justifyContent: 'flex-start',
                        }}
                    >
                        <Box
                        sx={{
                            display: mobileView ? 'block' : 'flex',
                            alignItems: 'center',
                            ...(field.visibleToStudent === '2' || fieldVisibility[field.fieldName] === false ? { display: 'none' } : {}),
                        }}
                        >
                        {field.dbColumnName.toLowerCase() !== 'photo' && field.fieldType !== 'Image' &&  field.fieldType !== 'RadioButton' &&
                        <InputLabel
                            className="formLabel"
                            shrink={false}
                            sx={{
                            ...(field.visibleToStudent === '2' || fieldVisibility[field.fieldName] === false ? { display: 'none' } : {}),
                            }}
                        >
                            {field.fieldName}
                            {(field.fieldType === 'Photo' ||
                            field.fieldType === 'File') && (
                            <span style={{ color: 'red' }}>*</span>
                            )}
                        </InputLabel>
                        }
                        {field.helpText !== null &&
                            field.helpText !== '' &&
                            field.fieldType !== 'RadioButton' && (
                            <Popup
                                trigger={
                                <InfoOutlinedIcon
                                    sx={{
                                    marginBottom: mobileView ? '0%' : '-6%',
                                    marginLeft: mobileView ? '109px' : '15px',
                                    marginTop: mobileView ? '-2%' : '0%',
                                    position: mobileView ? 'absolute' : 'relative',
                                    color: '#484848',
                                    width: '4%',
                                    }}
                                />
                                }
                                on="hover"
                                position="right center"
                            >
                                <Box>{field.helpText}</Box>
                            </Popup>
                            )}
                        </Box>
                        <Input
                        type={field.fieldType}
                        defaultValue={inputValue.current[field.fieldName] || '' || field.value}
                        onBlur={(loggedInUser !== 'admin' || (loggedInUser === 'admin' && sessionStorage.getItem('actionType') === 'Edit')) ? value =>
                            handleInputChange(
                            value,
                            field.validationType,
                            field.fieldName,
                            { ...field },
                            section.section.isMultipleFields
                            )
                        : undefined}
                        onChange={value => handleChange(value, field.fieldName, { ...field }, {...section})}
                        {...field}
                        />
                    </Box>
                    </FormControl>
                </Box>
                </Grid>
            ))}
            </Grid>
        )}
        </ScreenView>
    );
    };

    // photo field
    const PhotoGrid = (section, index) => { 
        const fileInputRef = useRef(null);
    return (
        <ScreenView>
        {mobileView => (
            <Grid container direction="column" sx={{ textAlign: 'left' }}>
            {section.section.fieldsList
            .sort((a, b) => a.dbColumnName.localeCompare(b.dbColumnName))
            .filter(field => field.dbColumnName.toLowerCase() === 'photo' && field.isActive === 1)
            .map((field, fieldIndex) => (
                <Grid item key={fieldIndex}>
                <Box
                    sx={{
                    display: section.sectionId === 2 ? 'block' : 'inline-block',
                    }}
                >
                    <FormControl
                    sx={{
                        width: mobileView ? '100%' : '100%',
                        textAlign: 'left',
                        ...(field.visibleToStudent === '2' || field.fieldType === 'HiddenField' || fieldVisibility[field.fieldName] === false
                        ? { display: 'none' }
                        : {}),
                    }}
                    >
                    {/* rest of your code */}
                    <Box
                        sx={{
                        flexDirection: mobileView ? 'column' : 'column',
                        width: mobileView ? '100%' : '225%',
                        alignItems: 'flex-start',
                        justifyContent: 'flex-start',
                        mt:2
                        }}
                    >
                        <Box
                        sx={{
                            display: mobileView ? 'block' : 'flex',
                            alignItems: 'center',
                            ...(field.visibleToStudent === '2' || fieldVisibility[field.fieldName] === false ? { display: 'none' } : {}),
                        }}
                        >
                        <Typography sx={{
                            // fontFamily: "Open Sauce Sans",
                            fontSize: '16px',
                            fontStyle: 'normal',
                            lineHeight: 'normal',
                        }}>{field.fieldName}<span style={{color: '#FF0000'}}>*</span></Typography>
                        
                        </Box>
                        <Box sx={{display: 'flex'}}>
                            <Box
                                height={150}
                                width={200}
                                my={1}
                                display="flex"
                                alignItems="center"
                                justifyContent="center"
                                gap={4}
                                p={2}
                                sx={{borderRadius: '10px', border: '0.5px solid #972524', cursor: 'pointer' }}
                                onClick={() => {
                                    // Check if the conditions are met to trigger the file input
                                    if (
                                        (loggedInUser  !== 'admin' || (loggedInUser  === 'admin' && sessionStorage.getItem('actionType') === 'Edit')) 
                                        // && isAadhaarVerified === false
                                    ) {
                                        // Trigger the hidden file input
                                        fileInputRef.current.click();
                                    }
                                }}
                            >
                                {/* file && file[field?.fieldName] && (file[field?.fieldName] !== undefined || file[field?.fieldName] !== null) ?  */}
                                {file && Object.keys(file).length !== 0 && file[field?.fieldName] ? (
                                    <>
                                        <img id={field.dbColumnName} src={file[field?.fieldName]} style={{ width: '200px', height: '150px', borderRadius: '10px' }} alt="Uploaded file" />
                                        {(loggedInUser !== 'admin' || (loggedInUser === 'admin' && sessionStorage.getItem('actionType') === 'Edit')) && 
                                            <input id={field?.dbColumnName} ref={fileInputRef} type="file" style={{ display: 'none' }} onChange={(e) => handleImageChange(field?.fieldName, field?.sectionId, field?.fieldId, field, e)} onBlur={handleInputChange} />
                                        }
                                    </>
                                    // (file && (file[field?.fieldName] === undefined || file[field?.fieldName] === null)) && (field?.value !== null && field?.value !== "") ? 
                                ) : (file && Object.keys(file).length !== 0 && !file[field?.fieldName]) || (field?.value !== null && field?.value !== "") ? (
                                    <>
                                        <img id={field.dbColumnName} src={field?.value} style={{ width: '200px', height: '150px', borderRadius: '10px' }} alt="Uploaded file" />
                                        {(loggedInUser !== 'admin' || (loggedInUser === 'admin' && sessionStorage.getItem('actionType') === 'Edit')) &&
                                            <input id={field?.dbColumnName} ref={fileInputRef} type="file" style={{ display: 'none' }} onChange={(e) => handleImageChange(field?.fieldName, field?.sectionId, field?.fieldId, field, e)} onBlur={handleInputChange} />
                                        }
                                    </>
                                    // file && (file[field?.fieldName] === undefined || file[field?.fieldName] === null) && (field.value === null || field.value === "") ?
                                ) : (!file || Object.keys(file).length === 0) || (file || Object.keys(file).length !== 0 && !file[field?.fieldName]) && (field?.value === null || field?.value === "") ? (
                                        <Box>
                                            <Box display="flex" alignItems="center" style={{ cursor: 'pointer' }}>
                                                <UploadOutlinedIcon />
                                                <span>Browse from device</span>
                                            </Box>
                                            {(loggedInUser !== 'admin' || (loggedInUser === 'admin' && sessionStorage.getItem('actionType') === 'Edit')) && 
                                                <input id={field?.dbColumnName} ref={fileInputRef} type="file" style={{ display: 'none' }} onChange={(e) => handleImageChange(field?.fieldName, field?.sectionId, field?.fieldId, field, e)} onBlur={handleInputChange} />
                                            }
                                        </Box>
                                    ) : (field?.value !== null && field?.value !== "") ? (
                                        <>
                                        <img id={field.dbColumnName} src={field?.value} style={{ width: '200px', height: '150px', borderRadius: '10px' }} alt="Uploaded file" />
                                            {(loggedInUser !== 'admin' || (loggedInUser === 'admin' && sessionStorage.getItem('actionType') === 'Edit')) &&
                                                <input id={field?.dbColumnName} ref={fileInputRef} type="file" style={{ display: 'none' }} onChange={(e) => handleImageChange(field?.fieldName, field?.sectionId, field?.fieldId, field, e)} onBlur={handleInputChange} />
                                            }
                                        </>
                                    ) : null
                                }
                                
                            </Box>
                            {file && file[field?.fieldName] && (
                                <DeleteForeverIcon 
                                    sx={{ cursor: 'pointer', alignSelf: 'center', ml: 2 }} 
                                    onClick={() => setFile((prevState) => {
                                        const { [field?.fieldName]: _, ...newFile } = prevState; // Destructure to exclude the field
                                        return newFile; // Return the new object without the specified field
                                    })}
                                />
                            )}
                            
                        </Box>
                        {Object.entries(textError).length > 0 &&
                            Object.entries(textError).map(([name, { isError, errorMessage }]) => (
                                isError === true &&
                                field?.fieldName === name && (
                                <Typography className="error-message" key={name}>
                                    {errorMessage}
                                </Typography>
                            )
                        ))}
                        <Typography 
                            sx={{
                                textAlign: 'left', width: '100%', 
                                // fontFamily: "Open Sauce Sans",
                                fontSize: '14px',
                                fontStyle: 'normal',
                                color: 'black'
                            }}
                        >
                            Format: {field.fieldValidations.map((acc)=>{
                                if (acc.property === 'FileType') {
                                    return acc.value.replace(/\,/g, ', ');
                                } else if (acc.property === 'MinSize') {
                                    const minSizeUnit = field.fieldValidations.find(v => v.property === 'MinSizeUnit').value;
                                    return ` , Min Size: ${acc.value}${minSizeUnit}`;
                                } else if (acc.property === 'MaxSize') {
                                    const maxSizeUnit = field.fieldValidations.find(v => v.property === 'MaxSizeUnit').value;
                                    return ` , Max Size: ${acc.value}${maxSizeUnit}`;
                                }
                                return '';
                            }).filter(Boolean).join('')}
                        </Typography>
                    </Box>
                    </FormControl>
                </Box>
                </Grid>
            ))}
            </Grid>
        )}
        </ScreenView>
    );
    };

    return(
        <>
        <ScreenView>
            {mobileView => (
            <Box className="container">
                <Box>
                    {/* <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}></Box> */}
                    <Grid container component="main">
                        <Grid item xs={12}>
                            {/* {successMessage !== null &&
                            <Snackbar
                                className="sucess-popup"
                                open={SnackbarOpen}
                                autoHideDuration={3000}
                                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                                onClose={() => {
                                    handleSnackbarClose();
                                    setSuccessMessage(null); // reset successMessage to null
                                }}
                                sx={{
                                    top: mobileView ? '-90px !important' : '-62px'
                                }}
                                message={successMessage}
                                key={'top center'}
                            />
                            } */}
                            <Typography className="title" sx={{textAlign: 'left', ml:0, fontWeight: 600}}  variant="h6">
                                {/* {name} */}
                                {(data === null || loading === true) ? <Loader/> : data !== null &&
                                    data?.sections.map((section) =>
                                        section.sectionId === id && section.isActive === 1 ? 
                                        <>
                                            <span key={section.sectionId}>{section.sectionName}</span> 
                                            {section.sectionId === 3 &&
                                            <Box
                                                sx={{width: mobileView ? '90%' : '560px',
                                                    height: '50px',
                                                    flexShrink: '0',
                                                    borderRadius: '8px',
                                                    border: '1px solid #FEBF00',
                                                    background: '#ffffffb3',
                                                    boxShadow: '0px 4px 4px 0px #00000040',
                                                    display: 'flex',
                                                    alignItems: 'center',  // Align items vertically center
                                                    padding: '0 8px' ,
                                                }}
                                            >
                                                <Typography
                                                    sx={{
                                                        color: '#000',
                                                        // fontFamily: "Open Sauce Sans",
                                                        fontSize: mobileView ? '13px' : '16px',
                                                        fontStyle: 'normal',
                                                        fontWeight: '500',
                                                        lineHeight: '167%', /* 26.72px */
                                                        textAlign: 'left',
                                                        flexGrow: 1
                                                    }}
                                                >
                                                    Save time. Auto fill your current location.
                                                </Typography>
                                                <Button
                                                    sx={{width: '85px',
                                                        height: '43px',
                                                        flexShrink: '0',
                                                        borderRadius: '8px',
                                                        background: '#FEBF00',
                                                        color: '#fff',
                                                        marginLeft: 'auto',
                                                        textTransform: 'none',
                                                        '&:hover': {
                                                            background: '#FEBF00',
                                                        },
                                                    }}
                                                    id='auto_fill_btn'
                                                    onClick={handleLocationClick}
                                                >
                                                    Auto fill
                                                </Button>
                                            </Box>
                                            }
                                        </>
                                        : null
                                    )
                                }
                            </Typography>
                        </Grid>
                    
                    </Grid>

                    {/*  1st 3 fields and photo field  */}
                    <React.Fragment>
                        {data !== null && loading === false && data?.sections?.length > 0 ? (
                            data?.sections.find((section) => section.sectionId === id) ? (
                            data?.sections.find((section) => section.sectionId === 2 && section.isActive === 1 && !mobileView && section.fieldsList.some((field) => field.dbColumnName.toLowerCase() === 'photo')) ? (
                                <Grid container spacing={2} mt={2}>
                                <Grid item xs={5}>
                                    {data?.sections
                                    .filter((section) => section.sectionId === id && section.sectionId === 2 && section.isActive === 1 && !mobileView)
                                    .map((section, index) => (
                                        <PersonalGrid section={section} index={index} key={section.sectionId}/>
                                    ))}
                                </Grid>
                                <Grid item xs={5}>
                                    {data?.sections
                                    .filter((section) => section.sectionId === id && section.sectionId === 2 && section.isActive === 1 && !mobileView)
                                    .map((section, index) => (
                                        <PhotoGrid section={section} index={index} key={section.sectionId}/>
                                    ))}
                                </Grid>
                                </Grid>
                            ) : null
                            ) : null
                        ) : null}
                    </React.Fragment>
                    
                    <React.Fragment>
                        {(data !== null && loading === false) ?
                        data?.sections?.map((section) => (
                            section.parentSectionId === 0 && section.sectionId === id && section.isActive === 1 ? (
                                <Grid container component="main">
                                    <Grid item xs={10}> 
                                    <section key={section.sectionId} style={{textAlign: 'left'}}>
                                        {section.isMultipleFields === 0 && section.fieldsList
                                            .filter(field => field.isActive === 1 ) // Add this condition to filter active fields
                                            .filter(field => mobileView || field.dbColumnName.toLowerCase() !== 'photo')
                                            .sort((a, b) => a.sequence - b.sequence)
                                            .map((field, index) => (
                                            <>
                                                {/* // Other fields */}
                                                { !mobileView 
                                                    && (!( section.sectionId === 2 && section.fieldsList.some(f => f.dbColumnName.toLowerCase() === 'photo' && f.fieldType === 'Image')
                                                    ? [1, 2, 3].includes(field.sequence) || 
                                                    ([1, 2, 3, 4].includes(field.sequence) && [1, 2, 3, 4].some(seq => section.fieldsList.find(f => f.sequence === seq && f.dbColumnName.toLowerCase() === 'photo' && f.fieldType === 'Image')))
                                                    : false
                                                    ) || (section.sectionId === 2 
                                                        && section.fieldsList.some(f => f.sequence === 1 && f.fieldType === 'Image')
                                                        && section.fieldsList.some(f => f.dbColumnName.toLowerCase() === 'photo')
                                                        ? field.sequence !== 1 && field.dbColumnName.toLowerCase() !== 'photo'
                                                        : false
                                                    ))
                                                    ?
                                                    <FormControl sx={{ width: mobileView ? '100%' : field.fieldType !== 'Paragraph' ? '50%' : '100%', textAlign: 'left',
                                                        ...(field.visibleToStudent === '2' || fieldVisibility[field.fieldName] === false || field.fieldType === "HiddenField" ? { display: 'none' }: {}),
                                                        }}
                                                    >
                                                        <Box sx={{
                                                            direction: mobileView ? 'column' : 'row',
                                                            width: mobileView ? '100%' : '80%',
                                                            alignItems: 'left',
                                                            justifyContent: 'flex-start'
                                                        }}>
                                                            <Box sx={{ display: mobileView ? 'block' : field.fieldType !== 'Paragraph' ? 'flex' : 'block', alignItems: 'center',  mt: mobileView ? 2 : 0
                                                            // ...(field.visibleToStudent === '2' ? { display: 'none' }: {}) 
                                                            }}>
                                                                {!(field.fieldType === 'RadioButton' || field.fieldType === 'CheckBox' || field.fieldType === 'Image') && field.dbColumnName.toLowerCase() !== 'photo' && field.sectionId !== 14 &&
                                                                <>
                                                                <InputLabel
                                                                    className="formLabel"
                                                                    id='1234'
                                                                    shrink={false}
                                                                    sx={{display: mobileView ? 'contents' : 'block', textWrap: 'wrap', mt:2, ml:field.fieldType === 'Paragraph' ? 1 : 0}}
                                                                    // sx={{ ...(field.visibleToStudent === '2' ? { display: 'none' } : {}) }}
                                                                    // sx={{ position: 'relative', textAlign: 'left' }}
                                                                >
                                                                    {field.fieldName}
                                                                    {(field.fieldType === 'RadioButton') &&
                                                                        <span style={{ color: 'red' }}>*</span>
                                                                    }
                                                                </InputLabel>
                                                                </>
                                                                }
                                                                {!mobileView && field.helpText !== null && field.helpText !== '' && !(field.fieldType === 'RadioButton' || field.fieldType === 'CheckBox') && field.sectionId !== 14 ? (
                                                                    <Popup
                                                                        trigger={
                                                                            <InfoOutlinedIcon
                                                                                sx={{
                                                                                    marginBottom: mobileView ? '0%' : '-6%',
                                                                                    marginLeft: mobileView ? '109px' : '15px',
                                                                                    marginTop: mobileView ? '-2%' : '0%',
                                                                                    position: mobileView ? 'absolute' : 'relative',
                                                                                    color: '#484848',
                                                                                    width: mobileView ? '5%' : '3.5%'
                                                                                }}
                                                                            />
                                                                        }
                                                                            on="hover" // Set the on prop to 'hover'
                                                                            position="right center"
                                                                        >
                                                                        <Box>{field.helpText}</Box>
                                                                    </Popup>
                                                                ): (mobileView && field.helpText !== null && field.helpText !== '' && field.fieldType !== 'RadioButton'&& field.sectionId !== 14 && (
                                                                    <span
                                                                        style={{
                                                                            color: '#000',
                                                                            // fontFamily: "Open Sauce Sans",
                                                                            fontSize: '14px',
                                                                            fontWeight: 500,
                                                                            fontStyle: 'italic',
                                                                            lineHeight: '167%'
                                                                        }}  
                                                                    >&nbsp;&nbsp;({field?.helpText})</span>
                                                                    
                                                                ))}
                                                                {field.sectionId === 14 && (
                                                                    <Box sx={{fontStyle: 'italic'}}>({field.helpText})</Box>
                                                                )}
                                                            </Box>
                                                            <Input
                                                                type={field.fieldType}
                                                                name={field.fieldName}
                                                                defaultValue={inputValue.current[field.fieldName]  || '' || field.value}
                                                                onBlur={(value) => handleInputChange( 
                                                                    value, 
                                                                    field.validationType, 
                                                                    field.fieldName,
                                                                    {...field}, 
                                                                    section.isMultipleFields
                                                                )}
                                                                onChange={(value) => handleChange(value, field.fieldName, {...field}, {...section})}
                                                                {...field}
                                                            />
                                                        </Box>
                                                        {section.sectionId === 7 &&
                                                            <Box sx={{
                                                                mt: 5
                                                            }}>
                                                                <Typography
                                                                    sx={{
                                                                        // fontFamily: 'Open Sauce Sans',
                                                                        cursor: 'pointer',
                                                                        color: '#185ABD'
                                                                    }}
                                                                    onClick={handleAnnexture}
                                                                >
                                                                    Click here to view annexture
                                                                </Typography>
                                                                
                                                            </Box>
                                                        }
                                                        {section.sectionId === 7 &&
                                                            <Snackbar open={SnackbarOpen} autoHideDuration={6000} onClose={handleSnackbarClose}>
                                                                <Alert
                                                                    onClose={handleSnackbarClose}
                                                                    severity="error"
                                                                    variant="filled"
                                                                    sx={{ width: '100%'}}
                                                                >
                                                                    Please view annexture
                                                                </Alert>
                                                            </Snackbar>
                                                        }
                                                    </FormControl>
                                                :
                                                (mobileView &&
                                                    <FormControl sx={{ width: mobileView ? '100%' : '50%', textAlign: 'left',
                                                        ...(field.visibleToStudent === '2' || fieldVisibility[field.fieldName] === false || field.fieldType === "HiddenField" ? { display: 'none' }: {}),
                                                        }}
                                                    >
                                                        <Box sx={{
                                                            direction: mobileView ? 'column' : 'row',
                                                            width: mobileView ? '100%' : '80%',
                                                            alignItems: 'left',
                                                            justifyContent: 'flex-start'
                                                        }}>
                                                            <Box sx={{ display: mobileView ? 'block' : 'flex', alignItems: 'center',  mt: mobileView ? 2 : 0
                                                            // ...(field.visibleToStudent === '2' ? { display: 'none' }: {}) 
                                                            }}>
                                                                {field.fieldType !== 'RadioButton' && field.fieldName !== 'CheckBox' && field.dbColumnName.toLowerCase() !== 'photo' && field.sectionId !== 14 &&
                                                                <InputLabel
                                                                    className="formLabel"
                                                                    shrink={false}
                                                                    sx={{display: mobileView ? 'contents' : 'block', mt:2}}
                                                                    // sx={{ ...(field.visibleToStudent === '2' ? { display: 'none' } : {}) }}
                                                                    // sx={{ position: 'relative', textAlign: 'left' }}
                                                                >
                                                                    {field.fieldName}
                                                                    {(field.fieldType === 'RadioButton') &&
                                                                        <span style={{ color: 'red' }}>*</span>
                                                                    }
                                                                </InputLabel>
                                                                }
                                                                {!mobileView && field.helpText !== null && field.helpText !== '' && field.fieldType !== 'RadioButton'&& field.sectionId !== 14 ? (
                                                                    <Popup
                                                                        trigger={
                                                                            <InfoOutlinedIcon
                                                                                sx={{
                                                                                    marginBottom: mobileView ? '0%' : '-6%',
                                                                                    marginLeft: mobileView ? '109px' : '15px',
                                                                                    marginTop: mobileView ? '-2%' : '0%',
                                                                                    position: mobileView ? 'absolute' : 'relative',
                                                                                    color: '#484848',
                                                                                    width: mobileView ? '5%' : '3.5%'
                                                                                }}
                                                                            />
                                                                        }
                                                                            on="hover" // Set the on prop to 'hover'
                                                                            position="right center"
                                                                        >
                                                                        <Box>{field.helpText}</Box>
                                                                    </Popup>
                                                                ): (mobileView && field.helpText !== null && field.helpText !== '' && field.fieldType !== 'RadioButton'&& field.sectionId !== 14 && (
                                                                    <span
                                                                        style={{
                                                                            color: '#000',
                                                                            // fontFamily: "Open Sauce Sans",
                                                                            fontSize: '14px',
                                                                            fontWeight: 500,
                                                                            fontStyle: 'italic',
                                                                            lineHeight: '167%'
                                                                        }}  
                                                                    >&nbsp;&nbsp;({field?.helpText})</span>
                                                                    
                                                                ))}
                                                                {field.sectionId === 14 && (
                                                                    <Box sx={{fontStyle: 'italic'}}>({field.helpText})</Box>
                                                                )}
                                                            </Box>
                                                            {mobileView && field.dbColumnName.toLowerCase() === 'photo' ?
                                                            <PhotoGrid section={section} index={index} key={section.sectionId}/>
                                                            :
                                                            <Input
                                                                type={field.fieldType}
                                                                name={field.fieldName}
                                                                defaultValue={inputValue.current[field.fieldName]  || '' || field.value}
                                                                onBlur={(value) => handleInputChange( 
                                                                    value, 
                                                                    field.validationType, 
                                                                    field.fieldName,
                                                                    {...field}, 
                                                                    section.isMultipleFields
                                                                )}
                                                                onChange={(value) => handleChange(value, field.fieldName, {...field}, {...section})}
                                                                {...field}
                                                            />
                                                            }
                                                            
                                                            
                                                        </Box>
                                                        {section.sectionId === 7 &&
                                                            <Box sx={{
                                                                mt: 5
                                                            }}>
                                                                <Typography
                                                                    sx={{
                                                                        // fontFamily: 'Open Sauce Sans',
                                                                        cursor: 'pointer',
                                                                        color: '#185ABD'
                                                                    }}
                                                                    onClick={handleAnnexture}
                                                                >
                                                                    Click here to view annexture
                                                                </Typography>
                                                                
                                                            </Box>
                                                        }
                                                        {section.sectionId === 7 &&
                                                            <Snackbar open={SnackbarOpen} autoHideDuration={6000} onClose={handleSnackbarClose}>
                                                                <Alert
                                                                    onClose={handleSnackbarClose}
                                                                    severity="error"
                                                                    variant="filled"
                                                                    sx={{ width: '100%'}}
                                                                >
                                                                    Please view annexture
                                                                </Alert>
                                                            </Snackbar>
                                                        }
                                                    </FormControl>
                                                )
                                                }
                                                {/* } */}
                                                
                                            </>
                                            
                                        ))}
                                        {section.isMultipleFields === 1 && section.fieldsList
                                            .filter(field => field.isActive === 1)
                                            .filter(field => field.multipleSequence === Math.min(...section.fieldsList.filter(field => field.isActive === 1).map(field => field.multipleSequence)))
                                            .sort((a, b) => a.sequence - b.sequence)
                                            .map((field, index) => (
                                            <>
                                                <FormControl sx={{ width: mobileView ? '100%' : '50%', textAlign: 'left',
                                                    ...(field.visibleToStudent === '2' || fieldVisibility[field.fieldName] === false || field.fieldType === "HiddenField" ? { display: 'none' }: {}),
                                                    }}
                                                >
                                                    <Box sx={{
                                                        direction: mobileView ? 'column' : 'row',
                                                        width: mobileView ? '100%' : '80%',
                                                        alignItems: 'left',
                                                        justifyContent: 'flex-start'
                                                    }}>
                                                        <Box sx={{ display: mobileView ? 'block' : 'flex', alignItems: 'center', 
                                                        // ...(field.visibleToStudent === '2' ? { display: 'none' }: {}) 
                                                        }}>
                                                           {!(field.fieldType === 'RadioButton' || field.fieldType === 'CheckBox') &&
                                                                <InputLabel
                                                                    className="formLabel"
                                                                    shrink={false}
                                                                >
                                                                    {field.fieldName}
                                                                    {(field.fieldType === 'Photo' || field.fieldType === 'File') &&
                                                                    <span style={{ color: 'red' }}>*</span>
                                                                    }
                                                                </InputLabel>
                                                            }
                                                            {field.helpText !== null && field.helpText !== '' && field.fieldType !== 'RadioButton' && (
                                                                <Popup
                                                                    trigger={
                                                                        <InfoOutlinedIcon
                                                                            sx={{
                                                                                marginBottom: mobileView ? '0%' : '-6%',
                                                                                marginLeft: mobileView ? '109px' : '15px',
                                                                                marginTop: mobileView ? '-2%' : '0%',
                                                                                position: mobileView ? 'absolute' : 'relative',
                                                                                color: '#484848',
                                                                                width: '4%'
                                                                            }}
                                                                        />
                                                                    }
                                                                        on="hover" // Set the on prop to 'hover'
                                                                        position="right center"
                                                                    >
                                                                    <Box>{field.helpText}</Box>
                                                                </Popup>
                                                            )}
                                                        </Box>
                                                        <Input
                                                            type={field.fieldType}
                                                            defaultValue={inputValue.current[field.fieldName] || '' ||field.value}
                                                            onBlur={(value, displayValue) => handleInputChange( 
                                                                value, 
                                                                field.validationType, 
                                                                field.fieldName,
                                                                {...field}, 
                                                                section.isMultipleFields,
                                                                displayValue,
                                                            )}
                                                            onChange={(value) => handleChange(value, field.fieldName, {...field}, {...section})}
                                                            isMultipleFields = {section.isMultipleFields}
                                                            {...field}
                                                        />
                                                        
                                                        
                                                    </Box>
                                                    
                                                </FormControl>
                                            </>
                                        ))}
                                        {section.sectionId === 14 && Insterested === '1' && (loggedInUser !== 'admin' || loggedInUser === 'admin' && sessionStorage.getItem('actionType') === 'Edit') ? section.fieldsList
                                        .map((field, index) => (
                                            <>
                                            <JobSection enquiry={enquiryId} fields={section.fieldsList} sendDataToParent={handleDataFromJob} sendDataLength={handleJobDataLength}/>
                                            {Object.entries(textError).map(([name, { isError, errorMessage }]) =>
                                                isError === true && field?.fieldName === name && (
                                                <Snackbar open={SnackbarOpen} autoHideDuration={6000} onClose={handleSnackbarClose}>
                                                    <Alert
                                                        onClose={handleSnackbarClose}
                                                        severity="error"
                                                        variant="filled"
                                                        sx={{ width: '100%'}}
                                                    >
                                                        {errorMessage}
                                                    </Alert>
                                                </Snackbar>
                                            ))}
                                            
                                            </>
                                        )) : (section.sectionId === 14 && loggedInUser === 'admin' && <JobSection enquiry={enquiryId} fields={section.fieldsList} sendDataToParent={handleDataFromJob} sendDataLength={handleJobDataLength}/>)
                                        }
                                        
                                    </section>
                                    
                                    </Grid>

                                    {/* If isMultipleField section */}
                                    {section.isMultipleFields === 1 &&
                                        <Box xs={12} sx={{ width: '100%', textAlign: 'left'}}>
                                        
                                            <>
                                            <Button sx={{
                                                    borderRadius: '8px',
                                                    background: '#FEBF00',
                                                    boxShadow: '4px 4px 20px 0px rgba(0, 0, 0, 0.25)',
                                                    color: '#000',
                                                    '&:hover': {
                                                        background: '#FEBF00',
                                                    },
                                                    textTransform: 'none'
                                                }} 
                                                className="add-more-btn" 
                                                id='add_more_btn'
                                                variant="outlined" 
                                                onClick={() => addData(section.sectionId)}
                                                >
                                                + Add {section.sectionName.toLowerCase()}
                                            </Button>
                                            
                                            <TableContainer sx={{marginTop: '2%'}} component={Paper} elevation={4}>
                                                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                                                    <TableHead>
                                                        <TableRow sx={{background: '#538a30', }}>
                                                            {section.fieldsList
                                                                // .filter(field => field.multipleSequence === 0 || field.multipleSequence === 1 )
                                                                // .filter(field => field.isActive === 1 && field.fieldType !== 'Paragraph')
                                                                .filter(field => field.isActive === 1 )
                                                                .filter(field => field.multipleSequence === Math.min(...section.fieldsList.filter(field => field.isActive === 1).map(field => field.multipleSequence)))
                                                                .sort((a, b) => a.sequence - b.sequence)
                                                                .map((field, index) => (
                                                                    <TableCell key={index} sx={{ color: '#fff' }}>{field.fieldName}</TableCell>
                                                                ))}
                                                            <TableCell sx={{ color: '#fff' }}>Action</TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {tableInputValue[section.sectionId] && tableInputValue[section.sectionId].map((row, rowIndex) => (
                                                            <TableRow key={rowIndex}>
                                                                {section.fieldsList
                                                                // .filter(field => field.multipleSequence === 1 ? field.multipleSequence === 1 : field.multipleSequence === 0)
                                                                .filter(field => field.isActive === 1)
                                                                .filter(field => field.multipleSequence === Math.min(...section.fieldsList.filter(field => field.isActive === 1).map(field => field.multipleSequence)))
                                                                .slice()
                                                                .sort((a, b) => a.sequence - b.sequence)
                                                                .sort((a, b) => a.multipleSequence - b.multipleSequence)
                                                                .map((field, cellIndex) => (
                                                                    <TableCell>
                                                                        {field.fieldType === 'CheckBox' ?
                                                                            <Checkbox readOnly={true} 
                                                                            onClick={(e) => e.preventDefault()}
                                                                            style={{ pointerEvents: 'none' }} 
                                                                            checked={row[field.fieldName]} />  
                                                                        : 
                                                                            <span>{row[field.fieldName]}</span>
                                                                        }
                                                                    </TableCell>
                                                                    
                                                                ))}
                                                                <TableCell>
                                                                    <BorderColorOutlinedIcon
                                                                        id='edit_btn'
                                                                        onClick={() => editRecord(row, section.sectionId, rowIndex)}
                                                                    />&emsp;
                                                                    <DeleteForeverIcon sx={{color: 'red'}}
                                                                        id='delete_btn'
                                                                        onClick={() => deleteRecord(section.sectionId, rowIndex)}
                                                                        // onClick={() => deleteRecord(rowIndex)}
                                                                    />
                                                                </TableCell>
                                                                

                                                            </TableRow>
                                                        ))}
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                            </>
                                        
                                        </Box>
                                    }
                                    {/* save and back button */}
                                    {section?.sectionId === 3 || section?.sectionId === 11 ? "" : (<Grid item xs={9}>
                                        <Box sx={{
                                            my: mobileView ? 7 : 10,
                                            textAlign: 'left',
                                            marginBottom: '10%',
                                            display: mobileView ? 'block' : (section?.sectionId !== 3 ? 'flex' : (section?.sectionId === 3 && section?.fieldsList?.length > 0 ? 'flex' : 'none')),
                                            // display: mobileView ? 'block' : section.sectionId !== 3 ? 'flex' : section.sectionId === 3 && section.fieldsList.length <= 0 ? 'flex' : 'none',
                                            justifyContent: mobileView ? 'center' : 'space-between',
                                            // alignItems: !mobileView ?? 'flex-start'
                                        }}>
                                            <Button sx={{
                                                border: '1px solid #185ABD',
                                                color: '#185ABD',
                                                background: '#FFF',
                                                '&:hover': {
                                                    border: '1px solid #185ABD',
                                                },
                                                textTransform: 'none'
                                            }} 
                                            ref={backButtonRef}
                                            className="secondary-save-btn" 
                                            id='back_btn'
                                            variant="outlined"
                                            onKeyDown={e => {
                                                if (e.key === 'Tab' && !e.shiftKey) {
                                                e.preventDefault();
                                                if (saveButtonRef.current) saveButtonRef.current.focus();
                                                }
                                            }}
                                            onClick={() => handleBack(section.sequence, section.sectionId)}
                                            >
                                                Back 
                                            </Button>
                                            <Button sx={{
                                                background: '#185ABD',
                                                my: mobileView ?? 5,
                                                marginLeft: !mobileView ?? '110%',
                                                // marginLeft: '100%',
                                                '&:hover': {
                                                    background: '#185ABD',
                                                },
                                                textTransform: 'none'
                                            }} 
                                            ref={saveButtonRef}
                                            className="primary-save-btn"
                                            id='save_btn' 
                                            variant="contained" 
                                            onClick={() => ((loggedInUser !== 'admin' || (loggedInUser === 'admin' && sessionStorage.getItem('actionType') === 'Edit')) ? 
                                                handleContinue(mobileView ? 1 : 0, section.isMultipleFields, section.fieldsList, section.sequence, section.sectionId):
                                                handleNextAdmin(mobileView ? 1 : 0, section.isMultipleFields, section.fieldsList, section.sequence, section.sectionId)
                                            )}>
                                                {(loggedInUser === 'admin' && sessionStorage.getItem('actionType') !== 'Edit') ? 'Proceed' : 'Save & Continue'}
                                            </Button>
                                        </Box>
                                    </Grid>)}

                                    {/* To display alert popup on success */}
                                    {isModalOpen && 
                                        <ModalComponent 
                                        open={isModalOpen} 
                                        onClose={() => setIsModalOpen(false)} 
                                        title={titleMsg} 
                                        content={content} 
                                        contentIdentity={modalContentIdentity} 
                                        modalResponse={() => {
                                            setModalResponse(true);
                                            if (modalResponseCallback) {
                                              modalResponseCallback();
                                            }
                                          }}
                                        />
                                    }
                                    
                                </Grid>
                            ):

                            // Address section for mobile view & subject

                            <Grid container component="main">
                                {(mobileView && section.parentSectionId !== 0 && section.parentSectionId === id && section.parentSectionId === 3 && section.isActive === 1 && (
                                    <Grid item xs={10}>
                                            <Typography 
                                                sx={{textAlign: 'left', mt:2,
                                                    color: '#000',
                                                    // fontFamily: "Open Sauce Sans",
                                                    fontSize: '15px',
                                                    fontStyle: 'normal',
                                                    fontWeight: 600,
                                                    lineHeight: '167%', 
                                                }}>{section.sectionName}
                                                &nbsp;&nbsp;
                                                <div style={{ display: section.sequence === 2 ? 'inline-flex' : 'none', alignItems: 'center' }}>
                                                    <input ref={checkboxRef} id='check' type='checkbox' onChange={copyAddress}/>
                                                    <Typography sx={{ fontSize: '13px' }}>Same as Correspondence address</Typography>
                                                </div>
                                            </Typography>
                                            <section style={{textAlign: 'left'}}>
                                                {section.isMultipleFields === 0 && section.fieldsList
                                                .sort((a, b) => a.sequence - b.sequence)
                                                .map((field, index) => (
                                                    <>
                                                        <FormControl sx={{ width: mobileView ? '100%' : '50%', textAlign: 'left',
                                                                ...(field.visibleToStudent === '2' || fieldVisibility[field.fieldName] === false || field.fieldType === "HiddenField" ? { display: 'none' }: {}),
                                                                }}
                                                            >
                                                                <Box sx={{
                                                                    direction: mobileView ? 'column' : 'column',
                                                                    width: mobileView ? '100%' : '80%',
                                                                    alignItems: 'left',
                                                                    justifyContent: 'flex-start'
                                                                }}>
                                                                    <Box sx={{ display: mobileView ? 'block' : 'flex', alignItems: 'center', 
                                                                    // ...(field.visibleToStudent === '2' ? { display: 'none' }: {}) 
                                                                    }}>
                                                                        {field.fieldName !== 'CheckBox' &&
                                                                        <InputLabel
                                                                            className="formLabel"
                                                                            shrink={false}
                                                                            // sx={{ ...(field.visibleToStudent === '2' ? { display: 'none' } : {}) }}
                                                                            // sx={{ position: 'relative', textAlign: 'left' }}
                                                                        >
                                                                            {field.fieldName}
                                                                            {(field.fieldType === 'RadioButton' || field.fieldType === 'Photo' || field.fieldType === 'File') &&
                                                                                <span style={{ color: 'red' }}>*</span>
                                                                            }
                                                                        </InputLabel>
                                                                        }
                                                                        {field.helpText !== null && field.helpText !== '' && field.fieldType !== 'RadioButton' && (
                                                                            <Popup
                                                                                trigger={
                                                                                    <InfoOutlinedIcon
                                                                                        sx={{
                                                                                            marginBottom: mobileView ? '0%' : '-6%',
                                                                                            marginLeft: mobileView ? '109px' : '15px',
                                                                                            marginTop: mobileView ? '-2%' : '0%',
                                                                                            position: mobileView ? 'absolute' : 'relative',
                                                                                            color: '#484848',
                                                                                            width: '4%'
                                                                                        }}
                                                                                    />
                                                                                }
                                                                                    on="hover" // Set the on prop to 'hover'
                                                                                    position="right center"
                                                                                >
                                                                                <Box>{field.helpText}</Box>
                                                                            </Popup>
                                                                        )}
                                                                    </Box>
                                                                    <Input
                                                                        type={field.fieldType}
                                                                        defaultValue={inputValue.current[field.fieldName] || '' ||field.value}
                                                                        onBlur={(value) => handleInputChange( 
                                                                            value, 
                                                                            field.validationType, 
                                                                            field.fieldName,
                                                                            {...field}, 
                                                                            section.isMultipleFields
                                                                        )}
                                                                        onChange={(value) => handleChange(value, field.fieldName, {...field}, {...section})}
                                                                        {...field}
                                                                    />
                                                                    
                                                                    
                                                                </Box>
                                                                
                                                        </FormControl>
                                                    </>
                                                ))}
                                            </section>
                                        </Grid> 
                                    ))
                                }

                                {/* Subject Section */}
                                {!mobileView && section.parentSectionId !== 0 && section.parentSectionId === id && section.parentSectionId === 11 && section.isActive === 1 ?(
                                    <Grid container component='main'>
                                        <Grid item xs={10}>
                                            <Typography 
                                                sx={{
                                                    textAlign: 'left',
                                                    mt: 3,
                                                    color: '#000',
                                                    // fontFamily: "Open Sauce Sans",
                                                    fontSize: '17px',
                                                    fontStyle: 'normal',
                                                    fontWeight: 600,
                                                    lineHeight: '167%',
                                                    textDecoration: 'underline'
                                                    // marginTop: mobileView ? '0%' : '-93%',
                                                }}>
                                                {section.sectionName}
                                            </Typography>
                                            <section key={section.sectionId} style={{textAlign: 'left'}}>
                                                {/* compulsory subject */}
                                                {section.isMultipleFields === 0 && section.sequence === 1  && section.fieldsList 
                                                    .sort((a, b) => a.sequence - b.sequence)
                                                    .map((field, index) => (
                                                        <FormControl sx={{ width: mobileView ? '100%' : '50%', textAlign: 'left',
                                                            ...(field.visibleToStudent === '2' || field.fieldType === "HiddenField" || fieldVisibility[field.fieldName] === false ? { display: 'none' }: {}),
                                                            }}
                                                        >
                                                            <Box sx={{
                                                                direction: mobileView ? 'column' : 'row',
                                                                width: mobileView ? '100%' : '80%',
                                                                alignItems: 'left',
                                                                justifyContent: 'flex-start'
                                                            }}>
                                                                <Input
                                                                    type={field.fieldType}
                                                                    // defaultValue={inputValue[field.fieldName] || '' ||field.value}
                                                                    {...field}
                                                                />
                                                                
                                                            </Box>
                                                            
                                                        </FormControl>
                                                ))}

                                                {/* optional subject */}
                                                {section.isMultipleFields === 0 && section.sequence === 2  && section.fieldsList
                                                    .sort((a, b) => a.sequence - b.sequence)
                                                    .filter(field => {
                                                        if (field.fieldRefType !== 'SubjectId') return true;
                                                        if (!allowedOptionalSubjectIds || allowedOptionalSubjectIds.length === 0) return true;
                                                        const prefix = String(field.fieldName).split(' - ')[0].trim();
                                                        return allowedOptionalSubjectIds.includes(prefix);
                                                    })
                                                    .map((field, index) => (
                                                    (field.fieldRefType === 'SubjectId' ?
                                                        <FormControl sx={{ width: mobileView ? '100%' : '50%', textAlign: 'left',
                                                            ...(field.visibleToStudent === '2' || field.fieldType === "HiddenField" || fieldVisibility[field.fieldName] === false ? { display: 'none' }: {}),
                                                            }}
                                                        >
                                                            <Box sx={{
                                                                direction: mobileView ? 'column' : 'row',
                                                                width: mobileView ? '100%' : '80%',
                                                                alignItems: 'left',
                                                                justifyContent: 'flex-start'
                                                            }}>
                                                                <Input
                                                                    type={field.fieldType}
                                                                    defaultValue={inputValue.current[field.fieldName] || '' ||field.value}
                                                                    onBlur={(value) => handleInputChange(
                                                                        value,
                                                                        field.validationType,
                                                                        field.fieldName,
                                                                        {...field},
                                                                        section.isMultipleFields
                                                                    )}
                                                                    {...field}
                                                                />
                                                                
                                                            </Box>
                                                            
                                                        </FormControl>
                                                    :
                                                    <Box>
                                                        <Box 
                                                            sx={{
                                                                color: '#000',
                                                                // fontFamily: "Open Sauce Sans",
                                                                fontSize: '16px',
                                                                fontStyle: 'normal',
                                                                fontWeight: 600,
                                                                lineHeight: '167%',
                                                                mt: 3
                                                            }}  
                                                        >
                                                            {field.fieldName}
                                                            {field.helpText !== null && field.helpText !== '' &&
                                                                <span
                                                                    style={{
                                                                        color: '#000',
                                                                        // fontFamily: "Open Sauce Sans",
                                                                        fontSize: '16px',
                                                                        fontWeight: 500,
                                                                        fontStyle: 'italic',
                                                                        lineHeight: '167%'
                                                                    }}  
                                                                >&nbsp;&nbsp;({field?.helpText})</span>
                                                            }
                                                        </Box>
                                                        <FormControl sx={{ width: mobileView ? '100%' : '61%', textAlign: 'left', display: 'flex',
                                                            ...(field.visibleToStudent === '2' || field.fieldType === "HiddenField" || fieldVisibility[field.fieldName] === false ? { display: 'none' }: {}),
                                                            }}
                                                        >
                                                            <Box sx={{
                                                                direction: mobileView ? 'column' : 'row',
                                                                width: mobileView ? '100%' : '80%',
                                                                alignItems: 'left',
                                                                // display: 'inline-flex',
                                                                justifyContent: 'flex-start',
                                                                // gap: 30
                                                            }}>
                                                                <Input
                                                                    type={field.fieldType}
                                                                    defaultValue={inputValue.current[field.fieldName] || '' ||field.value}
                                                                    onBlur={(value) => handleInputChange( 
                                                                        value, 
                                                                        field.validationType, 
                                                                        field.fieldName,
                                                                        {...field}, 
                                                                        section.isMultipleFields
                                                                    )}
                                                                    {...field}
                                                                />
                                                                
                                                            </Box>
                                                            {Object.entries(textError)?.length > 0 &&
                                                                Object.entries(textError).map(([name, { isError, errorMessage }]) => (
                                                                    isError === true &&
                                                                    field?.fieldName === name && (
                                                                        <Typography className="error-message" key={name}>
                                                                            {errorMessage}
                                                                        </Typography>
                                                                    )
                                                                ))
                                                            }
                                                            
                                                        </FormControl>
                                                        
                                                    </Box>
                                                    )
                                                        
                                                ))}
                                                
                                            </section>
                                        </Grid>
                                        {section?.sequence === maxSubjectSequence &&
                                            <Grid item xs={9}>
                                                <Box sx={{
                                                    my: mobileView ? 7 : 10,
                                                    textAlign: 'left',
                                                    marginBottom: '10%',
                                                    display: mobileView ? 'block' : (section?.sectionId !== 3 ? 'flex' : (section?.sectionId === 3 && section?.fieldsList?.length > 0 ? 'flex' : 'none')),
                                                    // display: mobileView ? 'block' : section.sectionId !== 3 ? 'flex' : section.sectionId === 3 && section.fieldsList.length <= 0 ? 'flex' : 'none',
                                                    justifyContent: mobileView ? 'center' : 'space-between',
                                                    // alignItems: !mobileView ?? 'flex-start'
                                                }}>
                                                    <Button sx={{
                                                        border: '1px solid #185ABD',
                                                        color: '#185ABD',
                                                        background: '#FFF',
                                                        '&:hover': {
                                                            border: '1px solid #185ABD',
                                                        },
                                                        textTransform: 'none'
                                                    }} 
                                                     ref={backButtonRef}
                                                    className="secondary-save-btn" 
                                                    id='back_btn'
                                                    variant="outlined"
                                                    onKeyDown={e => {
                                                        if (e.key === 'Tab' && !e.shiftKey) {
                                                        e.preventDefault();
                                                        if (saveButtonRef.current) saveButtonRef.current.focus();
                                                        }
                                                    }}
                                                    onClick={() => handleBack(section.sequence, section.parentSectionId)}
                                                    >
                                                        Back 
                                                    </Button>
                                                    <Button sx={{
                                                        background: '#185ABD',
                                                        my: mobileView ?? 5,
                                                        marginLeft: !mobileView ?? '110%',
                                                        // marginLeft: '100%',
                                                        '&:hover': {
                                                            background: '#185ABD',
                                                        },
                                                        textTransform: 'none'
                                                    }} 
                                                    ref={saveButtonRef}
                                                    className="primary-save-btn"
                                                    id='save_btn' 
                                                    variant="contained" 
                                                    onClick={() => ((loggedInUser !== 'admin' || (loggedInUser === 'admin' && sessionStorage.getItem('actionType') === 'Edit')) ? 
                                                        handleContinue(mobileView ? 1 : 0, section.isMultipleFields, section.fieldsList, section.sequence, section.parentSectionId):
                                                        handleNextAdmin(mobileView ? 1 : 0, section.isMultipleFields, section.fieldsList, section.sequence, section.parentSectionId)
                                                    )}>
                                                        {(loggedInUser === 'admin' && sessionStorage.getItem('actionType') !== 'Edit' )? 'Proceed' : 'Save & Continue'}
                                                    </Button>
                                                </Box>
                                            </Grid>
                                        }
                                    </Grid>
                                ): mobileView && section.parentSectionId !== 0 && section.parentSectionId === id && section.parentSectionId === 11 && section.isActive === 1 &&(
                                    <Grid container component='main'>
                                        <Grid item xs={10}>
                                            <Typography 
                                                sx={{
                                                    textAlign: 'left',
                                                    mt: 3,
                                                    color: '#000',
                                                    // fontFamily: "Open Sauce Sans",
                                                    fontSize: '15px',
                                                    fontStyle: 'normal',
                                                    fontWeight: 600,
                                                    lineHeight: '167%',
                                                    textDecoration: 'underline'
                                                    // marginTop: mobileView ? '0%' : '-93%',
                                                }}>
                                                {section.sectionName}
                                            </Typography>
                                            <section key={section.sectionId} style={{textAlign: 'left'}}>
                                                {section.isMultipleFields === 0 && section.sequence === 1  && section.fieldsList 
                                                    // .filter(field => section.isMultipleFields === 1)
                                                    .sort((a, b) => a.sequence - b.sequence)
                                                    .map((field, index) => (
                                                        <FormControl sx={{ width: mobileView ? '105%' : '50%', textAlign: 'left',
                                                            ...(field.visibleToStudent === '2' || field.fieldType === "HiddenField" || fieldVisibility[field.fieldName] === false ? { display: 'none' }: {}),
                                                            }}
                                                        >
                                                            <Box sx={{
                                                                direction: mobileView ? 'column' : 'row',
                                                                width: mobileView ? '100%' : '80%',
                                                                alignItems: 'left',
                                                                justifyContent: 'flex-start'
                                                            }}>
                                                                <Input
                                                                    type={field.fieldType}
                                                                    // defaultValue={inputValue[field.fieldName] || '' ||field.value}
                                                                    {...field}
                                                                />
                                                                
                                                            </Box>
                                                            
                                                        </FormControl>
                                                ))}

                                                {section.isMultipleFields === 0 && section.sequence === 2  && section.fieldsList
                                                    // .filter(field => section.isMultipleFields === 1)
                                                    .sort((a, b) => a.sequence - b.sequence)
                                                    .filter(field => {
                                                        if (field.fieldRefType !== 'SubjectId') return true;
                                                        if (!allowedOptionalSubjectIds || allowedOptionalSubjectIds.length === 0) return true;
                                                        const prefix = String(field.fieldName).split(' - ')[0].trim();
                                                        return allowedOptionalSubjectIds.includes(prefix);
                                                    })
                                                    .map((field, index) => (
                                                    <FormControl sx={{ width: mobileView ? '100%' : '50%', textAlign: 'left',
                                                        ...(field.visibleToStudent === '2' || field.fieldType === "HiddenField" || fieldVisibility[field.fieldName] === false ? { display: 'none' }: {}),
                                                        }}
                                                    >
                                                        <Box sx={{
                                                            direction: mobileView ? 'column' : 'row',
                                                            width: mobileView ? '50%' : '80%',
                                                            alignItems: 'left',
                                                            justifyContent: 'flex-start'
                                                        }}>
                                                            <Box sx={{ display: mobileView ? 'block' : 'flex', alignItems: 'center',  width: '185%', mt: 1
                                                            // ...(field.visibleToStudent === '2' ? { display: 'none' }: {}) 
                                                            }}>
                                                                {field.fieldType !== 'RadioButton' && field.fieldName !== 'CheckBox' && field.sectionId !== 14 &&
                                                                <InputLabel
                                                                    className="formLabel"
                                                                    shrink={false}
                                                                    sx={{display: 'inline'}}
                                                                    // sx={{ ...(field.visibleToStudent === '2' ? { display: 'none' } : {}) }}
                                                                    // sx={{ position: 'relative', textAlign: 'left' }}
                                                                >
                                                                    {field.fieldName}
                                                                    {(field.fieldType === 'RadioButton') &&
                                                                        <span style={{ color: 'red' }}>*</span>
                                                                    }
                                                                </InputLabel>
                                                                }
                                                                {field.helpText !== null && field.helpText !== '' && field.fieldType !== 'RadioButton'&& field.sectionId !== 14 && (
                                                                    <span
                                                                        style={{
                                                                            color: '#000',
                                                                            // fontFamily: "Open Sauce Sans",
                                                                            fontSize: '14px',
                                                                            fontWeight: 500,
                                                                            fontStyle: 'italic',
                                                                            lineHeight: '167%'
                                                                        }}  
                                                                    >&nbsp;&nbsp;({field?.helpText})</span>
                                                                    
                                                                )}
                                                                {field.sectionId === 14 && (
                                                                    <Box sx={{fontStyle: 'italic', width:'100%'}}>({field.helpText})</Box>
                                                                )}
                                                            </Box>
                                                            <Input
                                                                type={field.fieldType}
                                                                name={field.fieldName}
                                                                defaultValue={inputValue.current[field.fieldName]  || '' || field.value}
                                                                onBlur={(value) => handleInputChange( 
                                                                    value, 
                                                                    field.validationType, 
                                                                    field.fieldName,
                                                                    {...field}, 
                                                                    section.isMultipleFields
                                                                )}
                                                                onChange={(value) => handleChange(value, field.fieldName, {...field}, {...section})}
                                                                {...field}
                                                            />
                                                        </Box>
                                                    </FormControl>
                                                ))}
                                            </section>
                                        </Grid>
                                        {section?.sequence === maxSubjectSequence &&
                                            <Grid item xs={9}>
                                                <Box sx={{
                                                    my: mobileView ? 7 : 10,
                                                    textAlign: 'left',
                                                    marginBottom: '10%',
                                                    display: mobileView ? 'block' : (section?.sectionId !== 3 ? 'flex' : (section?.sectionId === 3 && section?.fieldsList?.length > 0 ? 'flex' : 'none')),
                                                    // display: mobileView ? 'block' : section.sectionId !== 3 ? 'flex' : section.sectionId === 3 && section.fieldsList.length <= 0 ? 'flex' : 'none',
                                                    justifyContent: mobileView ? 'center' : 'space-between',
                                                    // alignItems: !mobileView ?? 'flex-start'
                                                }}>
                                                    <Button sx={{
                                                        border: '1px solid #185ABD',
                                                        color: '#185ABD',
                                                        background: '#FFF',
                                                        '&:hover': {
                                                            border: '1px solid #185ABD',
                                                        },
                                                        textTransform: 'none'
                                                    }} 
                                                     ref={backButtonRef}
                                                    className="secondary-save-btn" 
                                                    id='back_btn'
                                                    variant="outlined"
                                                    onKeyDown={e => {
                                                        if (e.key === 'Tab' && !e.shiftKey) {
                                                        e.preventDefault();
                                                        if (saveButtonRef.current) saveButtonRef.current.focus();
                                                        }
                                                    }}
                                                    onClick={() => handleBack(section.sequence, section.parentSectionId)}
                                                    >
                                                        Back 
                                                    </Button>
                                                    <Button sx={{
                                                        background: '#185ABD',
                                                        my: mobileView ?? 5,
                                                        marginLeft: !mobileView ?? '110%',
                                                        // marginLeft: '100%',
                                                        '&:hover': {
                                                            background: '#185ABD',
                                                        },
                                                        textTransform: 'none'
                                                    }} 
                                                    ref={saveButtonRef}
                                                    className="primary-save-btn"
                                                    id='save_btn' 
                                                    variant="contained" 
                                                    onClick={() => ((loggedInUser !== 'admin' || (loggedInUser === 'admin' && sessionStorage.getItem('actionType') === 'Edit')) ? 
                                                        handleContinue(mobileView ? 1 : 0, section.isMultipleFields, section.fieldsList, section.sequence, section.parentSectionId):
                                                        handleNextAdmin(mobileView ? 1 : 0, section.isMultipleFields, section.fieldsList, section.sequence, section.parentSectionId)
                                                    )}>
                                                        {(loggedInUser === 'admin' && sessionStorage.getItem('actionType') !== 'Edit' )? 'Proceed' : 'Save & Continue'}
                                                    </Button>
                                                </Box>
                                            </Grid>
                                        }
                                    </Grid>
                                ) }
                            </Grid>
                        )):null
                        }
                    </React.Fragment>

                    {/* Address section for desktop */}
                    <React.Fragment>
                        {data !== null && loading === false && data?.sections?.length > 0 ? (
                            <Grid container spacing={2} mt={2}>
                            <Grid item xs={5}>
                                {data?.sections
                                .filter((section) => section?.parentSectionId === id && section?.parentSectionId === 3 && section?.isActive === 1 && section?.sequence === 1 && !mobileView)
                                .map((section, index) => (
                                    <SectionGrid section={section} index={index} key={section.sectionId} />
                                ))}
                            </Grid>
                            <Grid item xs={5}>
                                {data?.sections
                                .filter((section) => section?.parentSectionId === id && section?.parentSectionId === 3 && section?.isActive === 1 && section?.sequence === 2 && !mobileView)
                                .map((section, index) => (
                                    <SectionGrid section={section} index={index} key={section.sectionId} />
                                ))}
                            </Grid>
                            <Grid item xs={9}>
                                {data?.sections
                                .filter((section) => section?.parentSectionId === id && section?.parentSectionId === 3 && section?.isActive === 1 && section?.sequence === 1 )
                                .map((section, index) => (
                                <Box sx={{
                                    my: mobileView ? 7 : 10,
                                    textAlign: 'left',
                                    marginBottom: '10%',
                                    display: mobileView ? 'block' :'flex',
                                    justifyContent: mobileView ? 'center' : 'space-between',
                                    // alignItems: !mobileView ?? 'flex-start'
                                }}>
                                    <Button sx={{
                                        border: '1px solid #185ABD',
                                        color: '#185ABD',
                                        background: '#FFF',
                                        '&:hover': {
                                            border: '1px solid #185ABD',
                                        },
                                        textTransform: 'none'
                                    }} 
                                     ref={backButtonRef}
                                    className="secondary-save-btn" 
                                    id='back_btn'
                                    variant="outlined"
                                    onKeyDown={e => {
                                        if (e.key === 'Tab' && !e.shiftKey) {
                                        e.preventDefault();
                                        if (saveButtonRef.current) saveButtonRef.current.focus();
                                        }
                                    }}
                                    onClick={() => handleBack(3, section.parentSectionId)}
                                    >
                                        Back
                                    </Button>
                                    <Button sx={{
                                        background: '#185ABD',
                                        my: mobileView ?? 5,
                                        marginLeft: !mobileView ?? '110%',
                                        // marginLeft: '100%',
                                        '&:hover': {
                                            background: '#185ABD',
                                        },
                                        textTransform: 'none'
                                    }} 
                                    ref={saveButtonRef}
                                    className="primary-save-btn"
                                    id='save_btn' 
                                    variant="contained" 
                                    onClick={() => ((loggedInUser !== 'admin' || (loggedInUser === 'admin' && sessionStorage.getItem('actionType') === 'Edit')) ? 
                                        handleContinue(mobileView ? 1 : 0, section.isMultipleFields, section.fieldsList, 3, section.parentSectionId):
                                        handleNextAdmin(mobileView ? 1 : 0, section.isMultipleFields, section.fieldsList, 3, section.parentSectionId)
                                    )}>
                                        {(loggedInUser === 'admin' && sessionStorage.getItem('actionType') !== 'Edit') ? 'Proceed' : 'Save & Continue'}
                                    </Button>
                                </Box>
                                ))}
                                {/* To display snackbar on education field validation */}
                                    {mandatoryMsg !== null &&
                                        <Snackbar
                                            className="manadatory-education-snackbar"
                                            open={SnackbarOpen}
                                            autoHideDuration={3000}
                                            anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                                            onClose={() => {
                                                handleSnackbarClose();
                                                setSuccessMessage(null); // reset successMessage to null
                                            }}
                                            message={mandatoryMsg}
                                            key={'bottom left'}
                                            ContentProps={{
                                                sx: {
                                                    backgroundColor: '#185abdbf', // Light yellow background
                                                    // color: '#856404',           // Dark yellow text
                                                    // fontWeight: 600,
                                                    fontSize: '16px',
                                                    border: '1px solid #185abdbf',
                                                    borderRadius: '6px',
                                                    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                                                    marginBottom: '10%',
                                                    marginLeft: '-8%',
                                                }
                                            }}
                                        />
                                    }
                            </Grid>
                            </Grid>
                        ) : null}
                    </React.Fragment>
                    
                </Box>
            </Box>
            )}
        </ScreenView>
        {/* )} */}
        </>

    );
}